import React, { useCallback, useMemo, useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Grid,
  Snackbar,
  TextField,
  IconButton
} from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

// import { PieChart } from '@mui/x-charts/PieChart';
import CircularProgress from "@mui/material/CircularProgress";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { DataGrid } from "@mui/x-data-grid";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Paper from "@mui/material/Paper";
import ReactSelect from "react-select";
import { useAlert } from "react-alert";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Tooltip from "@mui/material/Tooltip";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

// import { PieChart } from '@mui/x-charts/PieChart';
// const openHome = (event, id) => {
//   navigate("/Home", { state: { patientId: id } });
// };
import Modal from "@mui/material/Modal";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import Card from "@mui/material/Card";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Checkbox from "@mui/material/Checkbox";
import Headroom from "react-headroom";
import AuthorizationRegistration from "../AuthorizationRegistration";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import VOBPAGE from "../DashForms/Vobpage";
// import VOBPAGE1 from "../DashForms/Vobpage1";
import OSAPAGE from "../DashForms/Osapage";
import Letter from "../DashForms/Letter";
import Disclaimer from "../DashForms/Disclaimer";
import Prior_auth from "../Prior_auth";
import PrintIcon from "@mui/icons-material/Print";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Avatar from "@mui/material/Avatar";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import VOBPAGE1 from "../Vobpage1";
import ClaimRegistration from "../ClaimRegistration";
import PatientRegistration from "../PatientRegistration";
import { useSelector } from "react-redux";

function Dashboard(props) {
  document.title = "Dashboard | LuxBilling";
  // const auth = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJqdGkiOiIwZmRiNWIxMy0wYzExLTQ4ZTQtOTdmMy1hZjhlOGNmOTJlMjgiLCJ2YWxpZCI6IjEiLCJ1c2VyRW1haWwiOiJhbGlAZ21haWwuY29tIiwicHJhY3RpY2VJZCI6IjEiLCJleHBpcnlEYXRlIjoiNy8zLzIwMjgiLCJicm93c2VyIjoiR29vZ2xlIENocm9tZSIsImFwcGxpY2F0aW9uIjoiTHV4QmlsbGluZyIsIklzQWRtaW4iOiJGYWxzZSIsIlByb3ZpZGVySWQiOiIwIiwiZXhwIjoxODQ2MDgwNTE2LCJpc3MiOiJodHRwOi8vd3d3Lkx1eEJpbGxpbmcuY29tIiwiYXVkIjoiaHR0cDovL3d3dy5MdXhCaWxsaW5nLmNvbSJ9.2Uac6a-c-IPRJFzYSvjxpRych9icwhsebjvB2lgZaOs`;
  // const auth = localStorage.getItem("Token");
  const token = localStorage.getItem("Token");
  const userType = localStorage.getItem("User_Type");
  const rights = useSelector((state) => state.login.rights);

  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };
  const navigate = useNavigate();
  // const navigateToPage =()=>{
  //   navigate ('/Home')
  //   console.log(" Navigate to homes")
  // }
  const [approvedNotification, setApprovedNotification] = useState(null);
  const [claimNotification, setclaimNotification] = useState(null);
  const [claimNotification1, setclaimNotification1] = useState(null);
  const [newClaimNotidcation, setnewClaimNotidcation] = useState(null);
  const [PendingClaimNotidcation, setPendingClaimNotidcation] = useState(null);
  const [claimNotificationpayment, setclaimNotificationpayment] =useState(null);
  const [PartiallyPaidClaims,setPartiallyPaidClaims] =useState(null);
  const [PartiallyPaidClaimsCount,setPartiallyPaidClaimsCount] =useState(null);
  const [ClosedClaimCount,setClosedClaimCount] =useState(null);
  const [authId, setauthId] = useState();
  const [claimId, setclaimId] = useState();

  const [patinetIdopenauth, setpatinetIdopenauth] = useState();
  const [patinetIdopenclaim, setpatinetIdopenclaim] = useState();

  const [patinetIdopenauth1, setpatinetIdopenauth1] = useState();
  const [patinetnameopenauth1, setpatinetnameopenauth1] = useState();
  const [patinetnameopenauth, setpatinetnameopenauth] = useState();
  const [patinetnameopenclaim, setpatinetnameopencalim] = useState();

  const [authId2, setauthId2] = useState(0);
  const [authIdcpt, setauthIdcpt] = useState();

  const [isLoading, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [rows1, setRows1] = useState(null);

  const [raws, setRaws] = useState(null);
  const [raws1, setRaws1] = useState(null);
  const [raws2, setRaws2] = useState(null);
  const [raws3, setRaws3] = useState(null);
  const [raws4, setRaws4] = useState(null);
  const [isChecked, setIsChecked] = useState(true);
  const [raws5, setRaws5] = useState([]);
  const [raws9, setRaws9] = useState([]);
  const [raws10, setRaws10] = useState([]);
  const [compeleterows, setcompeleterows] = useState([]);
  const [panddingrows, setpanddingrows] = useState([]);
  const [paymentrows, setpaymentrows] = useState([]);

  const [fromDate, setfromDate] = React.useState("");
  const [toDate, settoDate] = useState("");
  const [Dashboardinfo, setDashboardinfo] = useState([]);
  const [show, setshow] = useState("");
  const [data, setData] = useState([]);
  const [letterOfMedicalNecessity, setLetterOfMedicalNecessity] = useState([]);
  const [letterOfMedicalNecessity1, setLetterOfMedicalNecessity1] =
    useState("");
  const [UNapprovedRecord, setUnapproved] = useState(0);
  const [CompletedForms, setCompletedForms] = useState(0);
  const [approvedRecord, setApprovedRecord] = useState(0);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [progressNotes, setProgressNotes] = useState([]);
  const [authRequest, setAuthRequest] = useState([]);
  const [authRequest1, setAuthRequest1] = useState("");
  const [newrequests, setnewrequests] = useState(null);
  const [Pendingrequests, setPendingrequests] = useState(null);
  const [processRequest, setprocessRequest] = useState(null);
  const [approved, setApproved] = useState([]);
  const [approved1, setApproved1] = useState("");
  const [archivedApprovedCount, setArchivedApprovedCount] = useState(0);
const [archivedApprovedNotification, setArchivedApprovedNotification] = useState([]);
const [archivedRows, setArchivedRows] = useState([]);

  const [UnapprovedButton, setUnapprovedButton] = useState("");

  const [patientInfo, setPatientInfo] = useState([]);
  const [totalRecords, setTotalRecords] = useState([]);
  const [totalRecords1, setTotalRecords1] = useState([]);

  const [selectedLabel, setSelectedLabel] = useState(null);
  console.log("Slected_Lable", selectedLabel);
  const [selectedLabel1, setSelectedLabel1] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);

  const [modalData, setModalData] = useState(null);
  const [columnID, setColumnID] = React.useState("");
  const [columnIDsubluxbilling, setColumnIDsubluxbilling] = React.useState("");
  const [patientNamee, setPatientNamee] = React.useState("");
  const [compeletclaims, setcompeletclaims] = useState([]);
  const [penndingclaims, setpenndingclaims] = useState([]);
  const [paidclaims, setpaidclaims] = useState([]);
  const [Newclaims, setNewclaims] = useState([]);
  const [SecondaryPending, setSecondaryPending] = useState([]);
  const [SecondaryPendingReview, setSecondaryPendingReview] = useState([]);
  const [pendingfurther, setpendingfurther] = useState([]);
  const [closeClaims, setcloseClaims] = useState([]);
  const [partiallyPaid, setpartiallyPaid] = useState([]);
  const [paidToPatient, setpaidToPatient] = useState([]);
  const [pendingInsCheck, setpendingInsCheck] = useState([]);
  const [AutpattientID1, setAutpattientID1] = React.useState("");
  const [formDid, setColumnIDs] = React.useState("");

  const [AutpattientID, setAutpattientID] = React.useState("");
  const testpateint = props.PatientName;
  const [patientName, setPatientName] = React.useState(testpateint);
  const [approvelux, setapprovelux] = React.useState(false);
  const [Markaporoved, setMarkaporoved] = React.useState(false);
  const [Markaporovedopenauth, setMarkaporovedopenauth] = React.useState(false);
  useEffect(() => {
    // Set the default value of fromDate to the 1st date of the current month
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const formattedFromDate = formatDate(firstDayOfMonth);
    setfromDate(formattedFromDate);

    // Set the default value of toDate to the current date
    const formattedToDate = formatDate(today);
    settoDate(formattedToDate);
  }, []); // Empty dependency array ensures this effect runs only once on mount

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleapprovelux = () => {
    setapprovelux(true);
  };

  const handlecloseapprovelux = () => {
    setColumnID("");
    setAutpattientID1("");
    setPatientNamee("");
    setapprovelux(false);
  };
  useEffect(() => {
    if (AutpattientID1 > 0) {
      handleapprovelux();
    }
  }, [AutpattientID1]);
  const labelData = [
    // { label: `Total Records (${totalRecords})`, color: '#00e69d' },
    { label: `Submitted to LuxBilling (${authRequest1})`, color: "#ff2c52" },
    { label: `Completed(${approved1})`, color: "#326C1D" },
    { label: `Archived (${archivedApprovedCount})`, color: "#0B6FA4" },
    {
      label: `Letter Of Medical Necessity (${letterOfMedicalNecessity})`,
      color: "#0092fb",
    },
    { label: `Questionnaire (${questionnaire})`, color: "#00e69d" },
    // { label: `Progress Notes (${progressNotes})`, color: '#ffac00' },
    { label: `Patient Info (${patientInfo})`, color: "#0092fb" },
    { label: `Un-Approved (${UNapprovedRecord})`, color: "#6d00fbff" },
    { label: `Completed Forms (${CompletedForms})`, color: "rgb(155, 0, 251)" },
  ];
  const [newRows, setNewRows] = useState([]);
  const [pendingRows, setPendingRows] = useState([]);
  const [pendingFurtherRows, setPendingFurtherRows] = useState([]);
  const [secondaryRows, setSecondaryRows] = useState([]);
  const [completeRows, setCompleteRows] = useState([]);
  const [paidRows, setPaidRows] = useState([]);
  const [closeRows, setCloseRows] = useState([]);
  const [partiallyPaidRows, setpartiallyPaidRows] = useState([]);
  const [paidToPatientRows, setpaidToPatientRows] = useState([]);
  const [pendingInsCheckRows, setpendingInsCheckRows] = useState([]);
  const [secondaryPendingReviewRows, setsecondaryPendingReviewRows] = useState([]);
  const labelData1 = [
    // { label: `Total Records (${totalRecords})`, color: '#00e69d' },
    { label: `New (${Newclaims})`, color: "red" },
    { label: `Pending Claims (${penndingclaims})`, color: "orange" },
    { label: `Pending Further Review (${pendingfurther})`, color: "purple" },
    { label: `Secondary Pending (${SecondaryPending})`, color: "brown" },
    { label: `Secondary Pending Further Review (${SecondaryPendingReview})`, color: "Blueviolet" },
    { label: `Completed Claims (${compeletclaims})`, color: "green" },
    { label: `Paid Claims (${paidclaims})`, color: "#0092fb" },
    { label: `Close Claims (${closeClaims})`, color: "black" },
    { label: `Partially Paid (${partiallyPaid})`, color: "skyblue" },
    { label: `Paid To Patient (${paidToPatient})`, color: "lightgreen" },
    { label: `Pending Insurance Check (${pendingInsCheck})`, color: "deepPink" },
  ];

  const combinedData = [
    ...letterOfMedicalNecessity,
    ...questionnaire,
    ...progressNotes,
    ...authRequest,
    ...approved,
    ...patientInfo,
    ...totalRecords,
  ];
  const checkstyleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    // overflow: "auto",
    overflows: "hide",
    // zIndex: "10",
  };
  const [opens, setOpens] = React.useState(false);
  const handleCloseVOB = () => {
    setOpens(false);
  };

  const handleOpens = () => {
    setOpens(true);
  };

  const calumns = [
    {
      field: "authId",
      headerName: "Auth ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      renderCell: (cellValues) => (
        <Button
          style={{ float: "left", marginLeft: "-15px" }}
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            setColumnID(cellValues.row.authId);
            setAutpattientID(cellValues.row.patientId);
            const fullName =
              cellValues.row.lastName + ", " + cellValues.row.firstName;
            setPatientName(fullName);
            setOpenModal(true);
          }}
        >{`${cellValues.row.authId}`}</Button>
      ),
    },

    {
      field: "firstName",
      headerName: "First Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 3,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 3,
    },
    {
      field: "dOB",
      headerName: "DOB",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
    {
      field: "gender",
      headerName: "Gender",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
    },
    {
      field: "practiceName",
      headerName: "Practice Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2.7,
    },
    {
      field: "city",
      headerName: "City",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
    {
      field: "state",
      headerName: "State",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
    {
      field: "address",
      headerName: "Address",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
  ];

  const calumns1 = [
    {
      field: "authId",
      headerName: "Auth ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      renderCell: (cellValues) => (
        <Button
          style={{ float: "left", marginLeft: "-15px" }}
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            setauthId(cellValues.row.authId);
            setAutpattientID(cellValues.row.patientId);
            const setPatientNamee =
              cellValues.row.lastName + ", " + cellValues.row.firstName;
            setPatientName(setPatientNamee);
            setOpenModal(true);
          }}
        >{`${cellValues.row.authId}`}</Button>
      ),
    },
    {
      field: "firstName",
      headerName: "First Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 3,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 3,
    },
    {
      field: "dOB",
      headerName: "DOB",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
    {
      field: "gender",
      headerName: "Gender",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
    },
    {
      field: "city",
      headerName: "City",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
    {
      field: "state",
      headerName: "State",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },

    {
      field: "address",
      headerName: "Address",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
  ];
  const calumns2 = [
    {
      field: "AuthId",
      headerName: "Auth ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      // renderCell: (cellValues) => (
      //   <Button
      //     style={{ float: "left", marginLeft: "-15px" }}
      //     size="small"
      //     variant="text"
      //     color="info"
      //     onClick={(event) => {
      //       setColumnID(cellValues.row.AuthId);
      //       setAutpattientID(cellValues.row.PatientId);
      //       // const setPatientNamee = cellValues.row.lastName + ", " + cellValues.row.firstName;
      //       setPatientName(`${cellValues.row.PatientName}`);
      //       // setOpenModal(true)
      //       setapprovedasbord(true);
      //     }}
      //   >{`${cellValues.row.AuthId}`}</Button>
      // ),
    },
    {
      field: "PatientName",
      headerName: "Patient Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 2,
    },
    // {
    //   field: 'lastName',
    //   headerName: 'Last Name',
    //   headerClassName: 'super-app-theme--header',
    //   cellClassName: 'gridCell',
    //   sortable: false,
    //   flex: 2,
    // },
    {
      field: "DOB",
      headerName: "DOB",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
      },
    },
    {
      field: "Gender",
      headerName: "Gender",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.6,
    },
    {
      field: "PracticeName",
      headerName: "Practice Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2.7,
    },
    {
      field: "City",
      headerName: "City",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
    },
    {
      field: "State",
      headerName: "State",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
    },

    {
      field: "Address",
      headerName: "Address",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
    },
    {
      field: "ApprovedDate",
      headerName: "Approved Date",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
      },
    },
    {
      field: "DateApproval",
      headerName: "Date Sub",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
      },
    },
  ];
  const calumns3 = [
    {
      field: "authId",
      headerName: "Auth ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      renderCell: (cellValues) => (
        <Button
          style={{ float: "left", marginLeft: "-15px" }}
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            setColumnID(cellValues.row.id);
            setAutpattientID(cellValues.row.patientId);
            const setPatientNamee =
              cellValues.row.lastName + ", " + cellValues.row.firstName;
            setPatientName(setPatientNamee);
            setOpenModal(true);
          }}
        >{`${cellValues.row.authId}`}</Button>
      ),
    },
    {
      field: "firstName",
      headerName: "First Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 3,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 3,
    },
    {
      field: "dOB",
      headerName: "DOB",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
    {
      field: "gender",
      headerName: "Gender",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
    },
    {
      field: "practiceName",
      headerName: "Practice Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2.7,
    },
    {
      field: "city",
      headerName: "City",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
    {
      field: "state",
      headerName: "State",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },

    {
      field: "address",
      headerName: "Address",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
  ];
  const calumns4 = [
    {
      field: "authId",
      headerName: "Auth ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      renderCell: (cellValues) => (
        <Button
          style={{ float: "left", marginLeft: "-15px" }}
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            setColumnID(cellValues.row.authId);
            setAutpattientID(cellValues.row.patientId);
            const setPatientNamee =
              cellValues.row.lastName + ", " + cellValues.row.firstName;
            setPatientName(setPatientNamee);
            setOpenModal(true);
          }}
        >{`${cellValues.row.authId}`}</Button>
      ),
    },
    {
      field: "firstName",
      headerName: "First Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 3,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 3,
    },
    {
      field: "dOB",
      headerName: "DOB",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
    {
      field: "practiceName",
      headerName: "Practice Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2.7,
    },
    {
      field: "gender",
      headerName: "Gender",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
    },
    {
      field: "city",
      headerName: "City",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
    {
      field: "state",
      headerName: "State",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },

    {
      field: "address",
      headerName: "Address",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
    },
  ];
  const calumns5 = [
    {
      field: "authId",
      headerName: "Auth ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      minWidth: 100,
      renderCell: (cellValues) => (
        <Button
          style={{ float: "left", marginLeft: "-15px" }}
          size="small"
          variant="text"
          color="info"
          onClick={(event) => {
            setColumnID(cellValues.row.authId);
            setAutpattientID(cellValues.row.patientId);
            const setPatientNamee = cellValues.row.patientName;
            setPatientName(setPatientNamee);
            setOpenModal(true);
          }}
        >{`${cellValues.row.authId}`}</Button>
      ),
    },
    {
      field: "patientName",
      headerName: "Patient Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 2.3,
      minWidth: 150,
    },

    {
      field: "dob",
      headerName: "DOB",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
      minWidth: 120,
    },
    // {
    //   field: 'status',
    //   headerName: 'Status',
    //   flex: 3,
    //   sortable: false,
    //   minWidth: 150,
    //   headerClassName: 'super-app-theme--header',
    //   renderCell: (params) => {
    //     const StatusColor = params.row.StatusColor;
    //     let label = '';
    //     let backgroundColor = '';

    //     switch (StatusColor) {
    //       case 'orange':
    //         label = 'Pending';
    //         backgroundColor = 'orange'; // Orange
    //         break;
    //       case 'purple':
    //         label = 'In Processing';
    //         backgroundColor = 'purple'; // Purple
    //         break;
    //       case 'Red':
    //         label = 'New';
    //         backgroundColor = 'red'; // Red
    //         break;
    //       default:
    //         label = 'Unknown';
    //         backgroundColor = '#999'; // Gray
    //     }

    //     return (
    //       <div
    //         style={{
    //           backgroundColor,
    //           color: '#fff',
    //           padding: '4px 8px',
    //           borderRadius: '4px',
    //           width: '100%',
    //           textAlign: 'center',
    //         }}
    //       >
    //         {label}
    //       </div>
    //     );
    //   },
    // },

    {
      field: "gender",
      headerName: "Gender",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
      minWidth: 80,
    },
    {
      field: "city",
      headerName: "City",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
      minWidth: 150,
    },
    {
      field: "practiceName",
      headerName: "Practice Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2.9,
      minWidth: 150,
    },
    {
      field: "state",
      headerName: "State",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
      minWidth: 120,
    },

    {
      field: "address",
      headerName: "Address",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
      minWidth: 150,
    },
    {
      field: "dateSubmission",
      headerName: "Date Submission",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 3,
      minWidth: 100,
    },

    //   {
    //     field: "Approve",
    //     headerName: "Approve",
    //     sortable: true,
    //     headerClassName: "super-app-theme--header",
    //     flex: 2,
    //     minWidth: 150,
    //     renderCell: (cell) => {
    //           const StatusColor = (cell.row.statusColor || '').toLowerCase(); // Normalize to lowercase
    //           let Color = '';

    //           switch (StatusColor) {
    //             case 'orange':
    //               Color = 'orange';
    //               break;
    //             case 'purple':
    //               Color = 'purple';
    //               break;
    //             case 'red':
    //               Color = 'red';
    //               break;
    //             case 'black':
    //               Color = 'black';
    //               break;
    //             default:
    //               Color = '#999'; // Fallback color
    //           }
    //       console.log('Color----------',Color)
    //       if (cell.row.approved) {

    //         return (
    //           <TaskAltIcon
    //             onClick={(e) => {
    //               setColumnID(cell.row.authId)
    //               setColumnIDs(cell.row.id)

    //               setAutpattientID1(cell.row.patientId)
    //               setPatientNamee(cell.row.patientName)
    //               setMarkaporoved(cell.row.approved)
    //               // handleapprove()
    //             }}
    //             style={{
    //               marginRight: "5px",
    //               float: "right",
    //               marginTop: "5px",
    //               color: cell.row.statusColor =='Red' ? 'red' : cell.row.statusColor ,

    //               // cursor: "not-allowed",
    //             }}></TaskAltIcon>
    //         );
    //       } else {
    //  return (

    //         <TaskAltIcon
    //           style={{
    //             marginRight: "5px",
    //             float: "right",
    //             marginTop: "5px",
    //             color: cell.row.statusColor =='Red' ? 'red' : cell.row.statusColor ,
    //             cursor: "pointer",
    //             zIndex: 3500000,
    //           }}
    //           onClick={(cellValues) => {
    //             setColumnIDsubluxbilling(cell.row.id)
    //             setColumnIDs(cell.row.id)

    //             setAutpattientID1(cell.row.patientId)
    //             setPatientNamee(cell.row.patientName)
    //             setColumnID(cell.row.authId)

    //             setMarkaporoved(cell.row.approved)

    //           }}
    //         ></TaskAltIcon>
    //  )
    //       }
    //     },
    //   },
    {
      field: "Approve",
      headerName: "Approve",
      sortable: true,
      headerClassName: "super-app-theme--header",
      flex: 2,
      minWidth: 150,
      renderCell: (cell) => {
        const rawStatus = cell.row.statusColor || "";
        const StatusColor = rawStatus.trim().toLowerCase();
        let Color = "#999";

        switch (StatusColor) {
          case "orange":
            Color = "orange";
            break;
          case "purple":
            Color = "purple";
            break;
          case "Red":
            Color = "red";
            break;
          case "black":
            Color = "black";
            break;
        }

        console.log(cell.row.statusColor);

        // If already approved
        if (cell.row.approved) {
          return (
            <TaskAltIcon
              onClick={() => {
                setColumnID(cell.row.authId);
                setColumnIDs(cell.row.authId);
                setAutpattientID1(cell.row.patientId);
                setPatientNamee(cell.row.patientName);
                setMarkaporoved(cell.row.approved);
                // handleapprove();
              }}
              style={{
                marginRight: "5px",
                float: "right",
                marginTop: "5px",
                color: Color, // ✅ always use processed color
              }}
            />
          );
        } else {
          // If not approved
          return (
            <TaskAltIcon
              style={{
                marginRight: "5px",
                float: "right",
                marginTop: "5px",
                color: Color, // ✅ always use processed color
                cursor: "pointer",
                zIndex: 3500000,
              }}
              onClick={() => {
                setColumnIDsubluxbilling(cell.row.authId);
                setColumnIDs(cell.row.authId);
                setAutpattientID1(cell.row.patientId);
                setPatientNamee(cell.row.patientName);
                setColumnID(cell.row.authId);
                setMarkaporoved(cell.row.approved);
              }}
            />
          );
        }
      },
    },
  ];
  const calumns9 = [
    {
      field: "AuthId",
      headerName: "Auth ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
    },
    {
      field: "PatientName",
      headerName: "Patient Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 2,
    },
    // {
    //   field: 'lastName',
    //   headerName: 'Last Name',
    //   headerClassName: 'super-app-theme--header',
    //   cellClassName: 'gridCell',
    //   sortable: false,
    //   flex: 2,
    // },
    {
      field: "CPTCharges",
      headerName: "CPT",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
    },
    {
      field: "Dos",
      headerName: "DOS",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.6,
    },
    {
      field: "PracticeName",
      headerName: "Practice Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2.7,
    },

    {
      field: "ApprovedDate",
      headerName: "Approved Date",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB"); // DD/MM/YYYY
      },
    },
    {
      field: "Dos",
      headerName: "Date Sub",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2,
    },
  ];
    const [openpatientreg, setOpenpatientreg] = React.useState(false);
  const [PatienTdemoGraphiceId, setPatienTdemoGraphiceId] = useState(null); // 'approve' or 'luxbilling'

  const handleOpenpatientreg = () => setOpenpatientreg(true);
  const handleClosepatientreg = () => setOpenpatientreg(false);
  const calumns10 = [
    {
      field: "formId",
      headerName: "Form ID",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.5,
    },
    {
      field: "patientName",
      headerName: "Patient Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 2,
    },
    {
      field: "dob",
      headerName: "DOB",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 1.6,
    },
    {
      field: "practiceName",
      headerName: "Practice Name",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 2.7,
    },

    {
      field: "state",
      headerName: "state",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
     {
    field: "action",
    headerName: "Action",
    headerClassName: "super-app-theme--header",
    sortable: false,
    flex: 2,
    renderCell: (params) => (
      <button
        className="btn btn-primary btn-sm"
        onClick={() => {
          setPatienTdemoGraphiceId(params.row.patientId);
          setOpenpatientreg(true);
        }}
      >
        Go To Patient Chart
      </button>
    ),
  },
  ];

  const ClaimDashboradCoulmns = [
    {
      field: "id",
      headerName: "Id",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 0.5,
    },
    {
      field: "patientName",
      headerName: "Patient Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 2,
    },
     {
      field: "practiceName",
      headerName: "Practice Name",
      headerClassName: "super-app-theme--header",
      cellClassName: "gridCell",
      sortable: false,
      flex: 2,
    },
    {
      field: "dos",
      headerName: "DOS",
      cellClassName: "gridCell",
      sortable: false,
      headerClassName: "super-app-theme--header",
      flex: 0.8,
    },
 {
  field: "status",
  headerName: "Status",
  headerClassName: "super-app-theme--header",
  sortable: false,
  flex: 1.2,
  renderCell: (cell) => {
    const colorMap = {
      red: { label: "New", color: "red" },
      orange: { label: "Pending", color: "orange" },
      purple: { label: "Pending Further", color: "purple" },
      brown: { label: "Secondary Pending", color: "brown" },
      green: { label: "Completed", color: "green" },
      blue: { label: "Paid", color: "#0092fb" },
      black: { label: "Closed", color: "black" },
      skyblue: { label: "Partially Paid", color: "skyblue" },
      blueviolet: { label: "Secondary Pending Review", color: "Blueviolet" },
      deeppink: { label: "Pending Insurance Check", color: "deeppink" },
      lightgreen: { label: "Paid To Patient", color: "lightgreen" },
    };

    // find by StatusColor (default gray)
   const statusColor = cell.row.StatusColor?.toLowerCase().replace(/\s/g, "") || "";

    // ✅ Exact match instead of includes()
    const match = colorMap[statusColor] || { label: "Unknown", color: "gray" };

    return (
      <div
        style={{
          backgroundColor: match.color,
          color: "#fff",
          padding: "4px 8px",
          borderRadius: "4px",
          width: "100%",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "0.85rem",
        }}
      >
        {match.label}
      </div>
    );
  },
}

  ];

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    // resolver: yupResolver(validationSchema),
    // defaultValues: defValues
  });
  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: "drak",
    fontSize: "13.4px !important",
    color: "drak !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      borderRadius: 0.1,
      color: "white",
      fontSize: "16px !important",
    },
  };
  const gridClasses = {
    columnHeader: "MuiDataGrid-columnHeaders",
  };
  const [isAllPractics, setisAllPractics] = useState(false);

  useEffect(() => {
    onFilterSearch();
  }, [isChecked, isAllPractics]);
  const [HideData, setHideData] = useState(false);
  const [CallApis, setCallApis] = useState(false);

  // const AllPractices = event => {
  //   setHideData(true)
  //   setCallApis(!CallApis)
  //   setLoading(true);
  //   setRows(null);
  //     axios.get(`${process.env.REACT_APP_API_URL}/Dashboard/PatientAutherizationDashboard?showAllPractices=${isAllPractics}&Isall=${isChecked}`, { headers })
  //       .then(response => {
  //         setRows(response)
  //         setDashboardinfo(response)
  //         setLoading(false)
  //         piechart(response)
  //       })
  //       .catch(error => {
  //         console.error('Error fetching data:', error);
  //       });
  //       axios.get(`${process.env.REACT_APP_API_URL}/Dashboard/ClaimsDashboard?showAllPractices=${isAllPractics}&Isall=${isChecked}`, { headers })
  //       .then(response => {
  //         setRows1(response)
  //         setLoading(false)
  //         piechart1(response)
  //       })
  //       .catch(error => {
  //         console.error('Error fetching data:', error);
  //       });

  // }

  const [filterSearchTriggered, setFilterSearchTriggered] = useState(false);

  const onFilterSearch = (event) => {
    // if (!isChecked && (!fromDate || !toDate)) {
    //   return; // Do nothing
    // }
    setFilterSearchTriggered(true);
    setHideData(true);
    setLoading(true);
    setCallApis(!CallApis);
    setRows(null);
    if (isChecked) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Dashboard/PatientAutherizationDashboard?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
          { headers }
        )
        .then((response) => {
          setRows(response);
          setDashboardinfo(response);

          const data = response; // ✅ Must use res.data
          const unapproved = data[0]?.unapproved ?? 0;
          setUnapproved(unapproved);
          const CompletedForms = data[0]?.completedForms ?? 0;
          setCompletedForms(CompletedForms);
          const approvedrecord = data[0]?.approved ?? 0;
          setApprovedRecord(approvedrecord);

          setLoading(false);
          piechart(response);
          // const data = response[0];
          // setpenndingclaims(data.total_submitted || 0); // Default to 0 if value is falsy
          // setcompeletclaims(data.total_compeleted || 0); // Default to 0 if value is falsy
          // setpaidclaims(data.total_payment || 0)
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Dashboard/ClaimsDashboard?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
          { headers }
        )
        .then((response) => {
          setRows1(response);
          setLoading(false);
          piechart1(response);
          const data = response[0];
          setpenndingclaims(data.total_pending || 0);
          setcompeletclaims(data.total_completed || 0);
          setpaidclaims(data.total_paid || 0);
          setNewclaims(data.total_new || 0);
          setcloseClaims(data.total_closed || 0);
          setpartiallyPaid(data.total_partiallyPaid || 0);
          setpaidToPatient(data.total_paidToPatient || 0);
          setpendingInsCheck(data.total_PandingInsuranceCheck || 0);
          setSecondaryPending(data.total_secondaryPending || 0);
          setSecondaryPendingReview(data.total_secondaryPendingReviews || 0)
          setpendingfurther(data.total_pendingFurtherProcess || 0);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } else {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Dashboard/PatientAutherizationDashboard?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
          { headers }
        )
        .then((response) => {
          setRows(response);
          setDashboardinfo(response);
          setLoading(false);
          piechart(response);

          const data = response; // ✅ Must use res.data
          const unapproved = data[0]?.unapproved ?? 0; // fallback to 0 only if undefined
            const CompletedForms = data[0]?.completedForms ?? 0;
          setCompletedForms(CompletedForms);
          setUnapproved(unapproved);
          const approvedrecord = data[0]?.approved ?? 0;
          setApprovedRecord(approvedrecord);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/Dashboard/ClaimsDashboard?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
          { headers }
        )
        .then((response) => {
          setRows1(response);
          setLoading(false);
          piechart1(response);
          const data = response[0];
          setpenndingclaims(data.total_pending || 0);
          setcompeletclaims(data.total_completed || 0);
          setpaidclaims(data.total_paid || 0);
          setNewclaims(data.total_new || 0);
          setcloseClaims(data.total_closed || 0);
          setpartiallyPaid(data.total_partiallyPaid || 0);
          setpaidToPatient(data.total_paidToPatient || 0);
          setpendingInsCheck(data.total_PandingInsuranceCheck || 0);
          setSecondaryPending(data.total_secondaryPending || 0);
          setpendingfurther(data.total_pendingFurtherProcess || 0);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
  };
  // useEffect(() => {
  //   if(isAllPractics){
  //     onFilterSearch()
  //   }
  //   },[isAllPractics])
  const piechart = (response) => {
    const resData = response;
    const letterOfMedicalNecessity = [];
    const questionnaire = [];
    const progressNotes = [];
    const authRequest = [];
    const approved = [];
    const patientInfo = [];
    const totalRecords = [];
    for (let i = 0; i < resData.length; i++) {
      letterOfMedicalNecessity.push(resData[i]?.letterOfMedicalNecessity ?? 0);
      questionnaire.push(resData[i].questionnaire);
      progressNotes.push(resData[i].progressNotes);
      authRequest.push(resData[i].authRequest);
      approved.push(resData[i].approved);
      patientInfo.push(resData[i]?.patientInfo ?? 0);
      totalRecords.push(resData[i].totalRecords);
    }
    if (resData == "Please Select the Dos Date") {
      setLetterOfMedicalNecessity(resData);
    } else {
      setLetterOfMedicalNecessity(letterOfMedicalNecessity);
    }
    if (resData == "Please Select the Dos Date") {
      setQuestionnaire(resData);
    } else {
      setQuestionnaire(questionnaire);
    }
    if (resData == "Please Select the Dos Date") {
      setPatientInfo(resData);
    } else {
      setPatientInfo(patientInfo);
    }

    setProgressNotes(progressNotes);
    setAuthRequest(authRequest);
    setApproved(approved);
    setTotalRecords(totalRecords);
  };
  const piechart1 = (response) => {
    const resData = response;
    const compeletclaims = [];
    const paidclaims = [];
    const penndingclaims = [];

    for (let i = 0; i < resData.length; i++) {
      paidclaims.push(resData[i].total_payment);
      compeletclaims.push(resData[i].total_compeleted);
      penndingclaims.push(resData[i].total_submitted);
    }
    //   if(compeletclaims.length>0){
    //   setcompeletclaims(compeletclaims);
    //   }
    //   // setpenndingclaims(penndingclaims);

    //   if(penndingclaims.length>0)
    //  { setpenndingclaims(penndingclaims)

    // }
    //   if(paidclaims.length>0)
    //  { setpaidclaims(paidclaims);}
  };

  function handleClick() {
    // navigate("/Demographics");
    setshow(true);
  }
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1100,
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    // overflow: "auto",
    // overflows: "hide",
    // zIndex: "10",
    customHeader: {
      backgroundColor: "black", // Apply your desired background color
      color: "white", // Apply the desired text color
      fontWeight: "bold",
    },
  };
  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    overflow: "auto",
    // overflows: "hide",
    // zIndex: "10",
    customHeader: {
      backgroundColor: "black", // Apply your desired background color
      color: "white", // Apply the desired text color
      fontWeight: "bold",
    },
  };
  const [ApproveRequests, setApproveRequests] = useState("all");
  const statusOptions = [
    { value: "all", label: "All" }, // 'All' option with empty string value
    { value: "new", label: "🔴New" }, // 'All' option with empty string value
    { value: "pending", label: "🟠Pending" },
    { value: "NeedsFurtherProcessing", label: "🟣Needs Further Processing" },
    { value: "completed", label: "🟢Completed" },
  ];

  const handleStatusChange = (selectedOption) => {
    setApproveRequests(selectedOption.value);
  };

  const handleLabelClick = (label) => {
    if (!isChecked && (!fromDate || !toDate)) {
      return; // Do nothing
    }
    if (label !== `Total Records (${totalRecords})`) {
      setIsModalOpen(true);
    }
    if (label === `Patient Info (${patientInfo})`) {
      if (isChecked) {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/PatientInfoDetails?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setRaws(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/PatientInfoDetails?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response) => {
            setLoading(false);

            setRaws(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }

    if (label === `Letter Of Medical Necessity (${letterOfMedicalNecessity})`) {
      if (isChecked) {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/LOMNDashboardDetails?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setRaws4(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/LOMNDashboardDetails?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response) => {
            setLoading(false);

            setRaws4(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }

    if (label === `Questionnaire (${questionnaire})`) {
      if (isChecked) {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/QuestionnaireDetails?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setRaws3(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/QuestionnaireDetails?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response) => {
            setLoading(false);

            setRaws3(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }

    if (label === `Progress Notes (${progressNotes})`) {
      if (isChecked) {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/ProgresNotesDetails?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setRaws1(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/ProgresNotesDetails?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response) => {
            setLoading(false);

            setRaws1(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }

    if (label === `Submitted to LuxBilling (${authRequest1})`) {
      if (isChecked) {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/PatientAuthRequestDetails?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setRaws5(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/PatientAuthRequestDetails?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response, index) => {
            setLoading(false);
            setRaws5(response);
            const dashpatient =
              response[index].lastName + " " + response[index].firstName;
            setPatientName(dashpatient);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }

    if (label === `Completed(${approved1})`) {
      if (isChecked) {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/AprovedPatientDetails?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setRaws2(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/AprovedPatientDetails?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response) => {
            setLoading(false);
            setRaws2(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }

    if (label === `Archived (${archivedApprovedCount})`) {
  if (!isChecked && (!fromDate || !toDate)) return;

  setSelectedLabel(label);
  setIsModalOpen(true);
  setLoading(true);

let url = `${process.env.REACT_APP_API_URL}/Dashboard/GetAuthorizationFormApprovedArchieved?showAllPractices=${isAllPractics}&Isall=${isChecked}`;
  if (!isChecked && fromDate && toDate) {
    url += `&dateFrom=${fromDate}&dateTo=${toDate}`;
  }

  axios
    .get(url, { headers })
    .then((response) => {
      setArchivedRows(response);
      setLoading(false);
    })
    .catch((error) => {
      console.error("Archived rows error:", error);
      setArchivedRows([]);
      setLoading(false);
    });
}

    if (label === `Un-Approved (${UNapprovedRecord})`) {
      if (isChecked) {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/GetAuthorizationFormunApproved?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setRaws9(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/GetAuthorizationFormunApproved?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response, index) => {
            setLoading(false);
            setRaws9(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }

     if (label === `Completed Forms (${CompletedForms})`) {
      if (isChecked) {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/CompletedPatientForms?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setRaws10(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel(label);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/CompletedPatientForms?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response, index) => {
            setLoading(false);
            setRaws10(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }
  };
  const [DashboardClaimRows, setDashboardClaimRows] = useState([]);
  const handleLabelClick1 = (label) => {
    setSelectedLabel1(label);
    let rows = [];

    if (label === `New (${Newclaims})`) rows = newRows;
    else if (label === `Pending Claims (${penndingclaims})`) rows = pendingRows;
    else if (label === `Pending Further Review (${pendingfurther})`)
      rows = pendingFurtherRows;
    else if (label === `Secondary Pending (${SecondaryPending})`)
      rows = secondaryRows;
    else if (label === `Completed Claims (${compeletclaims})`)
      rows = completeRows;
    else if (label === `Paid Claims (${paidclaims})`) rows = paidRows;
    else if (label === `Close Claims (${closeClaims})`) rows = closeRows;
    else if (label === `Partially Paid (${partiallyPaid})`) rows = partiallyPaidRows;
    else if (label === `Paid To Patient (${paidToPatient})`) rows = paidToPatientRows;
    else if (label === `Pending Insurance Check (${pendingInsCheck})`) rows = pendingInsCheckRows;
    else if (label === `Secondary Pending Further Review (${SecondaryPendingReview})`) rows = secondaryPendingReviewRows;

    setDashboardClaimRows(rows);
    setIsModalOpen1(true);
  };
  /* const handleLabelClick1 = (label) => {
    if (!isChecked && (!fromDate || !toDate)) {
      return; // Do nothing
    }
    if (label === `Pending Claims (${penndingclaims})`) {
      if (isChecked) {
        setSelectedLabel1(label);
        setIsModalOpen1(true);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/ClaimssubmittedSummary?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setpanddingrows(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel1(label);
        setIsModalOpen1(true);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/ClaimssubmittedSummary?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response) => {
            setLoading(false);
            setpanddingrows(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }

    if (label === `Completed Claims (${compeletclaims})`) {
      if (isChecked) {
        setSelectedLabel1(label);
        setIsModalOpen1(true);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/ClaimscompeletedSummary?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setcompeleterows(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel1(label);
        setIsModalOpen1(true);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/ClaimscompeletedSummary?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response) => {
            setLoading(false);

            setcompeleterows(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }

    if (label === `Paid Claims (${paidclaims})`) {
      if (isChecked) {
        setSelectedLabel1(label);
        setIsModalOpen1(true);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/ClaimspaymentSummary?showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            { headers }
          )
          .then((response) => {
            setLoading(false);
            setpaymentrows(response);
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        setSelectedLabel1(label);
        setIsModalOpen1(true);
        setLoading(true);
        axios
          .get(
            `${process.env.REACT_APP_API_URL}/Dashboard/ClaimspaymentSummary?dateFrom=${fromDate}&dateTo=${toDate}&showAllPractices=${isAllPractics}&Isall=${isChecked}`,
            {
              headers,
            }
          )
          .then((response) => {
            setLoading(false);

            setpaymentrows(response);
          })

          .catch((error) => {
            console.error("There was an error!", error);
          });
      }
    }
   };*/

  const closeModopen = () => {
    setIsModalOpen(false);
  };
  const closeModopen1 = () => {
    setIsModalOpen1(false);
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(true);
  };
  const [osapage, setOsapage] = React.useState(false);
  const [OpenLetter, setOpenLetter] = React.useState(false);
  const [OpenpriorAuth, setOpenpriorAuth] = React.useState(false);
  const [vobpage, setVobpage] = React.useState(false);
  const [vobpagepatientid, setVobpagepatientid] = useState();
  const [vobpage1, setVobpage1] = React.useState(false);
  const [opennewDisclaimer, setOpenDisclaimer] = React.useState(false);

  const [opendashprove, setopendashprove] = React.useState(false);
  const handlecolsedashprove = () => setopendashprove(false);
  const handleopendashprove = () => {
    reset();
    setopendashprove(true);
    setColumnID(0);
    // setSelectedPatient("")
  };
  const [openModal, setOpenModal] = React.useState(false);
  const handleCloseModal = () => setOpenModal(false);

  const handleOpen = () => {
    reset();
    setOpenModal(true);
    setColumnID(0);
    // setSelectedPatient("")
  };
  const openvobpage = () => {
    setVobpage(true);
    // reset()
  };
  const openvobpage1 = () => {
    setVobpage1(true);
    // setPatId(patientId)
    // reset()
  };
  const openosapage = () => {
    setOsapage(true);
    // reset()
  };
  const openLetter = () => {
    setOpenLetter(true);
    // reset()
  };
  const openpriorAuth = () => {
    setOpenpriorAuth(true);
    setOpenpriorAuth(true);
    // reset()
  };
  const openDisclaimer = () => {
    setOpenDisclaimer(true);
    // reset()
  };

  const closevobpage = () => {
    setVobpage(false);
    // reset()
  };
  const closevobpage1 = () => {
    setVobpage1(false);
    // reset()
  };
  const closeosapage = () => {
    setOsapage(false);
    // reset()
  };
  const closeLetter = () => {
    setOpenLetter(false);
    // reset()
  };

  const closepriorAuth = () => {
    setOpenpriorAuth(false);
    // reset()
  };
  const closeDisclaimer = () => {
    setOpenDisclaimer(false);
    // reset()
  };
  const handlePrint = () => {
    window.print();
  };
  const options = [
    <div>
      <Grid container>
        <Grid>
          <Button className="Button" onClick={openvobpage} variant="contained">
            VOB CheckList
          </Button>
        </Grid>
        <Grid style={{ marginTop: "5px" }}>
          <Button className="Button" onClick={openvobpage1} variant="contained">
            Auth-Request
          </Button>
        </Grid>
        <Grid style={{ marginTop: "5px" }}>
          <Button className="Button" onClick={openosapage} variant="contained">
            Screener
          </Button>
        </Grid>
        <Grid style={{ marginTop: "5px" }}>
          <Button className="Button" onClick={openLetter} variant="contained">
            Letter
          </Button>
        </Grid>
        <Grid style={{ marginTop: "5px" }}>
          <Button
            className="Button"
            onClick={openpriorAuth}
            variant="contained"
          >
            Prior Auth
          </Button>
        </Grid>
        <Grid style={{ marginTop: "5px" }}>
          <Button
            className="Button"
            onClick={openDisclaimer}
            variant="contained"
          >
            Disclaimer
          </Button>
        </Grid>
      </Grid>
    </div>,
  ];

  const [id, setid] = useState("");
  const [id1, setid1] = useState("");

  const [Resolve, setResolve] = useState("");

  const [nonapprovedNotification, setNonapprovedNotification] = useState(null);
  const [processingNotification, setprocessingNotification] = useState(null);
  const [NewNotification, setNewNotification] = useState(null);
  const [refreshapprove, setrefreshapprove] = useState(false);
  function applyRefreshapprove() {
    setrefreshapprove(!refreshapprove);
  }
  const [refreshclaim, setrefreshcalim] = useState(false);
  function applyRefreshclaim() {
    setrefreshcalim(!refreshclaim);
  }
  //  useEffect(() => {
  //   setLoading(true)
  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/Dashboard/GetAuthorizationFormApproved?showAllPractices=${isAllPractics}&Isall=${isChecked}`, { headers })
  //     .then(response => {
  //       setApprovedNotification(response)
  //       setApproved1(response.length)
  //       // setTotalcount(response.length)
  //       setLoading(false)
  //     })
  //     .catch(error => {
  //       console.error('There was an error!', error)
  //     })

  // }, [refreshapprove,isAllPractics,isChecked])
  const [AuthsFormLoading, setAuthsFormLoading] = useState(false);

  useEffect(() => {
    setAuthsFormLoading(true);

    let url = `${process.env.REACT_APP_API_URL}/Dashboard/GetAuthorizationFormApproved?showAllPractices=${isAllPractics}&Isall=${isChecked}`;

    if (
      (filterSearchTriggered || HideData) &&
      !isChecked &&
      fromDate &&
      toDate
    ) {
      url += `&dateFrom=${fromDate}&dateTo=${toDate}`;
    }

    axios
      .get(url, { headers })
      .then((res) => {
        // const sortedData = res?.sort((a, b) => new Date(b.ApprovedDate) - new Date(a.ApprovedDate));
        setApprovedNotification(res);
        setApproved1(res.length);

        setAuthsFormLoading(false);
        setFilterSearchTriggered(false);
      })
      .catch((err) => {
        console.error("Error!", err);
        setAuthsFormLoading(false);
        setFilterSearchTriggered(false);
      });
  }, [refreshapprove, isAllPractics, isChecked, CallApis]);
  const [pendingClaimsCount, setPendingClaimsCount] = useState(0);
  const [completedClaimsCount, setCompletedClaimsCount] = useState(0);
  const [paidClaimsCount, setPaidClaimsCount] = useState(0);
  const [newClaimCount, setnewClaimCount] = useState(0);
  const [pendingONlyClaimCount, setpendingONlyClaimCount] = useState(0);
  const [CliamsLoading, setCliamsLoading] = useState(false);


  useEffect(() => {
let url = `${process.env.REACT_APP_API_URL}/Dashboard/GetAuthorizationFormApprovedArchieved?showAllPractices=${isAllPractics}&Isall=${isChecked}`;
  if ((filterSearchTriggered || HideData) && !isChecked && fromDate && toDate) {
    url += `&dateFrom=${fromDate}&dateTo=${toDate}`;
  }

  axios
    .get(url, { headers })
    .then((res) => {
      setArchivedApprovedNotification(res);
      setArchivedApprovedCount(res.length);
    })
    .catch((err) => {
      console.error("Archived API error:", err);
      setArchivedApprovedNotification([]);
      setArchivedApprovedCount(0);
    });
}, [refreshapprove, isAllPractics, isChecked, CallApis]);

  // useEffect(() => {
  //   setCliamsLoading(true);
  //    let url = `${process.env.REACT_APP_API_URL}/claims/ClaimsSummary?Isall=${isChecked}&showAllPractices=${isAllPractics}`;
  //   if (
  //     (filterSearchTriggered || HideData) &&
  //     !isChecked &&
  //     fromDate &&
  //     toDate
  //   ) {
  //     url += `&dateFrom=${fromDate}&dateTo=${toDate}`;
  //   }

  //   axios
  //     .get(url, { headers })
  //     .then((response) => {

  //       const followUpDays = response.length > 0 ? parseInt(response[0].followUpTime || "14") : 14;
  //       const twoWeeksAgo = new Date();
  //       console.log(followUpDays , "uzair")
  //       twoWeeksAgo.setDate(twoWeeksAgo.getDate() - followUpDays);
  //       var res = response.filter(
  //         (f) => f.compeleted == false && f.payment == false && !f.New
  //       );
  //       const recentClaims = res.filter((item) => {
  //         const createdDate = new Date(item.CreatedDate);
  //         return (
  //           item.CreatedDate &&
  //           !isNaN(createdDate) &&
  //           createdDate >= twoWeeksAgo
  //         );
  //       });

  //       const olderClaims = res.filter((item) => {
  //         const createdDate = new Date(item.CreatedDate);
  //         return (
  //           !item.CreatedDate || isNaN(createdDate) || createdDate < twoWeeksAgo
  //         );
  //       });

  //       setclaimNotification(olderClaims);
  //       setPendingClaimsCount(olderClaims.length);
  //       setPendingClaimNotidcation(recentClaims);
  //       setpendingONlyClaimCount(recentClaims.length);

  //       var res1 = response.filter(
  //         (f) => f.compeleted == true && f.payment == false
  //       );
  //       setclaimNotification1(res1);
  //       const compeletedres = res1?.length;
  //       setCompletedClaimsCount(compeletedres);
  //       var res2 = response.filter((f) => f.payment == true);
  //       setclaimNotificationpayment(res2);
  //       const total_payment = res2?.length;
  //       setPaidClaimsCount(total_payment);
  //       var res4 = response.filter((f) => f.New == "true" && !f.payment);
  //       setnewClaimNotidcation(res4);
  //       const New_payment = res4?.length;
  //       setnewClaimCount(New_payment);
  //       //  console.log(total_payment,'testre__+')

  //       // setTotalcount(response.length)
  //       setCliamsLoading(false);
  //       setFilterSearchTriggered(false);
  //     })
  //     .catch((error) => {
  //       console.error("There was an error!", error);
  //       setCliamsLoading(false);
  //       setFilterSearchTriggered(false);
  //     });
  // }, [refreshclaim, isChecked, isAllPractics, CallApis]);
const [rejectedLoaded, setRejectedLoaded] = useState(false);
 const [RejectedClaims, setRejectedClaims] = useState(null);
  const [callingFromRejection, setcallingFromRejection] = useState(null);
   const [RejectedClaimErrors, setRejectedClaimErrors] = useState([]);

  useEffect(() => {
    setCliamsLoading(true);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/Batches/getRejectedClaims`,
        { headers }
      )
      .then((response) => {
      setCliamsLoading(false);
         const claims =
        response?.rejected_claims?.flatMap(
          (item) => item.claims || []
        ) || [];
      setRejectedClaims(claims)
          const rejectionReasons =
        response?.rejected_claims?.flatMap(
          (item) => item.rejection_reasons || []
        ) || [];

      setRejectedClaimErrors(rejectionReasons);
      setRejectedLoaded(true);
      })
      .catch((error) => {
          setRejectedLoaded(true);
      });
  }, [refreshclaim, isChecked, isAllPractics,CallApis]);
  useEffect(() => {
    if (!rejectedLoaded) return;
    setCliamsLoading(true);

    let url = `${process.env.REACT_APP_API_URL}/claims/ClaimsSummary?Isall=${isChecked}&showAllPractices=${isAllPractics}`;

    if (
      (filterSearchTriggered || HideData) &&
      !isChecked &&
      fromDate &&
      toDate
    ) {
      url += `&dateFrom=${fromDate}&dateTo=${toDate}`;
    }

    axios
      .get(url, { headers })
      .then((data) => {
        // FollowUpDays (default 14 if missing)
          const rejectedIds = new Set(
        (RejectedClaims || []).map((x) => x.id) // <-- adjust field if needed (claimId/id)
      );

      // 🔥 remove rejected rows
      const response = data.filter(
        (c) => !rejectedIds.has(c.id) // <-- adjust field if needed
      );
        

        // 🔥 StatusColor based separation
        const orangeClaims = response.filter(
          (c) => c.StatusColor === "orange" || c.StatusColor === "brown" || c.StatusColor === "deepPink"
        );
        const purpleClaims = response.filter((c) => c.StatusColor === "purple" || c.StatusColor === "Blueviolet");
        const redClaims = response.filter((c) => c.StatusColor === "red");
        const greenClaims = response.filter((c) => c.StatusColor === "green" || c.StatusColor === "lightgreen");
        const BlueClaims = response.filter((c) => c.StatusColor === "blue");
        const SkyBlueClaims = response.filter((c) => c.StatusColor === "skyblue");
        // 👉 Assign to states
        setPendingClaimNotidcation(orangeClaims); // 🟠 Orange
        setclaimNotification(purpleClaims); // 🟣 Purple
        setnewClaimNotidcation(redClaims); // 🔴 Red
        setclaimNotification1(greenClaims); // 🟢 Green
        setclaimNotificationpayment(BlueClaims); //  #1976d2

        // 👉 Counts
        setpendingONlyClaimCount(orangeClaims.length);
        setPendingClaimsCount(purpleClaims.length);
        setnewClaimCount(redClaims.length);
        setCompletedClaimsCount(greenClaims.length);
        setPaidClaimsCount(BlueClaims.length);
        // 👉 For dashbord
        setNewRows(redClaims);
        setPendingRows(response.filter((c) => c.StatusColor === "orange"));
        setPartiallyPaidClaims(SkyBlueClaims);
        setPartiallyPaidClaimsCount(SkyBlueClaims.length)
        setPendingFurtherRows(response.filter((c) => c.StatusColor === "purple"));
        setSecondaryRows(response.filter((c) => c.StatusColor === "brown"));
        setpendingInsCheckRows(response.filter((c) => c.StatusColor === "deepPink"));
        setpaidToPatientRows(response.filter((c) => c.StatusColor === "lightgreen"));
        setCompleteRows(greenClaims);
        setPaidRows(BlueClaims);
        setCloseRows(response.filter((c) => c.StatusColor === "black"));
        setClosedClaimCount(response.filter((c) => c.StatusColor === "black").length);
        setpartiallyPaidRows(SkyBlueClaims);

        setsecondaryPendingReviewRows(response.filter((c) => c.StatusColor === "Blueviolet"));

        setCliamsLoading(false);
        setFilterSearchTriggered(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setCliamsLoading(false);
        setFilterSearchTriggered(false);
      });
  }, [refreshclaim, isChecked, isAllPractics, CallApis,rejectedLoaded]);
 
  const checkstyle1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #356F60",
    boxShadow: 24,
    // overflow: "auto",
    // overflow: "auto",
    /* Other styles */
    scrollbarWidth: "thin", // For Firefox
    scrollbarColor: "#356F60 transparent", // thumb color and track color
    "&::-webkit-scrollbar": {
      width: 8 /* Width of vertical scrollbar */,
      height: 8 /* Height of horizontal scrollbar */,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#356F60" /* Color of the thumb */,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent" /* Color of the track */,
    },
    /* Adjust the width for the horizontal scrollbar */
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4 /* Width of horizontal scrollbar */,
    },
    // zIndex: "10",
  };
  const checkstyle3 = {
    position: "absolute",
    top: "50%",
    // left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1100,
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    overflow: "auto",
    overflows: "hide",
    // zIndex: "10",
  };
  const checkstyle2 = {
    position: "absolute",
    top: "50%",
    left: "60%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: 600,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    overflow: "auto",
    // overflows: "hide",
    // zIndex: "10",
  };
  const [includetype, setIncludetype] = React.useState("");
  useEffect(() => {
    setIncludetype([
      { label: "Auth Request Submitted", value: "Auth Request Submitted" },
    ]);
  }, []);

  // const onFilterSearchapporve = event => {
  //   setLoading(true);

  //   axios
  //     .get(`${process.env.REACT_APP_API_URL}/Dashboard/GetAuthorizationFormSubmitted`, { headers })
  //     .then(response => {
  //       console.log('response.data: ', response);
  //       setNonapprovedNotification(response);
  //       setLoading(false);
  //     })
  //     .catch(error => {
  //       console.error('There was an error!', error);
  //       setLoading(false);
  //     });
  // };
  // useEffect(() => {
  //   onFilterSearchapporve()
  // }, [])
  // useEffect(() => {
  //   setLoading(true)
  //   axios
  //   .get(`${process.env.REACT_APP_API_URL}/Dashboard/GetAuthorizationFormSubmitted?showAllPractices=${isAllPractics}&Isall=${isChecked}`, { headers })
  //   .then(response => {
  //     setNonapprovedNotification(response);
  //      setAuthRequest1(response.length)
  //     setLoading(false);
  //   })
  //   .catch(error => {
  //     console.error('There was an error!', error);
  //     setLoading(false);
  //   });
  // }, [refreshapprove,isChecked,isAllPractics])

  useEffect(() => {
    setAuthsFormLoading(true);
    let url = `${process.env.REACT_APP_API_URL}/Dashboard/GetAuthorizationFormSubmitted?showAllPractices=${isAllPractics}&Isall=${isChecked}`;
    if (
      (filterSearchTriggered || HideData) &&
      !isChecked &&
      fromDate &&
      toDate
    ) {
      url += `&dateFrom=${fromDate}&dateTo=${toDate}`;
    }
    axios
      .get(url, { headers })
      .then((response) => {
        const pendingData = response.filter(
          (item) => item.statusColor === "orange"
        );
        // setNonapprovedNotification(response);
        setNonapprovedNotification(pendingData);
        setAuthRequest1(response.length);
        setPendingrequests(pendingData.length);
        const processData = response.filter(
          (item) => item.statusColor === "purple"
        );
        setprocessingNotification(processData);
        setprocessRequest(processData.length);
        const newData = response.filter(
          (item) => item.statusColor === "Red" || item.statusColor === "black"
        );
        setNewNotification(newData);
        setnewrequests(newData.length);
        setAuthsFormLoading(false);
        setFilterSearchTriggered(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setAuthsFormLoading(false);
        setFilterSearchTriggered(false);
      });
  }, [refreshapprove, isChecked, isAllPractics, CallApis]);
  // useEffect(() => {
  //   setLoading(true)

  //     // .get(`${process.env.REACT_APP_API_URL}/Notifications/getNotificationsAppprovedOrSubmitted?notInclude=${'Auth Request Approved'}&include=${'Auth Request Submitted'}`, { headers })

  //   axios
  //   .get(`${process.env.REACT_APP_API_URL}/Notifications/getNotificationsAppprovedOrSubmitted`, { headers })

  //     .then(response => {
  //       console.log('response.data: ', response)
  //     setNonapprovedNotification(response)
  //     // setPracticeID(response.practiceId)
  //     // setTotalcount(response.length)
  //     setLoading(false)

  //     })
  //     .catch(error => {
  //       console.error('There was an error!', error)
  //     })

  // }, [refreshapprove])
  /////Claim///
  const [claimopen, setclaimopen] = React.useState(false);
  const handleclaimopen = () => {
    setclaimopen(true);
  };
  const [claimPracticeID, setclaimPracticeID] = React.useState("");

  const handlecloseclaimopen = () => {
    setclaimopen(false);
    setclaimPracticeID("");
    setcallingFromRejection(null)
  };

  /////////
  const [PriorPracticeID, setPriorPracticeID] = useState("");
  const [lomn, setLomn] = useState("");
  const [Quetionare, setQuetionare] = useState("");
  const [Source, setSource] = useState("");
  const [Charge1, setCharge1] = useState("");

  const [approve, setapprove] = React.useState(false);
  const handleapprove = () => {
    setapprove(true);
  };

  const handlecloseapprove = () => {
    setapprove(false);
    setrefreshapprove(!refreshapprove);
  };
  const [approvedashbord, setapprovedasbord] = React.useState(false);
  const handleapprovedashbord = () => {
    setapprovedasbord(true);
  };

  const handlecloseapprovedashbord = () => {
    setapprovedasbord(false);
  };

  const [luxbillingpending, setluxbillingpending] = React.useState(false);
  const handleluxbillingpending = () => {
    setluxbillingpending(true);
  };

  const handleCloseluxbillingpending = () => {
    setluxbillingpending(false);
    setrefreshapprove(!refreshapprove);
  };
  const alert = useAlert();

  const [refresh, setRefresh] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [Totalcount, setTotalcount] = useState(0);
  const [selectedRow, setselectedRow] = useState("");
  const [selectedindex, setselectedindex] = useState("");
  const handleRemove = (selectedIndex) => {
    const updatedNotification = approvedNotification.filter(
      (_, index) => index !== selectedIndex
    );
    setApprovedNotification(updatedNotification);
    const updatedNotification1 = nonapprovedNotification.filter(
      (_, index) => index !== selectedIndex
    );
    setNonapprovedNotification(updatedNotification1);
    const updatedNotification2 = NewNotification.filter(
      (_, index) => index !== selectedIndex
    );
    setNewNotification(updatedNotification2);
    const updatedNotification3 = processingNotification.filter(
      (_, index) => index !== selectedIndex
    );
    setprocessingNotification(updatedNotification3);
    setAuthRequest(updatedNotification1.length);
  };
  const [errorMessage, setErrorMessage] = useState(false);
  const saveData = (data) => {
    var postData = data;
    postData.id = selectedRow;
    postData.resolved = true;
    // setSubmitting(true)
    if (!data.resolvedDate) {
      setErrorMessage(true);
      return;
    }
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Notifications/addNotifications`,
        postData,
        { headers }
      )
      .then((response) => {
        setid(null);
        approvedNotification.splice(selectedindex, 1);
        nonapprovedNotification.splice(selectedindex, 1);
        handleRemove(selectedindex);
        alert.success("Issue resolved successfully.", {
          type: "success",
          onClose: () => {
            setTotalcount(Totalcount - 1);
            setSubmitting(false);
            setRefresh(true);
            applyRefreshapprove();
            reset();
          },
        });
      })
      .catch((error) => {
        setSubmitting(false);
        alert.error(`Error ${error.message}`, {
          type: "error",
        });
        setRefresh(true);
      });
    setRefresh(true);
  };
  const [expandedRowId, setExpandedRowId] = useState(null);

  const handleToggleExpansion = (index) => {
    // if (expandedRowId === rowId) {
    //   setExpandedRowId(null); // Collapse the expanded row if it's clicked again
    // } else {
    setExpandedRowId((prevIndex) => (prevIndex === index ? null : index)); // Expand the clicked row
    // }
  };
  const [expandedRowIndex, setExpandedRowIndex] = useState(null); // Track the expanded row's index

  const handleToggleExpansion1 = (index) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index)); // Toggle the row expansion
  };

  const [pendingRequestRowIndex, setpendingRequestRowIndex] = useState(null);

  const handleToggleExpansionPedningRequest = (index) => {
    setpendingRequestRowIndex((prevIndex) =>
      prevIndex === index ? null : index
    );
  };
  const [NewRequestRowIndex, setNewRequestRowIndex] = useState(null);

  const handleToggleExpansionNewRequest = (index) => {
    setNewRequestRowIndex((prevIndex) => (prevIndex === index ? null : index)); // Toggle the row expansion
  };
  /////////Claim////////
  const [expandedRowIdclaim, setExpandedRowIdclaim] = useState(null);

  const handleToggleExpansionclaim = (rowIdclaim) => {
    if (expandedRowIdclaim === rowIdclaim) {
      setExpandedRowIdclaim(null); // Collapse the expanded row if it's clicked again
    } else {
      setExpandedRowIdclaim(rowIdclaim); // Expand the clicked row
    }
  };

  const [expandedRowIdclaim1, setExpandedRowIdclaim1] = useState(null);

  const handleToggleExpansionclaim1 = (rowIdclaim1) => {
    if (expandedRowIdclaim1 === rowIdclaim1) {
      setExpandedRowIdclaim1(null); // Collapse the expanded row if it's clicked again
    } else {
      setExpandedRowIdclaim1(rowIdclaim1); // Expand the clicked row
    }
  };

  const [expandedRowIdclaim2, setExpandedRowIdclaim2] = useState(null);

  const handleToggleExpansionclaim2 = (rowIdclaim2) => {
    if (expandedRowIdclaim2 === rowIdclaim2) {
      setExpandedRowIdclaim2(null); // Collapse the expanded row if it's clicked again
    } else {
      setExpandedRowIdclaim2(rowIdclaim2); // Expand the clicked row
    }
  };


  const styleDetailspatient = {
    width: "90%",
    height: 600,
    bgcolor: "white",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    margin: "auto",
    marginTop: "10px",
    paddingBottom: "10px",
    padding: "20px",
    overflow: "auto",
    zIndex: 1500, // 🔥 This makes sure the modal stays on top
    scrollbarWidth: "thin",
    scrollbarColor: "#356F60 transparent",
    "&::-webkit-scrollbar": {
      width: 8,
      height: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#356F60",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4,
    },
  };

  return (
    <React.Fragment>
      {/* demograhic Modal */}

      <Modal
        open={openpatientreg}
        onClose={handleClosepatientreg}
        sx={{ zIndex: 1500 }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDetailspatient}>
          <Grid container columnSpacing={1}>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Typography style={{ fontWeight: "bold", color: "black" }}>
                Patient Registration
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Button
                onClick={handleClosepatientreg}
                style={{
                  marginTop: "0px",
                  marginBottom: "10px",
                  float: "right",
                  marginLeft: "10px",
                  width: "90px",
                  height: "35px",
                  // backgroundColor: '#A574FD',
                  color: "white",
                  fontSize: "14px",
                }}
              >
                <CancelOutlinedIcon
                  fontSize="medium"
                  style={{ color: "red", paddingRight: "5px" }}
                ></CancelOutlinedIcon>
              </Button>
            </Grid>
            <Grid item xs={12} style={{ fontWeight: 500, marginTop: "-90px" }}>
              <PatientRegistration
                callingFrom={"Authorization"}
                pid={PatienTdemoGraphiceId}
                handleClosepatientreg={handleClosepatientreg}
              ></PatientRegistration>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {openModal ? (
        <>
          <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1}>
              <Headroom>
                <Grid
                  container
                  style={{ backgroundColor: "#356F60", position: "sticky" }}
                >
                  <Grid item xs={3}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: "2rem",
                      }}
                    >
                      <DialogTitle
                        style={{
                          flex: 1,
                          textAlign: "center",
                        }}
                      >
                        <Typography
                          variant="standard"
                          fontWeight="bold"
                          color="#fff"
                        >
                          {" "}
                          Add Authorization
                        </Typography>
                      </DialogTitle>
                    </div>
                  </Grid>
                  <Grid item xs={2.9}>
                    <Typography
                      style={{
                        color: "white",
                        marginTop: "8px",
                        float: "right",
                        fontWeight: "bold",
                      }}
                    >
                      Patient Name:
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography style={{ color: "white", marginTop: "8px" }}>
                      {patientName}
                    </Typography>
                  </Grid>
                  <Grid item xs={2.5}>
                    <Typography
                      style={{
                        color: "white",
                        marginTop: "8px",
                        float: "right",
                        fontWeight: "bold",
                      }}
                    >
                      ID:
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography style={{ color: "white", marginTop: "8px" }}>
                      {columnID}
                    </Typography>
                  </Grid>
                  <Grid item xs={0.5}>
                    <CancelOutlinedIcon
                      onClick={handleCloseModal}
                      fontSize="large"
                      color="red"
                      style={{
                        float: "right",
                        color: "red",
                        paddingRight: "5px",
                        cursor: "pointer",
                        // marginLeft: 'auto',
                        // marginRight: '1.5rem'
                      }}
                    ></CancelOutlinedIcon>
                  </Grid>
                </Grid>
              </Headroom>
              <Grid
                style={{
                  backgroundColor: "#f3f3f4",
                  margin: "1.3rem auto",
                  border: "1px solid #326C1D",
                  borderRadius: "10px",
                  width: "98%",
                }}
              >
                <Grid>
                  <AuthorizationRegistration
                    callingFrom="dashboard"
                    Dashboard={patientName}
                    AutpattientID={AutpattientID}
                    dashID={columnID}
                    CloseModal={handleCloseModal}
                  ></AuthorizationRegistration>
                  <ToastContainer
                    position="top-center"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                </Grid>
              </Grid>
            </Box>
          </Modal>

          {/* ////////// */}
        </>
      ) : (
        <div className="page-content">
          <Modal
            open={approvelux}
            onClose={handlecloseapprovelux}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            visible={true}
            title={"Title"}
            footer={"Footer"}
          >
            <Box sx={checkstyle1}>
              <Headroom>
                <Grid container style={{ backgroundColor: "#356F60" }}>
                  <Grid item xs={12} sm={12} xl={12}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: "3rem",
                      }}
                    >
                      <DialogTitle
                        style={{
                          flex: 1,
                          textAlign: "center",
                        }}
                      >
                        <h1
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            color: "#fff",
                            textDecoration: "underline",
                            fontSize: "1.5rem",
                          }}
                        >
                          Prior_auth & VOB
                        </h1>
                      </DialogTitle>
                      <Typography
                        style={{ color: "white", marginRight: "10px" }}
                      >
                        Patient Name:
                      </Typography>
                      <Typography
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          marginRight: "60px",
                        }}
                      >
                        {patientNamee}
                      </Typography>

                      <Typography
                        style={{ color: "white", marginRight: "10px" }}
                      >
                        ID:
                      </Typography>
                      <Typography
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          marginRight: "60px",
                        }}
                      >
                        {columnID}
                      </Typography>

                      <CancelOutlinedIcon
                        onClick={handlecloseapprovelux}
                        fontSize="large"
                        color="red"
                        style={{
                          color: "red",
                          paddingRight: "5px",
                          cursor: "pointer",
                          // marginLeft: 'auto',
                          // marginRight: '1.5rem'
                        }}
                      ></CancelOutlinedIcon>
                    </div>
                  </Grid>
                </Grid>
              </Headroom>

              <Grid item xs={12}>
                <Card
                  bordered={false}
                  style={{
                    overflow: "auto",
                    /* Other styles */
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "#356F60 transparent", // thumb color and track color
                    "&::-webkit-scrollbar": {
                      width: 8 /* Width of vertical scrollbar */,
                      height: 8 /* Height of horizontal scrollbar */,
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#356F60" /* Color of the thumb */,
                      borderRadius: 10,
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent" /* Color of the track */,
                    },
                    /* Adjust the width for the horizontal scrollbar */
                    "&::-webkit-scrollbar-thumb:horizontal": {
                      width: 4 /* Width of horizontal scrollbar */,
                    },
                    // zIndex: "10",
                    height: "70vh",
                  }}
                >
                  <Prior_auth
                    formDid={formDid}
                    columnID={columnID}
                    handleClose4={handlecloseapprovelux}
                    patientNameee={patientNamee}
                    AutpattientID1={AutpattientID1}
                    Markaporoved={Markaporoved}
                    updateHealthHistory={(id, authId) => {
                      setValue("approved", true);
                      setColumnIDsubluxbilling(authId);
                      // setapproveid(authId)
                    }}
                    style={{ height: "40vh" }}
                  ></Prior_auth>
                </Card>
                <ToastContainer
                  position="bottom-center"
                  autoClose={1500}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"
                />
              </Grid>
            </Box>
          </Modal>
          <Modal
            open={approve}
            onClose={handlecloseapprove}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            visible={true}
            title={"Title"}
            footer={"Footer"}
          >
            <Box sx={checkstyle1}>
              <Headroom>
                <Grid
                  container
                  spacing={0}
                  style={{
                    backgroundColor: "#356F60",

                    alignItems: "center",

                    height: "auto",
                  }}
                >
                  <Grid item xs={3}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: "3rem",
                      }}
                    >
                      <DialogTitle
                        style={{
                          flex: 1,
                          textAlign: "center",
                        }}
                      >
                        <h1
                          style={{
                            fontWeight: "bold",
                            textAlign: "left",
                            color: "#fff",
                            textDecoration: "underline",
                            fontSize: "24px",
                          }}
                        >
                          Prior_auth & VOB
                        </h1>
                      </DialogTitle>
                    </div>
                  </Grid>
                  <Grid item xs={3.5}>
                    <Typography style={{ color: "white", fontWeight: "bold" }}>
                      Patient Name:{patinetnameopenauth}{" "}
                    </Typography>
                  </Grid>
                  {/* <Grid item  xs={3}  >
                      <Typography style={{color:'white',fontWeight:'bold'}}>{patinetnameopenauth}</Typography>
                      </Grid> */}
                  <Grid item xs={2}>
                    <Typography style={{ color: "white", fontWeight: "bold" }}>
                      ID:{authId}
                    </Typography>
                  </Grid>
                  {/* <Grid item  xs={2} >
                      <Typography style={{color:'white'}}> {authId}</Typography>
                      </Grid> */}

                  <Grid item xs={3}>
                    <Button
                      className="Button"
                      variant="contained"
                      color="info"
                      fullWidth
                      //  disabled={columnID <= 0}
                      style={{
                        float: "left",
                        height: "30px",
                        marginTop: "8px",
                      }}
                      size="small"
                      onClick={() => {
                        setOpenpatientreg(true);
                      }}
                    >
                      Go to patient Chart
                    </Button>
                  </Grid>
                  <Grid item xs={0.5}>
                    <CancelOutlinedIcon
                      onClick={handlecloseapprove}
                      fontSize="medium"
                      color="red"
                      style={{
                        color: "red",

                        float: "right",
                        cursor: "pointer",
                        // marginLeft: 'auto',
                        // marginRight: '1.5rem'
                      }}
                    ></CancelOutlinedIcon>
                  </Grid>
                </Grid>
              </Headroom>
              <Grid item xs={12}>
                <Card
                  bordered={false}
                  style={{
                    overflow: "auto",
                    /* Other styles */
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "#356F60 transparent", // thumb color and track color
                    "&::-webkit-scrollbar": {
                      width: 8 /* Width of vertical scrollbar */,
                      height: 8 /* Height of horizontal scrollbar */,
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#356F60" /* Color of the thumb */,
                      borderRadius: 10,
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent" /* Color of the track */,
                    },
                    /* Adjust the width for the horizontal scrollbar */
                    "&::-webkit-scrollbar-thumb:horizontal": {
                      width: 4 /* Width of horizontal scrollbar */,
                    },
                    // zIndex: "10",
                    height: "70vh",
                  }}
                >
                  <Prior_auth
                    columnID={authId}
                    UnapprovedButton={UnapprovedButton}
                    PriorPracticeID={PriorPracticeID}
                    handleClose4={handlecloseapprove}
                    patientNameee={patinetnameopenauth}
                    ArchievedButton={true}
                    AutpattientID1={patinetIdopenauth}
                    Markaporoved={Markaporovedopenauth}
                    lomn={lomn}
                    UpdateMessage={true}
                    Charge1={Charge1}
                    Source={Source}
                    Quetionare={Quetionare}
                    updateHealthHistory={(id, authId) => {
                      setValue("approved", true);
                      setColumnIDsubluxbilling(authId);
                      // setapproveid(authId)
                    }}
                    style={{ height: "40vh" }}
                  ></Prior_auth>
                </Card>
                <ToastContainer
                  position="bottom-center"
                  autoClose={1500}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"
                />
              </Grid>
            </Box>
          </Modal>

          <Modal
            open={luxbillingpending}
            onClose={handleCloseluxbillingpending}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            visible={true}
            title={"Title"}
            footer={"Footer"}
          >
            <Box sx={checkstyle1}>
              <Headroom>
                <Grid
                  container
                  style={{ backgroundColor: "#356F60", position: "sticky" }}
                >
                  <Grid item xs={3}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: "3rem",
                      }}
                    >
                      <DialogTitle
                        style={{
                          flex: 1,
                          textAlign: "center",
                        }}
                      >
                        <h1
                          style={{
                            fontWeight: "bold",
                            textAlign: "left",
                            color: "#fff",
                            textDecoration: "underline",
                            fontSize: "24px",
                          }}
                        >
                          Prior_auth & VOB
                        </h1>
                      </DialogTitle>
                    </div>
                  </Grid>
                  <Grid item xs={3.5}>
                    <Typography
                      style={{
                        color: "white",
                        marginRight: "10px",
                        marginTop: "8px",
                      }}
                    >
                      Patient Name:{patinetnameopenauth1}
                    </Typography>
                  </Grid>

                  <Grid item xs={2}>
                    <Typography
                      style={{
                        color: "white",
                        marginRight: "10px",
                        marginTop: "8px",
                      }}
                    >
                      ID:{authId2}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      className="Button"
                      variant="contained"
                      color="info"
                      fullWidth
                      //  disabled={columnID <= 0}
                      style={{
                        float: "left",
                        height: "30px",
                        marginTop: "8px",
                      }}
                      size="small"
                      onClick={() => {
                        setOpenpatientreg(true);
                      }}
                    >
                      Go to patient Chart
                    </Button>
                  </Grid>
                  <Grid item xs={0.5}>
                    <CancelOutlinedIcon
                      onClick={handleCloseluxbillingpending}
                      fontSize="large"
                      color="red"
                      style={{
                        color: "red",
                        paddingRight: "5px",
                        cursor: "pointer",
                        // marginLeft: 'auto',
                        // marginRight: '1.5rem'
                      }}
                    ></CancelOutlinedIcon>
                  </Grid>
                </Grid>
              </Headroom>

              <Grid item xs={12}>
                {/* <AuthorizationRegistration callingFrom={"Approved"} columnID={authId2}  CloseModal={handleCloseluxbillingpending}></AuthorizationRegistration> */}
                <Card
                  bordered={false}
                  style={{
                    overflow: "auto",
                    /* Other styles */
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "#356F60 transparent", // thumb color and track color
                    "&::-webkit-scrollbar": {
                      width: 8 /* Width of vertical scrollbar */,
                      height: 8 /* Height of horizontal scrollbar */,
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#356F60" /* Color of the thumb */,
                      borderRadius: 10,
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent" /* Color of the track */,
                    },
                    /* Adjust the width for the horizontal scrollbar */
                    "&::-webkit-scrollbar-thumb:horizontal": {
                      width: 4 /* Width of horizontal scrollbar */,
                    },
                    // zIndex: "10",
                    height: "70vh",
                  }}
                >
                  <Prior_auth
                    columnID={authId2}
                    PriorPracticeID={PriorPracticeID}
                    columnIDcpt={authIdcpt}
                    handleClose4={handleCloseluxbillingpending}
                    patientNameee={patinetnameopenauth1}
                    AutpattientID1={patinetIdopenauth1}
                    lomn={lomn}
                    // UpdateMessage={true}
                    Source={Source}
                    Charge1={Charge1}
                    Quetionare={Quetionare}
                    Markaporoved={true}
                    //  AutpattientID1={AutpattientID}
                    updateHealthHistory={(id, authId) => {
                      // setautoClosePage(false)
                      setValue("authRequest", true);
                      setColumnID(authId);
                      setValue("id", authId);
                      // setauthRequestid(authId)
                    }}
                  ></Prior_auth>
                </Card>

                <ToastContainer
                  position="bottom-center"
                  autoClose={1500}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"
                />
              </Grid>
            </Box>
          </Modal>
          <Modal
            open={approvedashbord}
            onClose={handlecloseapprovedashbord}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            visible={true}
            title={"Title"}
            footer={"Footer"}
          >
            <Box sx={checkstyle1}>
              <Headroom>
                <Grid
                  container
                  style={{ backgroundColor: "#356F60", position: "sticky" }}
                >
                  <Grid item xs={12} sm={12} xl={12}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        height: "3rem",
                      }}
                    >
                      <DialogTitle
                        style={{
                          flex: 1,
                          textAlign: "center",
                        }}
                      >
                        <h1
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            color: "#fff",
                            textDecoration: "underline",
                            fontSize: "2rem",
                          }}
                        >
                          Prior_auth & VOB
                        </h1>
                      </DialogTitle>
                      <Typography
                        style={{ color: "white", marginRight: "10px" }}
                      >
                        Patient Name:
                      </Typography>
                      <Typography
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          marginRight: "60px",
                        }}
                      >
                        {patientName}
                      </Typography>

                      <Typography
                        style={{ color: "white", marginRight: "10px" }}
                      >
                        ID:
                      </Typography>
                      <Typography
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          marginRight: "60px",
                        }}
                      >
                        {columnID}
                      </Typography>

                      <CancelOutlinedIcon
                        onClick={handlecloseapprovedashbord}
                        fontSize="large"
                        color="red"
                        style={{
                          color: "red",
                          paddingRight: "5px",
                          cursor: "pointer",
                          // marginLeft: 'auto',
                          // marginRight: '1.5rem'
                        }}
                      ></CancelOutlinedIcon>
                    </div>
                  </Grid>
                </Grid>
              </Headroom>
              <Grid item xs={12}>
                <Card
                  bordered={false}
                  style={{
                    overflow: "auto",
                    /* Other styles */
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "#356F60 transparent", // thumb color and track color
                    "&::-webkit-scrollbar": {
                      width: 8 /* Width of vertical scrollbar */,
                      height: 8 /* Height of horizontal scrollbar */,
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#356F60" /* Color of the thumb */,
                      borderRadius: 10,
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent" /* Color of the track */,
                    },
                    /* Adjust the width for the horizontal scrollbar */
                    "&::-webkit-scrollbar-thumb:horizontal": {
                      width: 4 /* Width of horizontal scrollbar */,
                    },
                    // zIndex: "10",
                    height: "70vh",
                  }}
                >
                  <Prior_auth
                    abc={"abc"}
                    columnID={columnID}
                    handleClose4={handlecloseapprovedashbord}
                    patientNameee={patientNamee ? patientNamee : patientName}
                    AutpattientID1={AutpattientID}
                    Markaporoved={Markaporovedopenauth}
                    updateHealthHistory={(id, authId) => {
                      setValue("approved", true);
                      setColumnID(authId);
                      // setapproveid(authId)
                    }}
                    style={{ height: "40vh" }}
                  ></Prior_auth>
                </Card>
                <ToastContainer
                  position="top-center"
                  autoClose={1500}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"
                />
              </Grid>
            </Box>
          </Modal>

          {/* /////// Claim Open */}
          <Modal
            open={claimopen}
            onClose={handlecloseclaimopen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            visible={true}
            title={"Title"}
            footer={"Footer"}
          >
            <Box sx={checkstyle1}>
              <Headroom>
                <Grid
                  container
                  spacing={0}
                  style={{
                    backgroundColor: "#356F60",

                    alignItems: "center",

                    height: "auto",
                  }}
                >
                  {/* <Grid item  xs={12}  >
                      <CancelOutlinedIcon
                        onClick={handlecloseclaimopen}
                        fontSize="medium"
                        color="red"
                        style={{
                          color: 'red',
                         
                          float:"right",
                          cursor: 'pointer',
                          // marginLeft: 'auto',
                          // marginRight: '1.5rem'
                        }}
                      ></CancelOutlinedIcon>
                    
                  </Grid> */}
                  <Grid item xs={2.9}>
                    <Typography
                      style={{
                        fontWeight: "bold",

                        color: "#fff",
                        textDecoration: "underline",
                        fontSize: "25px",
                      }}
                    >
                      Claim Submission
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography style={{ color: "white", fontWeight: "bold" }}>
                      Patient Name: {patinetnameopenclaim}{" "}
                    </Typography>
                  </Grid>
                  <Grid item xs={0.1}></Grid>
                  <Grid item xs={2}>
                    <Typography style={{ color: "white", fontWeight: "bold" }}>
                      Patient Id : {PatienTdemoGraphiceId}
                    </Typography>
                  </Grid>
                  <Grid item xs={0.5}>
                    <Typography style={{ color: "white", fontWeight: "bold" }}>
                      ID:
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography style={{ color: "white" }}>
                      {" "}
                      {claimId}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      className="Button"
                      variant="contained"
                      color="info"
                      fullWidth
                      size="small"
                      style={{
                        height: "36px",
                        marginTop: "8px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                      onClick={() => {
                        setOpenpatientreg(true);
                      }}
                    >
                      Go to patient Chart
                    </Button>
                  </Grid>
                  <Grid item xs={0.5}>
                    <CancelOutlinedIcon
                      onClick={handlecloseclaimopen}
                      fontSize="medium"
                      color="red"
                      style={{
                        color: "red",

                        float: "right",
                        cursor: "pointer",
                        // marginLeft: 'auto',
                        // marginRight: '1.5rem'
                      }}
                    ></CancelOutlinedIcon>
                  </Grid>
                </Grid>
              </Headroom>
              <Grid item xs={12}>
                <Card
                  bordered={false}
                  style={{
                    overflow: "auto",
                    /* Other styles */
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "#356F60 transparent", // thumb color and track color
                    "&::-webkit-scrollbar": {
                      width: 8 /* Width of vertical scrollbar */,
                      height: 8 /* Height of horizontal scrollbar */,
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#356F60" /* Color of the thumb */,
                      borderRadius: 10,
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent" /* Color of the track */,
                    },
                    /* Adjust the width for the horizontal scrollbar */
                    "&::-webkit-scrollbar-thumb:horizontal": {
                      width: 4 /* Width of horizontal scrollbar */,
                    },
                    // zIndex: "10",
                    height: "70vh",
                  }}
                >
                  <ClaimRegistration
                    callingFrom={"dashboard"}
                    claimId={claimId}
                    claimPracticeID={claimPracticeID}
                    CloseModal={handlecloseclaimopen}
                    Namee={patinetnameopenclaim}
                    patientId={patinetIdopenclaim}
                    applyRefresh={applyRefreshclaim}
                    callingFromRejection={callingFromRejection}
                    RejectedClaimErrors={RejectedClaimErrors}
                    style={{ height: "40vh" }}
                  ></ClaimRegistration>
                </Card>
                <ToastContainer
                  position="bottom-center"
                  autoClose={1500}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="light"
                />
              </Grid>
            </Box>
          </Modal>

          {/* //////ClaimClose/// */}
          <Grid container spacing={1}>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                gap: "4px",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <Grid
                item
                xs={5}
                sm={5}
                md={1.5}
                sx={{
                  display: "flex",
                  height: "27px",
                  mt: "10px",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  checked={isChecked}
                  onClick={() => setIsChecked((prev) => !prev)}
                  sx={{ mt: "20px" }}
                />
                <Typography
                  sx={{
                    ml: "10px",
                    mt: "15px",
                    fontWeight: "bold",
                    fontSize: { xs: "0.875rem", sm: "1rem" },
                  }}
                >
                  All Dates
                </Typography>
              </Grid>

              <Grid
                item
                xs={5}
                sm={5}
                md={2}
                sx={{
                  display: "flex",
                  height: "27px",
                  mt: "10px",
                  alignItems: "center",
                }}
              >
                {rights.Dashboard_All_Practices && (
                  <>
                    <Checkbox
                      value={isAllPractics}
                      sx={{ mt: "20px" }}
                      onChange={(e) => setisAllPractics(e.target.checked)}
                    />
                    <Typography
                      sx={{
                        ml: "10px",
                        mt: "10px",
                        fontWeight: "bold",
                        fontSize: { xs: "0.875rem", sm: "1rem" },
                      }}
                    >
                      All Practices
                    </Typography>
                  </>
                )}
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={3}>
                <Typography sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                  From Date
                </Typography>
                <Controller
                  name="fromDate"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      size="small"
                      type="date"
                      disabled={isChecked}
                      {...field}
                      fullWidth
                      value={fromDate}
                      onChange={(e) => {
                        setValue("fromDate", e.target.value);
                        setfromDate(e.target.value);
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={3}>
                <Typography sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}>
                  To Date
                </Typography>
                <Controller
                  name="toDate"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      size="small"
                      type="date"
                      disabled={isChecked}
                      {...field}
                      fullWidth
                      value={toDate}
                      onChange={(e) => {
                        setValue("toDate", e.target.value);
                        settoDate(e.target.value);
                      }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <Button
                  className="Button"
                  variant="contained"
                  onClick={onFilterSearch}
                  fullWidth
                  sx={{
                    float: "right",
                    height: "35px",
                    mt: "25px",
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    color: "white",
                    bgcolor: "#004cab",
                    "&:hover": { bgcolor: "#003a8c" },
                  }}
                >
                  <SearchOutlinedIcon
                    fontSize="medium"
                    sx={{ color: "white", pb: "1px" }}
                  />
                  Search
                </Button>
              </Grid>
            </Grid>
          </Grid>

          <div>
            {isLoading ? (
              <div style={{ margin: "15rem", textAlign: "center" }}>
                <CircularProgress />
              </div>
            ) : (
              <>
                <Container fluid={true}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        marginTop: "5px",
                        gap: "10px",
                        justifyContent: "center",
                        display: "flex",
                      }}
                    >
                      {HideData && (
                        <Grid
                          item
                          md={6}
                          lg={6}
                          xs={12}
                          sm={12}
                          sx={{
                            border: "2px solid #377562",
                            p: { xs: 1, sm: 2 },
                            borderRadius: "15px",
                            maxWidth: "100%",
                          }}
                        >
                          {rows === null || rows.length === 0 ? (
                            <Typography>No Record found</Typography>
                          ) : (
                            <>
                              <Typography
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  backgroundColor: "#377562",
                                  color: "white",
                                  textAlign: "center",
                                  borderRadius: "15px",
                                }}
                              >
                                Authorization
                              </Typography>
                              {labelData.map((labelObj) => (
                                <Box
                                  key={labelObj.label}
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                  style={{
                                    marginTop: "3px",
                                  }}
                                >
                                  <div
                                    onClick={() =>
                                      handleLabelClick(labelObj.label)
                                    }
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      backgroundColor: labelObj.color,
                                      marginRight: "10px",
                                    }}
                                  ></div>
                                  {labelObj.label !==
                                  `Total Records (${totalRecords})` ? (
                                    <Typography
                                      style={{
                                        cursor: "pointer",
                                        display: "block",
                                        borderRadius: "5px",
                                      }}
                                      onClick={() =>
                                        handleLabelClick(labelObj.label)
                                      }
                                    >
                                      {labelObj.label}
                                    </Typography>
                                  ) : (
                                    <Typography>{labelObj.label}</Typography>
                                  )}
                                </Box>
                              ))}
                            </>
                          )}
                        </Grid>
                      )}
                      {HideData && (
                        <Grid
                          item
                          md={6}
                          lg={6}
                          xs={12}
                          sm={12}
                          style={{
                            border: "2px solid #377562",
                            padding: "10px",
                            borderRadius: "15px",
                          }}
                        >
                          {rows1 === null || rows1.length === 0 ? (
                            <Typography>No Record found</Typography>
                          ) : (
                            <>
                              <Typography
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  backgroundColor: "#377562",
                                  color: "white",
                                  textAlign: "center",
                                  borderRadius: "15px",
                                }}
                              >
                                Claims
                              </Typography>

                              {labelData1.map((labelObj1) => (
                                <Box
                                  key={labelObj1.label}
                                  display="flex"
                                  alignItems="center"
                                  mb={1}
                                  style={{
                                    marginTop: "3px",
                                  }}
                                >
                                  <div
                                    onClick={() =>
                                      handleLabelClick1(labelObj1.label)
                                    }
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      backgroundColor: labelObj1.color,
                                      marginRight: "10px",
                                    }}
                                  ></div>
                                  <Typography
                                    style={{
                                      cursor: "pointer",
                                      display: "block",
                                      borderRadius: "5px",
                                    }}
                                    onClick={() =>
                                      handleLabelClick1(labelObj1.label)
                                    }
                                  >
                                    {labelObj1.label}
                                  </Typography>
                                </Box>
                              ))}
                            </>
                          )}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  <Grid container spacing={1} style={{ marginTop: "5px" }}>
                    {AuthsFormLoading ? (
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "40vh", // Full vertical height
                          width: "100%", // Full width
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    ) : (
                      <>
                        <Grid item xs={12} sm={6} md={3} lg={3}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Typography
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  color: "black",
                                  whiteSpace: "nowrap",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  // backgroundColor: '#90EE90',
                                  padding: "2px 4px",
                                  borderRadius: "2px",
                                }}
                              >
                                {/* Alert-Message */}
                                Completed Prior-auth/VOB{" "}
                                <span
                                  style={{
                                    color: "#1976d2",
                                    fontWeight: "700",
                                  }}
                                >
                                  ({approved1})
                                </span>
                              </Typography>
                            </Grid>
                          </Grid>
                          <Paper
                            variant="outlined"
                            square
                            style={{
                              backgroundColor: "#F0F6F8",
                              borderRadius: "15px",
                              marginTop: "5px",
                              borderColor: "#377562",
                              maxWidth: "100%",
                              padding: ".5rem",
                              marginBottom: "0.3rem",
                              marginLeft: "0 .2rem",
                              height: "300px",
                              overflow: "auto",
                              /* Other styles */
                              scrollbarWidth: "thin", // For Firefox
                              scrollbarColor: "#377562 transparent", // thumb color and track color
                              "&::-webkit-scrollbar": {
                                width: 8 /* Width of vertical scrollbar */,
                                height: 8 /* Height of horizontal scrollbar */,
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor:
                                  "#377562" /* Color of the thumb */,
                                borderRadius: 10,
                              },
                              "&::-webkit-scrollbar-track": {
                                backgroundColor:
                                  "transparent" /* Color of the track */,
                              },
                              /* Adjust the width for the horizontal scrollbar */
                              "&::-webkit-scrollbar-thumb:horizontal": {
                                width: 4 /* Width of horizontal scrollbar */,
                              },
                              // zIndex: "10",
                            }}
                          >
                            {approvedNotification != null &&
                            approvedNotification.length > 0
                              ? approvedNotification.map((row, index) => {
                                  const isRowExpanded = expandedRowId === index;
                                  return (
                                    <Paper
                                      variant="outlined"
                                      square
                                      style={{
                                        backgroundColor: "white",
                                        borderRadius: "10px",
                                        // marginTop: '3px',
                                        borderColor: "#377562",
                                        maxWidth: "100%",
                                        padding: ".3rem",
                                        marginBottom: "0.3rem",
                                        marginLeft: "0 .2rem",
                                      }}
                                    >
                                      <Grid container>
                                        <Grid item xs={1.5}>
                                          <Avatar
                                            sx={{
                                              width: 22,
                                              height: 22,
                                              bgcolor: "#3C7F6B",
                                            }}
                                          >
                                            {row.PatientName?.charAt(
                                              0
                                            ).toUpperCase()}
                                          </Avatar>
                                        </Grid>
                                        <Grid item xs={9.3}>
                                          <Typography
                                            style={{
                                              color: "black",
                                              fontSize: "14px",
                                            }}
                                            onClick={() => {
                                              handleToggleExpansion(null);
                                            }}
                                          >
                                            <b>{row.PatientName}</b>
                                            {row.unApproved ? (
                                              <CancelIcon
                                                fontSize="small"
                                                style={{
                                                  color: "red",
                                                  marginLeft: 6,
                                                }}
                                                titleAccess="Unapproved"
                                              />
                                            ) : (
                                              <CheckCircleIcon
                                                fontSize="small"
                                                style={{
                                                  color: "green",
                                                  marginLeft: 6,
                                                }}
                                                titleAccess="Approved"
                                              />
                                            )}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={1}>
                                          {isRowExpanded ? (
                                            <>
                                              <ExpandLessIcon
                                                onClick={() =>
                                                  handleToggleExpansion(index)
                                                }
                                                fontSize="medium"
                                                style={{
                                                  color: "black",
                                                  paddingRight: "5px",
                                                  paddingBottom: "2px",
                                                }}
                                              ></ExpandLessIcon>
                                            </>
                                          ) : (
                                            <>
                                              <ExpandMoreIcon
                                                onClick={() =>
                                                  handleToggleExpansion(index)
                                                }
                                                fontSize="medium"
                                                style={{
                                                  color: "black",
                                                  paddingRight: "5px",
                                                  paddingBottom: "2px",
                                                }}
                                              ></ExpandMoreIcon>
                                            </>
                                          )}
                                        </Grid>

                                        <Grid container>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                marginTop: "1px",
                                              }}
                                            >
                                              <b>ID:</b> {row.AuthId}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <b>Submitted:</b>{" "}
                                              {row.PriorAuthSubmitted
                                                ? new Date(
                                                    row.PriorAuthSubmitted
                                                  ).toLocaleDateString("en-US")
                                                : ""}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                marginTop: "1px",
                                              }}
                                            >
                                              <b>Code:</b> {row.CPTCharges}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <b>Worked:</b>{" "}
                                              {row.UpdatedDate
                                                ? new Date(
                                                    row.UpdatedDate
                                                  ).toLocaleDateString("en-US")
                                                : ""}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={8}>
                                            <Typography
                                              style={{
                                                color: "green",
                                                fontSize: "13px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {" "}
                                              <b>{row.PracticeName}</b>{" "}
                                            </Typography>
                                          </Grid>
                                        </Grid>

                                        <Grid container spacing={1}>
                                          {isRowExpanded && (
                                            <Grid container spacing={1}>
                                              {/* <Grid item xs={2}>
                      <Typography style={{fontWeight:'bold',color:'black',fontSize:'14px',marginLeft:'15px',marginTop:'5px'}}>Comments:</Typography>

                      </Grid>
                      <Grid item xs={10}>
                      <Typography style={{color:'black',fontSize:'14px',marginLeft:'15px',marginTop:'5px'}}>{row.comments}</Typography>

                      </Grid> */}
                                              <Grid item xs={9}></Grid>
                                                   <Tooltip
                                            // title="Completed VOBs are locked for Front Office🔒">
                                         title={
    !rights?.Dashboard_Lock_Completed_VOBs
      ? "Completed VOBs are locked🔒"
      : ""
  }>
                                              <Grid item xs={3}>
                                              <span>
                                                <Button
                                                  style={{
                                                    backgroundColor: "green",
                                                    color: "white",
                                                    float: "right",
                                                    width: "120px",
                                                    height: "28px",
                                                    marginTop: "5px",
                                                    marginRight: "25px",
                                                      opacity: !rights?.Dashboard_Lock_Completed_VOBs ? 0.6 : 1,
                                                  }}
                                                  size="small"
                                                   disabled={!rights?.Dashboard_Lock_Completed_VOBs}
                                                  onClick={() => {
                                                    setauthId(row.AuthId);
                                                    setpatinetIdopenauth(
                                                      row.PatientId
                                                    );
                                                    setpatinetnameopenauth(
                                                      row.PatientName
                                                    );
                                                    setPatienTdemoGraphiceId(
                                                      row.PatientId
                                                    );
                                                    setMarkaporovedopenauth(
                                                      row.Approved
                                                    );
                                                    setPriorPracticeID(
                                                      row.PracticeId
                                                    );
                                                    setUnapprovedButton(
                                                      row.unApproved
                                                    );
                                                    setSource(row.Source);
                                                    setCharge1(row.CPTCharges);
                                                    setQuetionare(
                                                      row.Questionnaire
                                                    );
                                                    setLomn(row.LOMN);
                                                    handleapprove();
                                                  }}
                                                >
                                                  <Typography
                                                    fontSize="small"
                                                    style={{ color: "#fff" }}
                                                  >
                                                    Open Auth
                                                  </Typography>
                                                </Button>
                                                </span>
                                              </Grid>
                                                </Tooltip>
                                              {/* <Grid item xs={2} >
                                      <Button
                                       className='Button'
                                        onClick={() => {
                                          setselectedRow(row.id)
                                          setselectedindex(index)
                                          setResolve(row.id)
                                        }}
                                        variant='gradient'
                                        style={{
                                          marginBottom: '10px',
                                          float: 'right',
                                          width: '87px',
                                          height: '28px',
                                          backgroundColor: '#56CA00',
                                          color: 'white',
                                          fontSize: '12px',
                                          marginTop:'5px'
                                        }}
                                      >
                                         
                                        Resolve
                                      </Button>
                                    </Grid> */}

                                              {row.id === Resolve ? (
                                                <>
                                                  <Box
                                                    mb={2}
                                                    sx={{
                                                      marginBottom: "10px",

                                                      marginTop: "15px",
                                                      marginLeft: "10px",
                                                    }}
                                                  >
                                                    <Grid
                                                      container
                                                      columnSpacing={1}
                                                    >
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        style={{
                                                          fontWeight: 500,
                                                        }}
                                                      >
                                                        <Typography
                                                          style={{
                                                            fontWeight: "bold",
                                                            color: "black",
                                                            fontSize: "14px",
                                                            marginLeft: "15px",
                                                          }}
                                                        >
                                                          Resolve Comments:
                                                        </Typography>
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        style={{
                                                          marginLeft: "15px",
                                                        }}
                                                      >
                                                        <Controller
                                                          name="resolvedComments"
                                                          {...register(
                                                            "resolvedComments"
                                                          )}
                                                          control={control}
                                                          render={({
                                                            field,
                                                          }) => (
                                                            <TextareaAutosize
                                                              reset
                                                              aria-label="minimum height"
                                                              minRows={5}
                                                              placeholder="Enter comments"
                                                              style={{
                                                                width: "100%",
                                                                height: "100px",
                                                                borderRadius:
                                                                  "8px",
                                                                border:
                                                                  "2px solid #black",
                                                                overflow:
                                                                  "auto",
                                                              }}
                                                              // {...field}
                                                              fullWidth
                                                            />
                                                          )}
                                                        />
                                                        <p
                                                          style={{
                                                            color: "red",
                                                            fontSize: "14px",
                                                          }}
                                                        >
                                                          {
                                                            errors
                                                              .resolvedComments
                                                              ?.message
                                                          }
                                                        </p>
                                                      </Grid>
                                                      <Grid item xs={3}>
                                                        <Typography
                                                          style={{
                                                            fontWeight: "bold",
                                                            color: "black",
                                                            fontSize: "14px",
                                                            marginLeft: "15px",
                                                            marginTop: "-5px",
                                                          }}
                                                        >
                                                          Resolve Date:
                                                        </Typography>
                                                      </Grid>

                                                      <Grid
                                                        item
                                                        xs={6}
                                                        style={{
                                                          marginLeft: "15px",
                                                        }}
                                                      >
                                                        <Controller
                                                          name="completedDate"
                                                          {...register("date")}
                                                          control={control}
                                                          render={({
                                                            field,
                                                          }) => (
                                                            <TextField
                                                              type="date"
                                                              size="small"
                                                              fullWidth
                                                              {...field}
                                                              placeholder="Enter resolve date"
                                                              // value={completedDate}
                                                              onChange={(e) => {
                                                                setValue(
                                                                  "resolvedDate",
                                                                  e.target.value
                                                                );
                                                                // setcompletedDate(e.target.value)
                                                                // setcompeleterror(false)
                                                              }}
                                                            />
                                                          )}
                                                        />
                                                        {/* {compeleterror ? (
                                              <p style={errorMesage}>Please select Compelete Date</p>
                                            ) : null} */}
                                                        {errorMessage && (
                                                          <p
                                                            style={{
                                                              color: "red",
                                                            }}
                                                          >
                                                            Please Select Date
                                                          </p>
                                                        )}
                                                      </Grid>
                                                      <Grid item xs={8}></Grid>
                                                      <Grid item xs={2}>
                                                        <Button
                                                          className="Button"
                                                          onClick={handleSubmit(
                                                            saveData
                                                          )}
                                                          variant="gradient"
                                                          style={{
                                                            marginTop: "15px",
                                                            marginBottom:
                                                              "10px",
                                                            float: "right",
                                                            width: "87px",
                                                            height: "28px",
                                                            // backgroundColor: '#56CA00',
                                                            color: "white",
                                                            fontSize: "12px",
                                                            marginRight: "30px",
                                                          }}
                                                          // disabled={submitting}
                                                        >
                                                          <SaveOutlinedIcon
                                                            fontSize="medium"
                                                            style={{
                                                              color: "white",
                                                              paddingRight:
                                                                "5px",
                                                              paddingBottom:
                                                                "2px",
                                                            }}
                                                          ></SaveOutlinedIcon>
                                                          Save
                                                        </Button>
                                                      </Grid>

                                                      <Grid item xs={2}>
                                                        <Button
                                                          className="Button"
                                                          onClick={() => {
                                                            setResolve(null);
                                                          }}
                                                          variant="gradient"
                                                          style={{
                                                            marginTop: "15px",
                                                            marginBottom:
                                                              "10px",
                                                            float: "right",
                                                            width: "87px",
                                                            height: "28px",
                                                            backgroundColor:
                                                              "#56CA00",
                                                            color: "white",
                                                            fontSize: "12px",
                                                            marginRight: "18px",
                                                          }}
                                                        >
                                                          <CancelOutlinedIcon
                                                            fontSize="medium"
                                                            style={{
                                                              color: "white",
                                                              paddingRight:
                                                                "5px",
                                                              paddingBottom:
                                                                "2px",
                                                            }}
                                                          ></CancelOutlinedIcon>
                                                          Cancel
                                                        </Button>
                                                      </Grid>
                                                    </Grid>
                                                  </Box>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </Grid>
                                          )}
                                          {/* {row.id === id ? (
                            <>
                          
                            
                            </>):(<></>)} */}
                                        </Grid>
                                      </Grid>
                                    </Paper>
                                  );
                                })
                              : "No Record Found"}
                          </Paper>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={3}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Typography
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  color: "black",
                                  whiteSpace: "nowrap",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  // backgroundColor: '#CBC3E3',  // Light orange highlighter color
                                  padding: "2px 4px", // Add padding for better highlight effect
                                  borderRadius: "2px",
                                }}
                              >
                                {/* Alert-Message Requested/ */}
                                Pending Further Reviews VOBs
                                <span
                                  style={{
                                    color: "#1976d2",
                                    fontWeight: "700",
                                  }}
                                >
                                  ({processRequest})
                                </span>{" "}
                              </Typography>
                            </Grid>
                            {/* <Grid item xs={1}>

                          <CachedOutlinedIcon
                            onClick={event => {
                              applyRefreshapprove()
                            }}
                            fontSize='medium'
                            style={{
                              color: '#356F60',
                              //  marginRight: '-25px',
                              paddingRight: '0px',
                              paddingBottom: '1px'
                            }}
                          ></CachedOutlinedIcon>

                        </Grid> */}
                          </Grid>
                          <Paper
                            variant="outlined"
                            square
                            style={{
                              backgroundColor: "#F0F6F8",
                              borderRadius: "15px",
                              marginTop: "5px",
                              borderColor: "#377562",
                              maxWidth: "100%",
                              padding: ".5rem",
                              marginBottom: "0.3rem",
                              marginLeft: "0 .2rem",
                              height: "300px",
                              overflow: "auto",
                              /* Other styles */
                              scrollbarWidth: "thin", // For Firefox
                              scrollbarColor: "purple transparent", // thumb color and track color
                              "&::-webkit-scrollbar": {
                                width: 8 /* Width of vertical scrollbar */,
                                height: 8 /* Height of horizontal scrollbar */,
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor:
                                  "purple" /* Color of the thumb */,
                                borderRadius: 10,
                              },
                              "&::-webkit-scrollbar-track": {
                                backgroundColor:
                                  "transparent" /* Color of the track */,
                              },
                              /* Adjust the width for the horizontal scrollbar */
                              "&::-webkit-scrollbar-thumb:horizontal": {
                                width: 4 /* Width of horizontal scrollbar */,
                              },
                              // zIndex: "10",
                            }}
                          >
                            {processingNotification != null &&
                            processingNotification.length > 0
                              ? processingNotification.map((row, index) => {
                                  const isRowExpanded =
                                    pendingRequestRowIndex === index;
                                  return (
                                    <Paper
                                      variant="outlined"
                                      square
                                      style={{
                                        backgroundColor: "white",
                                        borderRadius: "10px",
                                        // marginTop: '5px',
                                        borderColor:
                                          row.statusColor === "Red"
                                            ? "red"
                                            : row.statusColor === "purple"
                                            ? "purple"
                                            : row.statusColor === "orange"
                                            ? "orange"
                                            : "green",
                                        maxWidth: "100%",
                                        padding: ".3rem",
                                        marginBottom: "0.3rem",
                                        marginLeft: "0 .2rem",
                                      }}
                                    >
                                      <Grid container>
                                        <Grid item xs={1.5}>
                                          <Avatar
                                            sx={{
                                              width: 22,
                                              height: 22,
                                              bgcolor:
                                                row.statusColor === "Red"
                                                  ? "red"
                                                  : row.statusColor === "purple"
                                                  ? "purple"
                                                  : row.statusColor === "orange"
                                                  ? "orange"
                                                  : "green",
                                            }}
                                          >
                                            {row.patientName
                                              ?.charAt(0)
                                              .toUpperCase()}
                                          </Avatar>
                                        </Grid>
                                        <Grid item xs={9.3}>
                                          <Typography
                                            style={{
                                              color: "black",
                                              fontSize: "14px",
                                            }}
                                            onClick={() =>
                                              handleToggleExpansionPedningRequest(
                                                index
                                              )
                                            }
                                          >
                                            <b>{row.patientName} </b>
                                            {/* Authorization Request Submitted */}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={1}>
                                          {isRowExpanded ? (
                                            <>
                                              <ExpandLessIcon
                                                onClick={() => {
                                                  handleToggleExpansionPedningRequest(
                                                    index
                                                  );
                                                }}
                                                fontSize="medium"
                                                style={{
                                                  color: "black",
                                                  paddingRight: "5px",
                                                  paddingBottom: "2px",
                                                }}
                                              ></ExpandLessIcon>
                                            </>
                                          ) : (
                                            <>
                                              <ExpandMoreIcon
                                                onClick={() => {
                                                  handleToggleExpansionPedningRequest(
                                                    index
                                                  );
                                                }}
                                                fontSize="medium"
                                                style={{
                                                  color: "black",
                                                  paddingRight: "5px",
                                                  paddingBottom: "2px",
                                                }}
                                              ></ExpandMoreIcon>
                                            </>
                                          )}
                                        </Grid>
                                        <Grid container>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                marginTop: "1px",
                                              }}
                                            >
                                              <b>ID:</b> {row.authId}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <b>Submitted:</b>{" "}
                                              {row.priorAuthSubmitted
                                                ? new Date(
                                                    row.priorAuthSubmitted
                                                  ).toLocaleDateString("en-US")
                                                : ""}
                                                
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                marginTop: "1px",
                                              }}
                                            >
                                              <b>Code:</b> {row.cptCharges}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <b>Worked:</b>{" "}
                                              {row.updatedDate
                                                ? new Date(
                                                    row.updatedDate
                                                  ).toLocaleDateString("en-US")
                                                : ""}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={8}>
                                            <Typography
                                              style={{
                                                color:
                                                  row.statusColor === "Red"
                                                    ? "red"
                                                    : row.statusColor ===
                                                      "purple"
                                                    ? "purple"
                                                    : row.statusColor ===
                                                      "orange"
                                                    ? "orange"
                                                    : "green",
                                                fontSize: "13px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {" "}
                                              <b>{row.practiceName}</b>{" "}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                        {isRowExpanded && (
                                          <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                              <Button
                                                style={{
                                                  backgroundColor:
                                                    row.statusColor === "Red"
                                                      ? "red"
                                                      : row.statusColor ===
                                                        "purple"
                                                      ? "purple"
                                                      : row.statusColor ===
                                                        "orange"
                                                      ? "orange"
                                                      : "green",
                                                  color: "#fff",
                                                  float: "right",
                                                  width: "180px",
                                                  height: "28px",
                                                  marginTop: "5px",
                                                  fontWeight: "bold",
                                                  // marginRight: '30px'
                                                }}
                                                size="small"
                                                onClick={() => {
                                                  // handleOpens()
                                                  setauthId2(row.authId);
                                                  setauthIdcpt(row.authCPTId);
                                                  setPriorPracticeID(
                                                    row.practiceId
                                                  );
                                                  setpatinetIdopenauth1(
                                                    row.patientId
                                                  );
                                                  setpatinetnameopenauth1(
                                                    row.patientName
                                                  );
                                                  setPatienTdemoGraphiceId(
                                                    row.patientId
                                                  );
                                                  setSource(row.source);
                                                  setCharge1(row.cptCharges);
                                                  setQuetionare(
                                                    row.questionnaire
                                                  );
                                                  setLomn(row.lomn);
                                                  handleluxbillingpending();
                                                }}
                                              >
                                                <Typography
                                                  fontSize="small"
                                                  style={{ color: "#fff" }}
                                                >
                                                  Open Auth Request
                                                </Typography>
                                              </Button>
                                            </Grid>
                                            <Grid item xs={2}></Grid>

                                            {row.id === Resolve ? (
                                              <>
                                                <Box
                                                  mb={2}
                                                  sx={{
                                                    marginBottom: "10px",

                                                    marginTop: "15px",
                                                    marginLeft: "10px",
                                                  }}
                                                >
                                                  <Grid
                                                    container
                                                    columnSpacing={1}
                                                  >
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      style={{
                                                        fontWeight: 500,
                                                      }}
                                                    >
                                                      <Typography
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "black",
                                                          fontSize: "14px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        Resolve Comments:
                                                      </Typography>
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <Controller
                                                        name="resolvedComments"
                                                        {...register(
                                                          "resolvedComments"
                                                        )}
                                                        control={control}
                                                        render={({ field }) => (
                                                          <TextareaAutosize
                                                            reset
                                                            aria-label="minimum height"
                                                            minRows={1}
                                                            placeholder="Enter comments"
                                                            style={{
                                                              width: "100%",
                                                              height: "100px",
                                                              borderRadius:
                                                                "8px",
                                                              border:
                                                                "2px solid #black",
                                                              overflow: "auto",
                                                            }}
                                                            onChange={(e) => {
                                                              setValue(
                                                                "resolvedComments",
                                                                e.target.value
                                                              );
                                                            }}
                                                            fullWidth
                                                          />
                                                        )}
                                                      />
                                                      <p
                                                        style={{
                                                          color: "red",
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        {
                                                          errors
                                                            .resolvedComments
                                                            ?.message
                                                        }
                                                      </p>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                      <Typography
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "black",
                                                          fontSize: "14px",
                                                          marginLeft: "5px",
                                                          marginTop: "-5px",
                                                        }}
                                                      >
                                                        Resolve Date:
                                                      </Typography>
                                                    </Grid>

                                                    <Grid
                                                      item
                                                      xs={9}
                                                      style={{
                                                        marginTop: "-5px",
                                                      }}
                                                    >
                                                      <Controller
                                                        name="completedDate"
                                                        {...register("date")}
                                                        control={control}
                                                        render={({ field }) => (
                                                          <TextField
                                                            type="date"
                                                            size="small"
                                                            fullWidth
                                                            {...field}
                                                            placeholder="Enter resolve date"
                                                            onChange={(e) => {
                                                              setValue(
                                                                "resolvedDate",
                                                                e.target.value
                                                              );
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                      {errorMessage && (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          Please Select Date
                                                        </p>
                                                      )}
                                                    </Grid>
                                                    <Grid item xs={8}></Grid>
                                                    <Grid item xs={2}>
                                                      <Button
                                                        className="Button"
                                                        onClick={handleSubmit(
                                                          saveData
                                                        )}
                                                        variant="gradient"
                                                        style={{
                                                          marginTop: "15px",
                                                          marginBottom: "10px",
                                                          float: "right",
                                                          width: "87px",
                                                          height: "28px",

                                                          color: "white",
                                                          fontSize: "12px",
                                                          marginRight: "50px",
                                                        }}
                                                      >
                                                        <SaveOutlinedIcon
                                                          fontSize="medium"
                                                          style={{
                                                            color: "white",
                                                            paddingRight: "5px",
                                                            paddingBottom:
                                                              "2px",
                                                          }}
                                                        ></SaveOutlinedIcon>
                                                        Save
                                                      </Button>
                                                    </Grid>

                                                    <Grid item xs={2}>
                                                      <Button
                                                        className="Button"
                                                        onClick={() => {
                                                          setResolve(null);
                                                        }}
                                                        variant="gradient"
                                                        style={{
                                                          marginTop: "15px",
                                                          marginBottom: "10px",
                                                          float: "right",
                                                          width: "87px",
                                                          height: "28px",
                                                          backgroundColor:
                                                            "#56CA00",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          marginRight: "18px",
                                                        }}
                                                      >
                                                        <CancelOutlinedIcon
                                                          fontSize="medium"
                                                          style={{
                                                            color: "white",
                                                            paddingRight: "5px",
                                                            paddingBottom:
                                                              "2px",
                                                          }}
                                                        ></CancelOutlinedIcon>
                                                        Cancel
                                                      </Button>
                                                    </Grid>
                                                  </Grid>
                                                </Box>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </Grid>
                                        )}
                                        {/* <Grid container style={{ fontWeight: 500 }}>

                              {row.id === id1 ? (<>
                               
                       
                              
                              </>):(<></>)}
                                </Grid>     */}
                                      </Grid>
                                    </Paper>
                                  );
                                })
                              : "No Record Found"}
                          </Paper>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={3}>
                          <Grid container spacing={1}>
                            <Grid item xs={12}>
                              <Typography
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "bold",
                                  color: "black",
                                  whiteSpace: "nowrap",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  marginLeft: "20px",
                                  // backgroundColor: '#FFD580',
                                  padding: "2px 4px",
                                  borderRadius: "2px",
                                }}
                              >
                                {/* Alert-Message Requested/ */}
                                Pending Prior-auth/VOB{" "}
                                <span
                                  style={{
                                    color: "#1976d2",
                                    fontWeight: "700",
                                  }}
                                >
                                  ({Pendingrequests})
                                </span>{" "}
                              </Typography>
                            </Grid>
                            {/* <Grid item xs={1}>

                          <CachedOutlinedIcon
                            onClick={event => {
                              applyRefreshapprove()
                            }}
                            fontSize='medium'
                            style={{
                              color: '#356F60',
                              //  marginRight: '-25px',
                              paddingRight: '0px',
                              paddingBottom: '1px'
                            }}
                          ></CachedOutlinedIcon>

                        </Grid> */}
                          </Grid>
                          <Paper
                            variant="outlined"
                            square
                            style={{
                              backgroundColor: "#F0F6F8",
                              borderRadius: "15px",
                              marginTop: "5px",
                              borderColor: "#377562",
                              maxWidth: "100%",
                              padding: ".5rem",
                              marginBottom: "0.3rem",
                              marginLeft: "0 .2rem",
                              height: "300px",
                              overflow: "auto",
                              /* Other styles */
                              scrollbarWidth: "thin", // For Firefox
                              scrollbarColor: "orange transparent", // thumb color and track color
                              "&::-webkit-scrollbar": {
                                width: 8 /* Width of vertical scrollbar */,
                                height: 8 /* Height of horizontal scrollbar */,
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor:
                                  "orange" /* Color of the thumb */,
                                borderRadius: 10,
                              },
                              "&::-webkit-scrollbar-track": {
                                backgroundColor:
                                  "transparent" /* Color of the track */,
                              },
                              /* Adjust the width for the horizontal scrollbar */
                              "&::-webkit-scrollbar-thumb:horizontal": {
                                width: 4 /* Width of horizontal scrollbar */,
                              },
                              // zIndex: "10",
                            }}
                          >
                            {nonapprovedNotification != null &&
                            nonapprovedNotification.length > 0
                              ? nonapprovedNotification.map((row, index) => {
                                  const isRowExpanded =
                                    expandedRowIndex === index;
                                  return (
                                    <Paper
                                      variant="outlined"
                                      square
                                      style={{
                                        backgroundColor: "white",
                                        borderRadius: "10px",
                                        // marginTop: '5px',
                                        borderColor:
                                          row.statusColor === "Red"
                                            ? "red"
                                            : row.statusColor === "purple"
                                            ? "purple"
                                            : row.statusColor === "orange"
                                            ? "orange"
                                            : "green",
                                        maxWidth: "100%",
                                        padding: ".3rem",
                                        marginBottom: "0.3rem",
                                        marginLeft: "0 .2rem",
                                      }}
                                    >
                                      <Grid container>
                                        <Grid item xs={1.5}>
                                          <Avatar
                                            sx={{
                                              width: 22,
                                              height: 22,
                                              bgcolor:
                                                row.statusColor === "Red"
                                                  ? "red"
                                                  : row.statusColor === "purple"
                                                  ? "purple"
                                                  : row.statusColor === "orange"
                                                  ? "orange"
                                                  : "green",
                                            }}
                                          >
                                            {row.patientName
                                              ?.charAt(0)
                                              .toUpperCase()}
                                          </Avatar>
                                        </Grid>
                                        <Grid item xs={9.3}>
                                          <Typography
                                            style={{
                                              color: "black",
                                              fontSize: "14px",
                                            }}
                                            onClick={() =>
                                              handleToggleExpansion1(index)
                                            }
                                          >
                                            <b>{row.patientName} </b>
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={1}>
                                          {isRowExpanded ? (
                                            <>
                                              <ExpandLessIcon
                                                onClick={() => {
                                                  handleToggleExpansion1(index);
                                                }}
                                                fontSize="medium"
                                                style={{
                                                  color: "black",
                                                  paddingRight: "5px",
                                                  paddingBottom: "2px",
                                                }}
                                              ></ExpandLessIcon>
                                            </>
                                          ) : (
                                            <>
                                              <ExpandMoreIcon
                                                onClick={() => {
                                                  handleToggleExpansion1(index);
                                                }}
                                                fontSize="medium"
                                                style={{
                                                  color: "black",
                                                  paddingRight: "5px",
                                                  paddingBottom: "2px",
                                                }}
                                              ></ExpandMoreIcon>
                                            </>
                                          )}
                                        </Grid>
                                        <Grid container>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                marginTop: "1px",
                                              }}
                                            >
                                              <b>ID:</b> {row.authId}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <b>Submitted:</b>{" "}
                                              {row.priorAuthSubmitted
                                                ? new Date(
                                                    row.priorAuthSubmitted
                                                  ).toLocaleDateString("en-US")
                                                : ""}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                marginTop: "1px",
                                              }}
                                            >
                                              <b>Code:</b> {row.cptCharges}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <b>Worked:</b>{" "}
                                              {row.updatedDate
                                                ? new Date(
                                                    row.updatedDate
                                                  ).toLocaleDateString("en-US")
                                                : ""}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={8}>
                                            <Typography
                                              style={{
                                                color:
                                                  row.statusColor === "Red"
                                                    ? "red"
                                                    : row.statusColor ===
                                                      "purple"
                                                    ? "purple"
                                                    : row.statusColor ===
                                                      "orange"
                                                    ? "orange"
                                                    : "green",
                                                fontSize: "13px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {" "}
                                              <b>{row.practiceName}</b>{" "}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                        {isRowExpanded && (
                                          <Grid container spacing={1}>
                                            {/* <Grid item xs={2}>
                        <Typography style={{fontWeight:'bold',color:'black',fontSize:'14px',marginLeft:'5px'}}>Comments:</Typography>
  
                        </Grid>
                        <Grid item xs={10}>
                        <Typography style={{color:'black',fontSize:'14px',marginLeft:'15px'}}>{row.comments}</Typography>
  
                        </Grid> */}

                                            <Grid item xs={12}>
                                              <Button
                                                style={{
                                                  backgroundColor:
                                                    row.statusColor === "Red"
                                                      ? "red"
                                                      : row.statusColor ===
                                                        "purple"
                                                      ? "purple"
                                                      : row.statusColor ===
                                                        "orange"
                                                      ? "orange"
                                                      : "green",
                                                  color: "#fff",
                                                  float: "right",
                                                  width: "180px",
                                                  height: "28px",
                                                  marginTop: "5px",
                                                  fontWeight: "bold",
                                                  // marginRight: '30px'
                                                }}
                                                size="small"
                                                onClick={() => {
                                                  // handleOpens()
                                                  setauthId2(row.authId);
                                                  setauthIdcpt(row.authCPTId);
                                                  setPriorPracticeID(
                                                    row.practiceId
                                                  );
                                                  setpatinetIdopenauth1(
                                                    row.patientId
                                                  );
                                                  setpatinetnameopenauth1(
                                                    row.patientName
                                                  );
                                                  setPatienTdemoGraphiceId(
                                                    row.patientId
                                                  );
                                                  setSource(row.source);
                                                  setQuetionare(
                                                    row.questionnaire
                                                  );
                                                  setCharge1(row.cptCharges);
                                                  setLomn(row.lomn);
                                                  handleluxbillingpending();
                                                }}
                                              >
                                                <Typography
                                                  fontSize="small"
                                                  style={{ color: "#fff" }}
                                                >
                                                  Open Auth Request
                                                </Typography>
                                              </Button>
                                            </Grid>
                                            <Grid item xs={2}>
                                              {/* <Button
                                       className='Button'
                                        onClick={() => {
                                          setselectedRow(row.id)
                                          setselectedindex(index)
                                          setResolve(row.id)
                                        }}
                                        variant='gradient'
                                        style={{
                                          marginBottom: '10px',
                                          float: 'right',
                                          width: '87px',
                                          height: '28px',
                                          backgroundColor: '#56CA00',
                                          color: 'white',
                                          fontSize: '12px',
                                          marginTop:'5px'
                                        }}
                                      >
                                        
                                        Resolve
                                      </Button> */}
                                            </Grid>

                                            {row.id === Resolve ? (
                                              <>
                                                <Box
                                                  mb={2}
                                                  sx={{
                                                    marginBottom: "10px",

                                                    marginTop: "15px",
                                                    marginLeft: "10px",
                                                  }}
                                                >
                                                  <Grid
                                                    container
                                                    columnSpacing={1}
                                                  >
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      style={{
                                                        fontWeight: 500,
                                                      }}
                                                    >
                                                      <Typography
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "black",
                                                          fontSize: "14px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        Resolve Comments:
                                                      </Typography>
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <Controller
                                                        name="resolvedComments"
                                                        {...register(
                                                          "resolvedComments"
                                                        )}
                                                        control={control}
                                                        render={({ field }) => (
                                                          <TextareaAutosize
                                                            reset
                                                            aria-label="minimum height"
                                                            minRows={1}
                                                            placeholder="Enter comments"
                                                            style={{
                                                              width: "100%",
                                                              height: "100px",
                                                              borderRadius:
                                                                "8px",
                                                              border:
                                                                "2px solid #black",
                                                              overflow: "auto",
                                                            }}
                                                            onChange={(e) => {
                                                              setValue(
                                                                "resolvedComments",
                                                                e.target.value
                                                              );
                                                            }}
                                                            fullWidth
                                                          />
                                                        )}
                                                      />
                                                      <p
                                                        style={{
                                                          color: "red",
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        {
                                                          errors
                                                            .resolvedComments
                                                            ?.message
                                                        }
                                                      </p>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                      <Typography
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "black",
                                                          fontSize: "14px",
                                                          marginLeft: "5px",
                                                          marginTop: "-5px",
                                                        }}
                                                      >
                                                        Resolve Date:
                                                      </Typography>
                                                    </Grid>

                                                    <Grid
                                                      item
                                                      xs={9}
                                                      style={{
                                                        marginTop: "-5px",
                                                      }}
                                                    >
                                                      <Controller
                                                        name="completedDate"
                                                        {...register("date")}
                                                        control={control}
                                                        render={({ field }) => (
                                                          <TextField
                                                            type="date"
                                                            size="small"
                                                            fullWidth
                                                            {...field}
                                                            placeholder="Enter resolve date"
                                                            onChange={(e) => {
                                                              setValue(
                                                                "resolvedDate",
                                                                e.target.value
                                                              );
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                      {errorMessage && (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          Please Select Date
                                                        </p>
                                                      )}
                                                    </Grid>
                                                    <Grid item xs={8}></Grid>
                                                    <Grid item xs={2}>
                                                      <Button
                                                        className="Button"
                                                        onClick={handleSubmit(
                                                          saveData
                                                        )}
                                                        variant="gradient"
                                                        style={{
                                                          marginTop: "15px",
                                                          marginBottom: "10px",
                                                          float: "right",
                                                          width: "87px",
                                                          height: "28px",

                                                          color: "white",
                                                          fontSize: "12px",
                                                          marginRight: "50px",
                                                        }}
                                                      >
                                                        <SaveOutlinedIcon
                                                          fontSize="medium"
                                                          style={{
                                                            color: "white",
                                                            paddingRight: "5px",
                                                            paddingBottom:
                                                              "2px",
                                                          }}
                                                        ></SaveOutlinedIcon>
                                                        Save
                                                      </Button>
                                                    </Grid>

                                                    <Grid item xs={2}>
                                                      <Button
                                                        className="Button"
                                                        onClick={() => {
                                                          setResolve(null);
                                                        }}
                                                        variant="gradient"
                                                        style={{
                                                          marginTop: "15px",
                                                          marginBottom: "10px",
                                                          float: "right",
                                                          width: "87px",
                                                          height: "28px",
                                                          backgroundColor:
                                                            "#56CA00",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          marginRight: "18px",
                                                        }}
                                                      >
                                                        <CancelOutlinedIcon
                                                          fontSize="medium"
                                                          style={{
                                                            color: "white",
                                                            paddingRight: "5px",
                                                            paddingBottom:
                                                              "2px",
                                                          }}
                                                        ></CancelOutlinedIcon>
                                                        Cancel
                                                      </Button>
                                                    </Grid>
                                                  </Grid>
                                                </Box>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </Grid>
                                        )}
                                        {/* <Grid container style={{ fontWeight: 500 }}>

                              {row.id === id1 ? (<>
                               
                       
                              
                              </>):(<></>)}
                                </Grid>     */}
                                      </Grid>
                                    </Paper>
                                  );
                                })
                              : "No Record Found"}
                          </Paper>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3} lg={3}>
                          <Grid container spacing={1}>
                            <Grid item xs={11}>
                              <Typography
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "bold",
                                  color: "black",
                                  whiteSpace: "nowrap",
                                  display: "inline-flex",
                                  marginLeft: "20px",
                                  alignItems: "center",
                                  // backgroundColor: '#FF474C',  // Light orange highlighter color
                                  padding: "2px 4px", // Add padding for better highlight effect
                                  borderRadius: "2px",
                                }}
                              >
                                {/* Alert-Message Requested/ */}
                                New Prior-auth/VOB{" "}
                                <span
                                  style={{
                                    color: "#1976d2",
                                    fontWeight: "700",
                                  }}
                                >
                                  ({newrequests})
                                </span>{" "}
                              </Typography>
                            </Grid>
                            <Grid item xs={1}>
                              <CachedOutlinedIcon
                                onClick={(event) => {
                                  applyRefreshapprove();
                                }}
                                fontSize="medium"
                                style={{
                                  color: "#356F60",
                                  //  marginRight: '-25px',
                                  paddingRight: "0px",
                                  paddingBottom: "1px",
                                }}
                              ></CachedOutlinedIcon>
                            </Grid>
                          </Grid>
                          <Paper
                            variant="outlined"
                            square
                            style={{
                              backgroundColor: "#F0F6F8",
                              borderRadius: "15px",
                              marginTop: "5px",
                              borderColor: "#377562",
                              maxWidth: "100%",
                              padding: ".5rem",
                              marginBottom: "0.3rem",
                              marginLeft: "0 .2rem",
                              height: "300px",
                              overflow: "auto",
                              /* Other styles */
                              scrollbarWidth: "thin", // For Firefox
                              scrollbarColor: "red transparent", // thumb color and track color
                              "&::-webkit-scrollbar": {
                                width: 8 /* Width of vertical scrollbar */,
                                height: 8 /* Height of horizontal scrollbar */,
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "red" /* Color of the thumb */,
                                borderRadius: 10,
                              },
                              "&::-webkit-scrollbar-track": {
                                backgroundColor:
                                  "transparent" /* Color of the track */,
                              },
                              /* Adjust the width for the horizontal scrollbar */
                              "&::-webkit-scrollbar-thumb:horizontal": {
                                width: 4 /* Width of horizontal scrollbar */,
                              },
                              // zIndex: "10",
                            }}
                          >
                            {NewNotification != null &&
                            NewNotification.length > 0
                              ? NewNotification.map((row, index) => {
                                  const isRowExpanded =
                                    NewRequestRowIndex === index;
                                  return (
                                    <Paper
                                      variant="outlined"
                                      square
                                      style={{
                                        backgroundColor: "white",
                                        borderRadius: "10px",
                                        // marginTop: '5px',
                                        borderColor:
                                          row.statusColor === "Red"
                                            ? "red"
                                            : row.statusColor === "purple"
                                            ? "purple"
                                            : row.statusColor === "orange"
                                            ? "orange"
                                            : row.statusColor === "black"
                                            ? "black"
                                            : "red",
                                        maxWidth: "100%",
                                        padding: ".3rem",
                                        marginBottom: "0.3rem",
                                        marginLeft: "0 .2rem",
                                      }}
                                    >
                                      <Grid container>
                                        <Grid item xs={1.5}>
                                          <Avatar
                                            sx={{
                                              width: 22,
                                              height: 22,
                                              bgcolor:
                                                row.statusColor === "Red"
                                                  ? "red"
                                                  : row.statusColor === "purple"
                                                  ? "purple"
                                                  : row.statusColor === "orange"
                                                  ? "orange"
                                                  : row.statusColor === "black"
                                                  ? "black"
                                                  : "red",
                                            }}
                                          >
                                            {row.patientName
                                              ?.charAt(0)
                                              .toUpperCase()}
                                          </Avatar>
                                        </Grid>
                                        <Grid item xs={9.3}>
                                          <Typography
                                            style={{
                                              color: "black",
                                              fontSize: "14px",
                                            }}
                                            onClick={() =>
                                              handleToggleExpansionNewRequest(
                                                index
                                              )
                                            }
                                          >
                                            <b>{row.patientName} </b>
                                            {/* Authorization Request Submitted */}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={1}>
                                          {isRowExpanded ? (
                                            <>
                                              <ExpandLessIcon
                                                onClick={() => {
                                                  handleToggleExpansionNewRequest(
                                                    index
                                                  );
                                                }}
                                                fontSize="medium"
                                                style={{
                                                  color: "black",
                                                  paddingRight: "5px",
                                                  paddingBottom: "2px",
                                                }}
                                              ></ExpandLessIcon>
                                            </>
                                          ) : (
                                            <>
                                              <ExpandMoreIcon
                                                onClick={() => {
                                                  handleToggleExpansionNewRequest(
                                                    index
                                                  );
                                                }}
                                                fontSize="medium"
                                                style={{
                                                  color: "black",
                                                  paddingRight: "5px",
                                                  paddingBottom: "2px",
                                                }}
                                              ></ExpandMoreIcon>
                                            </>
                                          )}
                                        </Grid>
                                        <Grid container>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                marginTop: "1px",
                                              }}
                                            >
                                              <b>ID:</b> {row.authId}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <b>Submitted:</b>{" "}
                                              {row.priorAuthSubmitted
                                                ? new Date(
                                                    row.priorAuthSubmitted
                                                  ).toLocaleDateString("en-US")
                                                : ""}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                marginTop: "1px",
                                              }}
                                            >
                                              <b>Code:</b> {row.cptCharges}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={6}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "12px",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              <b>Worked:</b>{" "}
                                              {row.updatedDate
                                                ? new Date(
                                                    row.updatedDate
                                                  ).toLocaleDateString("en-US")
                                                : ""}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={8}>
                                            <Typography
                                              style={{
                                                color:
                                                  row.statusColor === "Red"
                                                    ? "red"
                                                    : row.statusColor ===
                                                      "purple"
                                                    ? "purple"
                                                    : row.statusColor ===
                                                      "orange"
                                                    ? "orange"
                                                    : row.statusColor ===
                                                      "black"
                                                    ? "black"
                                                    : "red",
                                                fontSize: "13px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {" "}
                                              <b>{row.practiceName}</b>{" "}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                        {isRowExpanded && (
                                          <Grid container spacing={1}>
                                            <Grid item xs={12}>
                                              <Button
                                                style={{
                                                  backgroundColor:
                                                    row.statusColor === "Red"
                                                      ? "red"
                                                      : row.statusColor ===
                                                        "purple"
                                                      ? "purple"
                                                      : row.statusColor ===
                                                        "orange"
                                                      ? "orange"
                                                      : row.statusColor ===
                                                        "black"
                                                      ? "black"
                                                      : "red",
                                                  color: "#fff",
                                                  float: "right",
                                                  width: "180px",
                                                  height: "28px",
                                                  marginTop: "5px",
                                                  fontWeight: "bold",
                                                  // marginRight: '30px'
                                                }}
                                                size="small"
                                                onClick={() => {
                                                  // handleOpens()
                                                  setauthId2(row.authId);
                                                  setauthIdcpt(row.authCPTId);
                                                  setPriorPracticeID(
                                                    row.practiceId
                                                  );
                                                  setpatinetIdopenauth1(
                                                    row.patientId
                                                  );
                                                  setpatinetnameopenauth1(
                                                    row.patientName
                                                  );
                                                  setPatienTdemoGraphiceId(
                                                    row.patientId
                                                  );
                                                  setSource(row.source);
                                                  setQuetionare(
                                                    row.questionnaire
                                                  );
                                                  setCharge1(row.cptCharges);
                                                  setLomn(row.lomn);
                                                  handleluxbillingpending();
                                                }}
                                              >
                                                <Typography
                                                  fontSize="small"
                                                  style={{ color: "#fff" }}
                                                >
                                                  Open Auth Request
                                                </Typography>
                                              </Button>
                                            </Grid>
                                            <Grid item xs={2}></Grid>

                                            {row.id === Resolve ? (
                                              <>
                                                <Box
                                                  mb={2}
                                                  sx={{
                                                    marginBottom: "10px",

                                                    marginTop: "15px",
                                                    marginLeft: "10px",
                                                  }}
                                                >
                                                  <Grid
                                                    container
                                                    columnSpacing={1}
                                                  >
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      style={{
                                                        fontWeight: 500,
                                                      }}
                                                    >
                                                      <Typography
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "black",
                                                          fontSize: "14px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        Resolve Comments:
                                                      </Typography>
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      xs={12}
                                                      style={{
                                                        marginLeft: "5px",
                                                      }}
                                                    >
                                                      <Controller
                                                        name="resolvedComments"
                                                        {...register(
                                                          "resolvedComments"
                                                        )}
                                                        control={control}
                                                        render={({ field }) => (
                                                          <TextareaAutosize
                                                            reset
                                                            aria-label="minimum height"
                                                            minRows={1}
                                                            placeholder="Enter comments"
                                                            style={{
                                                              width: "100%",
                                                              height: "100px",
                                                              borderRadius:
                                                                "8px",
                                                              border:
                                                                "2px solid #black",
                                                              overflow: "auto",
                                                            }}
                                                            onChange={(e) => {
                                                              setValue(
                                                                "resolvedComments",
                                                                e.target.value
                                                              );
                                                            }}
                                                            fullWidth
                                                          />
                                                        )}
                                                      />
                                                      <p
                                                        style={{
                                                          color: "red",
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        {
                                                          errors
                                                            .resolvedComments
                                                            ?.message
                                                        }
                                                      </p>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                      <Typography
                                                        style={{
                                                          fontWeight: "bold",
                                                          color: "black",
                                                          fontSize: "14px",
                                                          marginLeft: "5px",
                                                          marginTop: "-5px",
                                                        }}
                                                      >
                                                        Resolve Date:
                                                      </Typography>
                                                    </Grid>

                                                    <Grid
                                                      item
                                                      xs={9}
                                                      style={{
                                                        marginTop: "-5px",
                                                      }}
                                                    >
                                                      <Controller
                                                        name="completedDate"
                                                        {...register("date")}
                                                        control={control}
                                                        render={({ field }) => (
                                                          <TextField
                                                            type="date"
                                                            size="small"
                                                            fullWidth
                                                            {...field}
                                                            placeholder="Enter resolve date"
                                                            onChange={(e) => {
                                                              setValue(
                                                                "resolvedDate",
                                                                e.target.value
                                                              );
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                      {errorMessage && (
                                                        <p
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          Please Select Date
                                                        </p>
                                                      )}
                                                    </Grid>
                                                    <Grid item xs={8}></Grid>
                                                    <Grid item xs={2}>
                                                      <Button
                                                        className="Button"
                                                        onClick={handleSubmit(
                                                          saveData
                                                        )}
                                                        variant="gradient"
                                                        style={{
                                                          marginTop: "15px",
                                                          marginBottom: "10px",
                                                          float: "right",
                                                          width: "87px",
                                                          height: "28px",

                                                          color: "white",
                                                          fontSize: "12px",
                                                          marginRight: "50px",
                                                        }}
                                                      >
                                                        <SaveOutlinedIcon
                                                          fontSize="medium"
                                                          style={{
                                                            color: "white",
                                                            paddingRight: "5px",
                                                            paddingBottom:
                                                              "2px",
                                                          }}
                                                        ></SaveOutlinedIcon>
                                                        Save
                                                      </Button>
                                                    </Grid>

                                                    <Grid item xs={2}>
                                                      <Button
                                                        className="Button"
                                                        onClick={() => {
                                                          setResolve(null);
                                                        }}
                                                        variant="gradient"
                                                        style={{
                                                          marginTop: "15px",
                                                          marginBottom: "10px",
                                                          float: "right",
                                                          width: "87px",
                                                          height: "28px",
                                                          backgroundColor:
                                                            "#56CA00",
                                                          color: "white",
                                                          fontSize: "12px",
                                                          marginRight: "18px",
                                                        }}
                                                      >
                                                        <CancelOutlinedIcon
                                                          fontSize="medium"
                                                          style={{
                                                            color: "white",
                                                            paddingRight: "5px",
                                                            paddingBottom:
                                                              "2px",
                                                          }}
                                                        ></CancelOutlinedIcon>
                                                        Cancel
                                                      </Button>
                                                    </Grid>
                                                  </Grid>
                                                </Box>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </Grid>
                                        )}
                                      </Grid>
                                    </Paper>
                                  );
                                })
                              : "No Record Found"}
                          </Paper>
                        </Grid>
                      </>
                    )}

                    {CliamsLoading ? (
                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "40vh", // Full vertical height
                          width: "100%", // Full width
                        }}
                      >
                        <CircularProgress />
                      </Box>
                    ) : (
                      <>
                        <Grid
                          container
                          spacing={1}
                          style={{ marginTop: "5px" }}
                        >
                          <Grid item xs={12} sm={6} md={3} lg={3}>
                            <Grid container spacing={1}>
                              <Grid item xs={12}>
                                <Typography
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "black",
                                    whiteSpace: "nowrap",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    // backgroundColor: '#CBC3E3',
                                    padding: "2px 4px",
                                    borderRadius: "2px",
                                  }}
                                >
                                  Completed Claims by LuxBilling{" "}
                                  <span
                                    style={{
                                      color: "#1976d2",
                                      fontWeight: "700",
                                    }}
                                  >
                                    ({completedClaimsCount})
                                  </span>{" "}
                                </Typography>
                              </Grid>
                            </Grid>

                            <Paper
                              variant="outlined"
                              square
                              style={{
                                backgroundColor: "#F0F6F8",
                                borderRadius: "15px",
                                marginTop: "3px",
                                borderColor: "#377562",
                                maxWidth: "100%",
                                padding: ".5rem",
                                marginBottom: "0.5rem",
                                marginLeft: "0 .2rem",
                                height: 300,
                                overflow: "auto",
                                /* Other styles */
                                scrollbarWidth: "thin", // For Firefox
                                scrollbarColor: "#377562 transparent", // thumb color and track color
                                "&::-webkit-scrollbar": {
                                  width: 8 /* Width of vertical scrollbar */,
                                  height: 8 /* Height of horizontal scrollbar */,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor:
                                    "#377562" /* Color of the thumb */,
                                  borderRadius: 10,
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor:
                                    "transparent" /* Color of the track */,
                                },
                                /* Adjust the width for the horizontal scrollbar */
                                "&::-webkit-scrollbar-thumb:horizontal": {
                                  width: 4 /* Width of horizontal scrollbar */,
                                },
                                // zIndex: "10",
                              }}
                            >
                              {claimNotification1 != null &&
                              claimNotification1.length > 0
                                ? claimNotification1.map((row, index) => {
                                    return (
                                      <Paper
                                        variant="outlined"
                                        square
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          // marginTop: '3px',
                                          borderColor: "green",
                                          maxWidth: "100%",
                                          padding: ".3rem",
                                          marginBottom: "0.3rem",
                                          marginLeft: "0 .2rem",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                          <Grid item xs={1.5}>
                                            <Avatar
                                              sx={{
                                                width: 22,
                                                height: 22,
                                                bgcolor: row.StatusColor,
                                              }}
                                            >
                                              {row.patientName
                                                ?.charAt(0)
                                                .toUpperCase()}
                                            </Avatar>
                                          </Grid>
                                          <Grid item xs={9.5}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "14px",
                                              }}
                                              onClick={() => {
                                                handleToggleExpansionclaim1(
                                                  null
                                                );
                                              }}
                                            >
                                              <b>{row.patientName}</b>
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={1}>
                                            {expandedRowIdclaim1 === row.id ? (
                                              <>
                                                <ExpandLessIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim1(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandLessIcon>
                                              </>
                                            ) : (
                                              <>
                                                <ExpandMoreIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim1(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandMoreIcon>
                                              </>
                                            )}
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            style={{
                                              justifyContent: "space-between",
                                              marginTop: "-8px",
                                              marginBottom: "-2px",
                                            }}
                                          >
                                            {expandedRowIdclaim1 === row.id ? (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: row.StatusColor,
                                                        fontSize: "13px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            ) : (
                                              <>
                                                <Grid container>
                                                  {/* <Grid item xs={12}>
                                                <Typography style={{ color: 'black', fontSize: '14px' }}
                                                  onClick={() => {
                                                    handleToggleExpansionclaim1(null)
                                                  }}
                                                ><b>{row.patientName}</b></Typography>
                                              </Grid> */}
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: row.StatusColor,
                                                        fontSize: "13px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            )}
                                          </Grid>

                                          {/* <Grid item xs={1} >
                                          {expandedRowIdclaim1 === row.id ? (<>

                                            <ExpandLessIcon
                                              onClick={() => handleToggleExpansionclaim1(row.id)}
                                              fontSize='medium'
                                              style={{
                                                color: 'black',
                                                paddingRight: '5px',
                                                paddingBottom: '2px'
                                              }}
                                            >
                                            </ExpandLessIcon>
                                          </>) : (
                                            <>
                                              <ExpandMoreIcon
                                                onClick={() => handleToggleExpansionclaim1(row.id)}
                                                fontSize='medium'
                                                style={{
                                                  color: 'black',
                                                  paddingRight: '5px',
                                                  paddingBottom: '2px'
                                                }}
                                              >
                                              </ExpandMoreIcon>
                                            </>)}

                                        </Grid> */}

                                          <Grid item xs={12}>
                                            {expandedRowIdclaim1 === row.id && (
                                              <Grid
                                                container
                                                style={{ marginTop: "-15px" }}
                                              >
                                                <Grid item xs={7}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    <b>Physician Name:</b>
                                                    {row.attendingPhysicianName}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    <b>Auth Number:</b>
                                                    {row.authNumber}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                  <Button
                                                    style={{
                                                      backgroundColor: row.StatusColor,
                                                      color: "white",
                                                      float: "right",
                                                      width: "120px",
                                                      height: "28px",
                                                      marginTop: "5px",
                                                      // marginRight:'25px'
                                                    }}
                                                    size="small"
                                                    onClick={() => {
                                                      setclaimId(row.id);
                                                      setpatinetIdopenclaim(
                                                        row.patientId
                                                      );
                                                      setpatinetnameopencalim(
                                                        row.patientName
                                                      );
                                                      setPatienTdemoGraphiceId(
                                                        row.patientId
                                                      );
                                                      setclaimPracticeID(
                                                        row.practiceId
                                                      );
                                                      handleclaimopen();
                                                    }}
                                                  >
                                                    <Typography
                                                      fontSize="small"
                                                      style={{ color: "#fff" }}
                                                    >
                                                      {" "}
                                                      Open Claim{" "}
                                                    </Typography>
                                                  </Button>
                                                </Grid>
                                                {/* <Grid item xs={2} >
                                     <Button
                                      className='Button'
                                       onClick={() => {
                                         setselectedRow(row.id)
                                         setselectedindex(index)
                                         setResolve(row.id)
                                       }}
                                       variant='gradient'
                                       style={{
                                         marginBottom: '10px',
                                         float: 'right',
                                         width: '87px',
                                         height: '28px',
                                         backgroundColor: '#56CA00',
                                         color: 'white',
                                         fontSize: '12px',
                                         marginTop:'5px'
                                       }}
                                     >
                                      
                                       Resolve
                                     </Button>
                                   </Grid> */}

                                                {/* {row.id === Resolve ?(<>
                               <Box
                                 mb={2}
                                 sx={{
                                   marginBottom: '10px',

                                   marginTop: '15px',
                                   marginLeft: '10px'
                                 }}
                               >
                                 <Grid container columnSpacing={1}>
                                   <Grid item xs={12} style={{ fontWeight: 500 }}>
                                     <Typography style={{fontWeight:'bold',color:'black',fontSize:'14px',marginLeft:'15px'}}>
                                       Ressolve Comments:
                                     </Typography>
                                   </Grid>
                                   <Grid item xs={12} style={{marginLeft:'15px'}}>
                                     <Controller
                                       name='resolvedComments'
                                       {...register('resolvedComments')}
                                       control={control}
                                       render={({ field }) => (
                                         <TextareaAutosize
                                           reset
                                           aria-label='minimum height'
                                           minRows={1}
                                           placeholder='Enter comments'
                                           style={{
                                             width: '100%',
                                             height: '100px',
                                             borderRadius: '8px',
                                             border: '2px solid #black',
                                             overflow: 'auto'
                                           }}
                                     
                                           fullWidth
                                           
                                         />
                                       )}
                                     />
                                     <p style={{ color: 'red', fontSize: '14px' }}>
                                       {errors.resolvedComments?.message}
                                     </p>
                                   </Grid>
                                   <Grid item xs={3} >
                                     <Typography style={{fontWeight:'bold',color:'black',fontSize:'14px',marginLeft:'15px',marginTop:'-5px'}}>
                                       Resolve Date:
                                     </Typography>
                                   </Grid>

                                   <Grid item xs={6} style={{marginLeft:'15px'}}>
                                     <Controller
                                       name='completedDate'
                                       {...register('date')}
                                       control={control}
                                       render={({ field }) => (
                                         <TextField
                                           type='date'
                                           size='small'
                                           fullWidth
                                           {...field}
                                           placeholder='Enter resolve date'
                                         
                                           onChange={e => {
                                             setValue('resolvedDate', e.target.value)
                                           
                                           }}
                                         />
                                       )}
                                     />
                                  
                                   </Grid>
                                   <Grid item xs={8}></Grid>
                                   <Grid item xs={2}>
                                     <Button
                                      className='Button'
                                       onClick={handleSubmit(saveData)}
                                       variant='gradient'
                                     
                                       style={{
                                         marginTop: '15px',
                                         marginBottom: '10px',
                                         float: 'right',
                                         width: '87px',
                                         height: '28px',
                                   
                                         color: 'white',
                                         fontSize: '12px',
                                          marginRight: '30px'
                                       }}
                                  
                                     >
                                       <SaveOutlinedIcon
                                         fontSize='medium'
                                         style={{
                                           color: 'white',
                                           paddingRight: '5px',
                                           paddingBottom: '2px'
                                         }}
                                       ></SaveOutlinedIcon>
                                       Save
                                     </Button>
                                   </Grid>

                                   <Grid item xs={2}>
                                     <Button
                                      className='Button'
                                       onClick={() => {
                                         setResolve(null)
                                       }}
                                       variant='gradient'
                                       style={{
                                         marginTop: '15px',
                                         marginBottom: '10px',
                                         float: 'right',
                                         width: '87px',
                                         height: '28px',
                                         backgroundColor: '#56CA00',
                                         color: 'white',
                                         fontSize: '12px',
                                         marginRight: '18px'
                                       }}
                                     >
                                       <CancelOutlinedIcon
                                         fontSize='medium'
                                         style={{
                                           color: 'white',
                                           paddingRight: '5px',
                                           paddingBottom: '2px'
                                         }}
                                       ></CancelOutlinedIcon>
                                       Cancel
                                     </Button>
                                   </Grid>
                                 </Grid>
                               </Box>
                             
                             </>):(<></>) }  */}
                                              </Grid>
                                            )}
                                            {/* {row.id === id ? (
                            <>
                          
                            
                            </>):(<></>)} */}
                                          </Grid>
                                        </Grid>
                                      </Paper>
                                    );
                                  })
                                : "No Record Found"}
                            </Paper>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={3}>
                            <Grid container spacing={1}>
                              <Grid item xs={12}>
                                <Typography
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "black",
                                    whiteSpace: "nowrap",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    // backgroundColor: '#FFD580',  // Light orange highlighter color
                                    padding: "2px 4px", // Add padding for better highlight effect
                                    borderRadius: "2px",
                                  }}
                                >
                                  Pending Further Review Claims{" "}
                                  <span
                                    style={{
                                      color: "#1976d2",
                                      fontWeight: "700",
                                    }}
                                  >
                                    ({pendingClaimsCount})
                                  </span>{" "}
                                </Typography>
                              </Grid>
                              {/* <Grid item xs={1}>

                            <CachedOutlinedIcon
                              onClick={event => {
                                applyRefreshclaim()
                              }}
                              fontSize='medium'
                              style={{
                                color: '#3C7F6B',
                                //  marginRight: '-25px',
                                paddingRight: '0px',
                                paddingBottom: '1px'
                              }}
                            ></CachedOutlinedIcon>

                          </Grid> */}
                            </Grid>
                            <Paper
                              variant="outlined"
                              square
                              style={{
                                backgroundColor: "#F0F6F8",
                                borderRadius: "15px",
                                marginTop: "3px",
                                borderColor: "purple",
                                maxWidth: "100%",
                                padding: ".5rem",
                                marginBottom: "0.5rem",
                                marginLeft: "0 .2rem",
                                height: 300,
                                overflow: "auto",
                                /* Other styles */
                                scrollbarWidth: "thin", // For Firefox
                                scrollbarColor: "purple transparent", // thumb color and track color
                                "&::-webkit-scrollbar": {
                                  width: 8 /* Width of vertical scrollbar */,
                                  height: 8 /* Height of horizontal scrollbar */,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor:
                                    "purple" /* Color of the thumb */,
                                  borderRadius: 10,
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor:
                                    "transparent" /* Color of the track */,
                                },
                                /* Adjust the width for the horizontal scrollbar */
                                "&::-webkit-scrollbar-thumb:horizontal": {
                                  width: 4 /* Width of horizontal scrollbar */,
                                },
                                // zIndex: "10",
                              }}
                            >
                              {claimNotification != null &&
                              claimNotification.length > 0
                                ? claimNotification.map((row, index) => {
                                    return (
                                      <Paper
                                        variant="outlined"
                                        square
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          // marginTop: '3px',
                                          borderColor: "purple",
                                          maxWidth: "100%",
                                          padding: ".3rem",
                                          marginBottom: "0.3rem",
                                          marginLeft: "0 .2rem",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                          {/* <Grid item xs={2}>
                      <Typography style={{color:'black',fontWeight:'bold'}}>{row.patientName}'S</Typography>

                      </Grid> */}
                                          <Grid item xs={1.5}>
                                            <Avatar
                                              sx={{
                                                width: 22,
                                                height: 22,
                                                bgcolor: row.StatusColor,
                                              }}
                                            >
                                              {row.patientName
                                                ?.charAt(0)
                                                .toUpperCase()}
                                            </Avatar>
                                          </Grid>
                                          <Grid item xs={9.5}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "14px",
                                              }}
                                              onClick={() => {
                                                handleToggleExpansionclaim(
                                                  null
                                                );
                                              }}
                                            >
                                              <b>{row.patientName}</b>
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={1}>
                                            {expandedRowIdclaim === row.id ? (
                                              <>
                                                <ExpandLessIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandLessIcon>
                                              </>
                                            ) : (
                                              <>
                                                <ExpandMoreIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandMoreIcon>
                                              </>
                                            )}
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            style={{
                                              justifyContent: "space-between",
                                              marginTop: "-8px",
                                              marginBottom: "-2px",
                                            }}
                                          >
                                            {expandedRowIdclaim === row.id ? (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: row.StatusColor,
                                                        fontSize: "13px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      <b>{row.practiceName}</b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            ) : (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: row.StatusColor,
                                                        fontSize: "13px",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            )}
                                          </Grid>

                                          {/* <Grid item xs={1} >
                                          {expandedRowIdclaim === row.id ? (<>

                                            <ExpandLessIcon
                                              onClick={() => handleToggleExpansionclaim(row.id)}
                                              fontSize='medium'
                                              style={{
                                                color: 'black',
                                                paddingRight: '5px',
                                                paddingBottom: '2px'
                                              }}
                                            >
                                            </ExpandLessIcon>
                                          </>) : (
                                            <>
                                              <ExpandMoreIcon
                                                onClick={() => handleToggleExpansionclaim(row.id)}
                                                fontSize='medium'
                                                style={{
                                                  color: 'black',
                                                  paddingRight: '5px',
                                                  paddingBottom: '2px'
                                                }}
                                              >
                                              </ExpandMoreIcon>
                                            </>)}

                                        </Grid> */}

                                          <Grid item xs={12}>
                                            {expandedRowIdclaim === row.id && (
                                              <Grid container>
                                                <Grid item xs={7}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Physician Name:</b>
                                                    {row.attendingPhysicianName}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Auth Number:</b>
                                                    {row.authNumber}
                                                  </Typography>
                                                </Grid>
                                                {/* <Grid item xs={3.1}>
                                            <Typography style={{ fontWeight: 'bold', color: 'black', fontSize: '14px', marginLeft: '15px', marginTop: '5px' }}>Physician Name:</Typography>

                                          </Grid>
                                          <Grid item xs={2.6} >
                                            <Typography style={{ color: 'black', fontSize: '14px', marginLeft: '15px', marginTop: '5px' }}>{row.attendingPhysicianName}</Typography>

                                          </Grid>

                                          <Grid item xs={2.9}>
                                            <Typography style={{ fontWeight: 'bold', color: 'black', fontSize: '14px', marginLeft: '15px', marginTop: '5px' }}>Auth Number:</Typography>

                                          </Grid>
                                          <Grid item xs={3.3} >
                                            <Typography style={{ color: 'black', fontSize: '14px', marginLeft: '15px', marginTop: '5px' }}>{row.authNumber}</Typography>

                                          </Grid> */}

                                                <Grid item xs={12}>
                                                  <Button
                                                    style={{
                                                      backgroundColor: row.StatusColor,
                                                      color: "white",
                                                      float: "right",
                                                      width: "120px",
                                                      height: "28px",
                                                      marginTop: "5px",
                                                      // marginRight:'25px'
                                                    }}
                                                    size="small"
                                                    onClick={() => {
                                                      setclaimId(row.id);
                                                      setpatinetIdopenclaim(
                                                        row.patientId
                                                      );
                                                      setpatinetnameopencalim(
                                                        row.patientName
                                                      );
                                                      setPatienTdemoGraphiceId(
                                                        row.patientId
                                                      );
                                                      setclaimPracticeID(
                                                        row.practiceId
                                                      );
                                                      handleclaimopen();
                                                    }}
                                                  >
                                                    <Typography
                                                      fontSize="small"
                                                      style={{ color: "#fff" }}
                                                    >
                                                      {" "}
                                                      Open Claim{" "}
                                                    </Typography>
                                                  </Button>
                                                </Grid>
                                                {/* <Grid item xs={2} >
                                      <Button
                                       className='Button'
                                        onClick={() => {
                                          setselectedRow(row.id)
                                          setselectedindex(index)
                                          setResolve(row.id)
                                        }}
                                        variant='gradient'
                                        style={{
                                          marginBottom: '10px',
                                          float: 'right',
                                          width: '87px',
                                          height: '28px',
                                          backgroundColor: '#56CA00',
                                          color: 'white',
                                          fontSize: '12px',
                                          marginTop:'5px'
                                        }}
                                      >
                                       
                                        Resolve
                                      </Button>
                                    </Grid> */}

                                                {/* {row.id === Resolve ?(<>
                                <Box
                                  mb={2}
                                  sx={{
                                    marginBottom: '10px',

                                    marginTop: '15px',
                                    marginLeft: '10px'
                                  }}
                                >
                                  <Grid container columnSpacing={1}>
                                    <Grid item xs={12} style={{ fontWeight: 500 }}>
                                      <Typography style={{fontWeight:'bold',color:'black',fontSize:'14px',marginLeft:'15px'}}>
                                        Ressolve Comments:
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12} style={{marginLeft:'15px'}}>
                                      <Controller
                                        name='resolvedComments'
                                        {...register('resolvedComments')}
                                        control={control}
                                        render={({ field }) => (
                                          <TextareaAutosize
                                            reset
                                            aria-label='minimum height'
                                            minRows={1}
                                            placeholder='Enter comments'
                                            style={{
                                              width: '100%',
                                              height: '100px',
                                              borderRadius: '8px',
                                              border: '2px solid #black',
                                              overflow: 'auto'
                                            }}
                                      
                                            fullWidth
                                            
                                          />
                                        )}
                                      />
                                      <p style={{ color: 'red', fontSize: '14px' }}>
                                        {errors.resolvedComments?.message}
                                      </p>
                                    </Grid>
                                    <Grid item xs={3} >
                                      <Typography style={{fontWeight:'bold',color:'black',fontSize:'14px',marginLeft:'15px',marginTop:'-5px'}}>
                                        Resolve Date:
                                      </Typography>
                                    </Grid>

                                    <Grid item xs={6} style={{marginLeft:'15px'}}>
                                      <Controller
                                        name='completedDate'
                                        {...register('date')}
                                        control={control}
                                        render={({ field }) => (
                                          <TextField
                                            type='date'
                                            size='small'
                                            fullWidth
                                            {...field}
                                            placeholder='Enter resolve date'
                                          
                                            onChange={e => {
                                              setValue('resolvedDate', e.target.value)
                                            
                                            }}
                                          />
                                        )}
                                      />
                                   
                                    </Grid>
                                    <Grid item xs={8}></Grid>
                                    <Grid item xs={2}>
                                      <Button
                                       className='Button'
                                        onClick={handleSubmit(saveData)}
                                        variant='gradient'
                                      
                                        style={{
                                          marginTop: '15px',
                                          marginBottom: '10px',
                                          float: 'right',
                                          width: '87px',
                                          height: '28px',
                                    
                                          color: 'white',
                                          fontSize: '12px',
                                           marginRight: '30px'
                                        }}
                                   
                                      >
                                        <SaveOutlinedIcon
                                          fontSize='medium'
                                          style={{
                                            color: 'white',
                                            paddingRight: '5px',
                                            paddingBottom: '2px'
                                          }}
                                        ></SaveOutlinedIcon>
                                        Save
                                      </Button>
                                    </Grid>

                                    <Grid item xs={2}>
                                      <Button
                                       className='Button'
                                        onClick={() => {
                                          setResolve(null)
                                        }}
                                        variant='gradient'
                                        style={{
                                          marginTop: '15px',
                                          marginBottom: '10px',
                                          float: 'right',
                                          width: '87px',
                                          height: '28px',
                                          backgroundColor: '#56CA00',
                                          color: 'white',
                                          fontSize: '12px',
                                          marginRight: '18px'
                                        }}
                                      >
                                        <CancelOutlinedIcon
                                          fontSize='medium'
                                          style={{
                                            color: 'white',
                                            paddingRight: '5px',
                                            paddingBottom: '2px'
                                          }}
                                        ></CancelOutlinedIcon>
                                        Cancel
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Box>
                              
                              </>):(<></>) }  */}
                                              </Grid>
                                            )}
                                            {/* {row.id === id ? (
                            <>
                          
                            
                            </>):(<></>)} */}
                                          </Grid>
                                        </Grid>
                                      </Paper>
                                    );
                                  })
                                : "No Record Found"}
                            </Paper>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={3}>
                            <Grid container spacing={1}>
                              <Grid item xs={12}>
                                <Typography
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "black",
                                    marginLeft: "20px",
                                    whiteSpace: "nowrap",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    //  backgroundColor: '#FFD580',  // Light orange highlighter color
                                    padding: "2px 4px", // Add padding for better highlight effect
                                    borderRadius: "2px",
                                  }}
                                >
                                  Pending Claims{" "}
                                  <span
                                    style={{
                                      color: "#1976d2",
                                      fontWeight: "700",
                                    }}
                                  >
                                    ({pendingONlyClaimCount})
                                  </span>{" "}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Paper
                              variant="outlined"
                              square
                              style={{
                                backgroundColor: "#F0F6F8",
                                borderRadius: "15px",
                                marginTop: "3px",
                                borderColor: "#356F60",
                                maxWidth: "100%",
                                padding: ".5rem",
                                marginBottom: "0.5rem",
                                marginLeft: "0 .2rem",
                                height: 300,
                                overflow: "auto",
                                /* Other styles */
                                scrollbarWidth: "thin", // For Firefox
                                scrollbarColor: "orange transparent", // thumb color and track color
                                "&::-webkit-scrollbar": {
                                  width: 8 /* Width of vertical scrollbar */,
                                  height: 8 /* Height of horizontal scrollbar */,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor:
                                    "orange" /* Color of the thumb */,
                                  borderRadius: 10,
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor:
                                    "transparent" /* Color of the track */,
                                },
                                /* Adjust the width for the horizontal scrollbar */
                                "&::-webkit-scrollbar-thumb:horizontal": {
                                  width: 4 /* Width of horizontal scrollbar */,
                                },
                                // zIndex: "10",
                              }}
                            >
                              {PendingClaimNotidcation != null &&
                              PendingClaimNotidcation.length > 0
                                ? PendingClaimNotidcation.map((row, index) => {
                                    return (
                                      <Paper
                                        variant="outlined"
                                        square
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          // marginTop: '3px',
                                          borderColor: "orange",
                                          maxWidth: "100%",
                                          padding: ".3rem",
                                          marginBottom: "0.3rem",
                                          marginLeft: "0 .2rem",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                          <Grid item xs={1.5}>
                                            <Avatar
                                              sx={{
                                                width: 22,
                                                height: 22,
                                                bgcolor: row.StatusColor,
                                              }}
                                            >
                                              {row.patientName
                                                ?.charAt(0)
                                                .toUpperCase()}
                                            </Avatar>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "14px",
                                              }}
                                              onClick={() => {
                                                handleToggleExpansionclaim(
                                                  null
                                                );
                                              }}
                                            >
                                              <b>{row.patientName}</b>
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={1}>
                                            {expandedRowIdclaim === row.id ? (
                                              <>
                                                <ExpandLessIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandLessIcon>
                                              </>
                                            ) : (
                                              <>
                                                <ExpandMoreIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandMoreIcon>
                                              </>
                                            )}
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            style={{
                                              justifyContent: "space-between",
                                              marginTop: "-8px",
                                              marginBottom: "-2px",
                                            }}
                                          >
                                            {expandedRowIdclaim === row.id ? (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: row.StatusColor,
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            ) : (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: row.StatusColor,
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            )}
                                          </Grid>

                                          {/* <Grid item xs={1} >
                                          {expandedRowIdclaim === row.id ? (<>

                                            <ExpandLessIcon
                                              onClick={() => handleToggleExpansionclaim(row.id)}
                                              fontSize='medium'
                                              style={{
                                                color: 'black',
                                                paddingRight: '5px',
                                                paddingBottom: '2px'
                                              }}
                                            >
                                            </ExpandLessIcon>
                                          </>) : (
                                            <>
                                              <ExpandMoreIcon
                                                onClick={() => handleToggleExpansionclaim(row.id)}
                                                fontSize='medium'
                                                style={{
                                                  color: 'black',
                                                  paddingRight: '5px',
                                                  paddingBottom: '2px'
                                                }}
                                              >
                                              </ExpandMoreIcon>
                                            </>)}

                                        </Grid> */}

                                          <Grid item xs={12}>
                                            {expandedRowIdclaim === row.id && (
                                              <Grid
                                                container
                                                style={{ marginTop: "-15px" }}
                                              >
                                                <Grid item xs={7}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Physician Name:</b>
                                                    {row.attendingPhysicianName}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Auth Number:</b>
                                                    {row.authNumber}
                                                  </Typography>
                                                </Grid>

                                                <Grid item xs={12}>
                                                  <Button
                                                    style={{
                                                      backgroundColor:
                                                        row.StatusColor,
                                                      color: "white",
                                                      float: "right",
                                                      width: "120px",
                                                      height: "28px",
                                                      marginTop: "5px",
                                                      // marginRight:'25px'
                                                    }}
                                                    size="small"
                                                    onClick={() => {
                                                      setclaimId(row.id);
                                                      setpatinetIdopenclaim(
                                                        row.patientId
                                                      );
                                                      setpatinetnameopencalim(
                                                        row.patientName
                                                      );
                                                      setPatienTdemoGraphiceId(
                                                        row.patientId
                                                      );
                                                      setclaimPracticeID(
                                                        row.practiceId
                                                      );
                                                      handleclaimopen();
                                                    }}
                                                  >
                                                    <Typography
                                                      fontSize="small"
                                                      style={{ color: "#fff" }}
                                                    >
                                                      {" "}
                                                      Open Claim{" "}
                                                    </Typography>
                                                  </Button>
                                                </Grid>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Paper>
                                    );
                                  })
                                : "No Record Found"}
                            </Paper>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={3}>
                            <Grid container spacing={1}>
                              <Grid item xs={11}>
                                <Typography
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: "black",
                                    whiteSpace: "nowrap",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    // backgroundColor: '#FFD580',  // Light orange highlighter color
                                    padding: "2px 4px", // Add padding for better highlight effect
                                    borderRadius: "2px",
                                  }}
                                >
                                  New Claims{" "}
                                  <span
                                    style={{
                                      color: "#1976d2",
                                      fontWeight: "700",
                                    }}
                                  >
                                    ({newClaimCount})
                                  </span>{" "}
                                </Typography>
                              </Grid>
                              <Grid item xs={1}>
                                <CachedOutlinedIcon
                                  onClick={(event) => {
                                    applyRefreshclaim();
                                  }}
                                  fontSize="medium"
                                  style={{
                                    color: "#3C7F6B",
                                    //  marginRight: '-25px',
                                    paddingRight: "0px",
                                    paddingBottom: "1px",
                                  }}
                                ></CachedOutlinedIcon>
                              </Grid>
                            </Grid>
                            <Paper
                              variant="outlined"
                              square
                              style={{
                                backgroundColor: "#F0F6F8",
                                borderRadius: "15px",
                                marginTop: "3px",
                                borderColor: "#356F60",
                                maxWidth: "100%",
                                padding: ".5rem",
                                marginBottom: "0.5rem",
                                marginLeft: "0 .2rem",
                                height: 300,
                                overflow: "auto",
                                /* Other styles */
                                scrollbarWidth: "thin", // For Firefox
                                scrollbarColor: "red transparent", // thumb color and track color
                                "&::-webkit-scrollbar": {
                                  width: 8 /* Width of vertical scrollbar */,
                                  height: 8 /* Height of horizontal scrollbar */,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor:
                                    "#356F60" /* Color of the thumb */,
                                  borderRadius: 10,
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor:
                                    "transparent" /* Color of the track */,
                                },
                                /* Adjust the width for the horizontal scrollbar */
                                "&::-webkit-scrollbar-thumb:horizontal": {
                                  width: 4 /* Width of horizontal scrollbar */,
                                },
                                // zIndex: "10",
                              }}
                            >
                              {newClaimNotidcation != null &&
                              newClaimNotidcation.length > 0
                                ? newClaimNotidcation.map((row, index) => {
                                    return (
                                      <Paper
                                        variant="outlined"
                                        square
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          // marginTop: '3px',
                                          borderColor: "red",
                                          maxWidth: "100%",
                                          padding: ".3rem",
                                          marginBottom: "0.3rem",
                                          marginLeft: "0 .2rem",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                          <Grid item xs={1.5}>
                                            <Avatar
                                              sx={{
                                                width: 22,
                                                height: 22,
                                                bgcolor: "red",
                                              }}
                                            >
                                              {row.patientName
                                                ?.charAt(0)
                                                .toUpperCase()}
                                            </Avatar>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "14px",
                                              }}
                                              onClick={() => {
                                                handleToggleExpansionclaim(
                                                  null
                                                );
                                              }}
                                            >
                                              <b>{row.patientName}</b>
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={1}>
                                            {expandedRowIdclaim === row.id ? (
                                              <>
                                                <ExpandLessIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandLessIcon>
                                              </>
                                            ) : (
                                              <>
                                                <ExpandMoreIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandMoreIcon>
                                              </>
                                            )}
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            style={{
                                              justifyContent: "space-between",
                                              marginTop: "-8px",
                                              marginBottom: "-2px",
                                            }}
                                          >
                                            {expandedRowIdclaim === row.id ? (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "red",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            ) : (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "red",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            )}
                                          </Grid>

                                          {/* <Grid item xs={1} >
                                          {expandedRowIdclaim === row.id ? (<>

                                            <ExpandLessIcon
                                              onClick={() => handleToggleExpansionclaim(row.id)}
                                              fontSize='medium'
                                              style={{
                                                color: 'black',
                                                paddingRight: '5px',
                                                paddingBottom: '2px'
                                              }}
                                            >
                                            </ExpandLessIcon>
                                          </>) : (
                                            <>
                                              <ExpandMoreIcon
                                                onClick={() => handleToggleExpansionclaim(row.id)}
                                                fontSize='medium'
                                                style={{
                                                  color: 'black',
                                                  paddingRight: '5px',
                                                  paddingBottom: '2px'
                                                }}
                                              >
                                              </ExpandMoreIcon>
                                            </>)}

                                        </Grid> */}

                                          <Grid item xs={12}>
                                            {expandedRowIdclaim === row.id && (
                                              <Grid
                                                container
                                                style={{ marginTop: "-15px" }}
                                              >
                                                <Grid item xs={7}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Physician Name:</b>
                                                    {row.attendingPhysicianName}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Auth Number:</b>
                                                    {row.authNumber}
                                                  </Typography>
                                                </Grid>

                                                <Grid item xs={12}>
                                                  <Button
                                                    style={{
                                                      backgroundColor: "red",
                                                      color: "white",
                                                      float: "right",
                                                      width: "120px",
                                                      height: "28px",
                                                      marginTop: "5px",
                                                      // marginRight:'25px'
                                                    }}
                                                    size="small"
                                                    onClick={() => {
                                                      setclaimId(row.id);
                                                      setpatinetIdopenclaim(
                                                        row.patientId
                                                      );
                                                      setpatinetnameopencalim(
                                                        row.patientName
                                                      );
                                                      setPatienTdemoGraphiceId(
                                                        row.patientId
                                                      );
                                                      setclaimPracticeID(
                                                        row.practiceId
                                                      );
                                                      handleclaimopen();
                                                    }}
                                                  >
                                                    <Typography
                                                      fontSize="small"
                                                      style={{ color: "#fff" }}
                                                    >
                                                      {" "}
                                                      Open Claim{" "}
                                                    </Typography>
                                                  </Button>
                                                </Grid>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Paper>
                                    );
                                  })
                                : "No Record Found"}
                            </Paper>
                          </Grid>

                          <Grid item xs={12} sm={6} md={3} lg={3}>
                            <Grid container spacing={1}>
                              <Grid item xs={12}>
                                <Typography
                                  style={{
                                    fontWeight: "bold",
                                    color: "black",
                                    whiteSpace: "nowrap",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    // backgroundColor: '#90EE90',
                                    padding: "2px 4px",
                                    borderRadius: "2px",
                                  }}
                                >
                                  Paid Claims by Provider{" "}
                                  <span
                                    style={{
                                      color: "#1976d2",
                                      fontWeight: "700",
                                    }}
                                  >
                                    ({paidClaimsCount})
                                  </span>
                                </Typography>
                              </Grid>
                              {/* <Grid item xs={1}>

                            <CachedOutlinedIcon
                              onClick={event => {
                                applyRefreshclaim()
                              }}
                              fontSize='medium'
                              style={{
                                color: '#3C7F6B',
                                //  marginRight: '-25px',
                                paddingRight: '0px',
                                paddingBottom: '1px'
                              }}
                            ></CachedOutlinedIcon>

                          </Grid> */}
                            </Grid>

                            <Paper
                              variant="outlined"
                              square
                              style={{
                                backgroundColor: "#F0F6F8",
                                borderRadius: "15px",
                                marginTop: "3px",
                                borderColor: "#377562",
                                maxWidth: "100%",
                                padding: ".5rem",
                                marginBottom: "0.5rem",
                                marginLeft: "0 .2rem",
                                height: 300,
                                overflow: "auto",
                                /* Other styles */
                                scrollbarWidth: "thin", // For Firefox
                                scrollbarColor: "#1976d2 transparent", // thumb color and track color
                                "&::-webkit-scrollbar": {
                                  width: 8 /* Width of vertical scrollbar */,
                                  height: 8 /* Height of horizontal scrollbar */,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor:
                                    "#1976d2" /* Color of the thumb */,
                                  borderRadius: 10,
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor:
                                    "transparent" /* Color of the track */,
                                },
                                /* Adjust the width for the horizontal scrollbar */
                                "&::-webkit-scrollbar-thumb:horizontal": {
                                  width: 4 /* Width of horizontal scrollbar */,
                                },
                                // zIndex: "10",
                              }}
                            >
                              {claimNotificationpayment != null &&
                              claimNotificationpayment.length > 0
                                ? claimNotificationpayment.map((row, index) => {
                                    return (
                                      <Paper
                                        variant="outlined"
                                        square
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          // marginTop: '3px',
                                          borderColor: "#1976d2",
                                          maxWidth: "100%",
                                          padding: ".3rem",
                                          marginBottom: "0.3rem",
                                          marginLeft: "0 .2rem",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                          {/* <Grid item xs={2}>
                      <Typography style={{color:'black',fontWeight:'bold'}}>{row.patientName}'S</Typography>

                      </Grid> */}
                                          <Grid item xs={1.5}>
                                            <Avatar
                                              sx={{
                                                width: 22,
                                                height: 22,
                                                bgcolor: "#1976d2",
                                              }}
                                            >
                                              {row.patientName
                                                ?.charAt(0)
                                                .toUpperCase()}
                                            </Avatar>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "14px",
                                              }}
                                              onClick={() => {
                                                handleToggleExpansionclaim2(
                                                  null
                                                );
                                              }}
                                            >
                                              <b>{row.patientName}</b>
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={1}>
                                            {expandedRowIdclaim2 === row.id ? (
                                              <>
                                                <ExpandLessIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim2(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandLessIcon>
                                              </>
                                            ) : (
                                              <>
                                                <ExpandMoreIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim2(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandMoreIcon>
                                              </>
                                            )}
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            style={{
                                              justifyContent: "space-between",
                                              marginTop: "-8px",
                                              marginBottom: "-2px",
                                            }}
                                          >
                                            {expandedRowIdclaim2 === row.id ? (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "#1976d2",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            ) : (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "#1976d2",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            )}
                                          </Grid>

                                          {/* <Grid item xs={1} >
                                          {expandedRowIdclaim2 === row.id ? (<>

                                            <ExpandLessIcon
                                              onClick={() => handleToggleExpansionclaim2(row.id)}
                                              fontSize='medium'
                                              style={{
                                                color: 'black',
                                                paddingRight: '5px',
                                                paddingBottom: '2px'
                                              }}
                                            >
                                            </ExpandLessIcon>
                                          </>) : (
                                            <>
                                              <ExpandMoreIcon
                                                onClick={() => handleToggleExpansionclaim2(row.id)}
                                                fontSize='medium'
                                                style={{
                                                  color: 'black',
                                                  paddingRight: '5px',
                                                  paddingBottom: '2px'
                                                }}
                                              >
                                              </ExpandMoreIcon>
                                            </>)}

                                        </Grid> */}

                                          <Grid item xs={12}>
                                            {expandedRowIdclaim2 === row.id && (
                                              <Grid
                                                container
                                                style={{ marginTop: "-15px" }}
                                              >
                                                <Grid item xs={7}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Physician Name:</b>
                                                    {row.attendingPhysicianName}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Auth Number:</b>
                                                    {row.authNumber}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                  <Button
                                                    style={{
                                                      backgroundColor:
                                                        "#1976d2",
                                                      color: "white",
                                                      float: "right",
                                                      width: "120px",
                                                      height: "28px",
                                                      marginTop: "5px",
                                                      // marginRight:'25px'
                                                    }}
                                                    size="small"
                                                    onClick={() => {
                                                      setclaimId(row.id);
                                                      setpatinetIdopenclaim(
                                                        row.patientId
                                                      );
                                                      setpatinetnameopencalim(
                                                        row.patientName
                                                      );
                                                      setPatienTdemoGraphiceId(
                                                        row.patientId
                                                      );
                                                      setclaimPracticeID(
                                                        row.practiceId
                                                      );
                                                      handleclaimopen();
                                                    }}
                                                  >
                                                    <Typography
                                                      fontSize="small"
                                                      style={{ color: "#fff" }}
                                                    >
                                                      {" "}
                                                      Open Claim{" "}
                                                    </Typography>
                                                  </Button>
                                                </Grid>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Paper>
                                    );
                                  })
                                : "No Record Found"}
                            </Paper>
                          </Grid>



                             <Grid item xs={12} sm={6} md={3} lg={3}>
                            <Grid container spacing={1}>
                              <Grid item xs={12}>
                                <Typography
                                  style={{
                                    fontWeight: "bold",
                                    color: "black",
                                    whiteSpace: "nowrap",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    // backgroundColor: '#90EE90',
                                    padding: "2px 4px",
                                    borderRadius: "2px",
                                  }}
                                >
                                  Partially Paid Claims{" "}
                                  <span
                                    style={{
                                      color: "#1976d2",
                                      fontWeight: "700",
                                    }}
                                  >
                                    ({PartiallyPaidClaimsCount})
                                  </span>
                                </Typography>
                              </Grid>
                              {/* <Grid item xs={1}>

                            <CachedOutlinedIcon
                              onClick={event => {
                                applyRefreshclaim()
                              }}
                              fontSize='medium'
                              style={{
                                color: '#3C7F6B',
                                //  marginRight: '-25px',
                                paddingRight: '0px',
                                paddingBottom: '1px'
                              }}
                            ></CachedOutlinedIcon>

                          </Grid> */}
                            </Grid>

                            <Paper
                              variant="outlined"
                              square
                              style={{
                                backgroundColor: "#F0F6F8",
                                borderRadius: "15px",
                                marginTop: "3px",
                                borderColor: "#377562",
                                maxWidth: "100%",
                                padding: ".5rem",
                                marginBottom: "0.5rem",
                                marginLeft: "0 .2rem",
                                height: 300,
                                overflow: "auto",
                                /* Other styles */
                                scrollbarWidth: "thin", // For Firefox
                                scrollbarColor: "#1976d2 transparent", // thumb color and track color
                                "&::-webkit-scrollbar": {
                                  width: 8 /* Width of vertical scrollbar */,
                                  height: 8 /* Height of horizontal scrollbar */,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor:
                                    "#1976d2" /* Color of the thumb */,
                                  borderRadius: 10,
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor:
                                    "transparent" /* Color of the track */,
                                },
                                /* Adjust the width for the horizontal scrollbar */
                                "&::-webkit-scrollbar-thumb:horizontal": {
                                  width: 4 /* Width of horizontal scrollbar */,
                                },
                                // zIndex: "10",
                              }}
                            >
                              {PartiallyPaidClaims != null &&
                              PartiallyPaidClaims.length > 0
                                ? PartiallyPaidClaims.map((row, index) => {
                                    return (
                                      <Paper
                                        variant="outlined"
                                        square
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          // marginTop: '3px',
                                          borderColor: "skyblue",
                                          maxWidth: "100%",
                                          padding: ".3rem",
                                          marginBottom: "0.3rem",
                                          marginLeft: "0 .2rem",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                  
                                          <Grid item xs={1.5}>
                                            <Avatar
                                              sx={{
                                                width: 22,
                                                height: 22,
                                                bgcolor: "skyblue",
                                              }}
                                            >
                                              {row.patientName
                                                ?.charAt(0)
                                                .toUpperCase()}
                                            </Avatar>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "14px",
                                              }}
                                              onClick={() => {
                                                handleToggleExpansionclaim2(
                                                  null
                                                );
                                              }}
                                            >
                                              <b>{row.patientName}</b>
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={1}>
                                            {expandedRowIdclaim2 === row.id ? (
                                              <>
                                                <ExpandLessIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim2(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandLessIcon>
                                              </>
                                            ) : (
                                              <>
                                                <ExpandMoreIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim2(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandMoreIcon>
                                              </>
                                            )}
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            style={{
                                              justifyContent: "space-between",
                                              marginTop: "-8px",
                                              marginBottom: "-2px",
                                            }}
                                          >
                                            {expandedRowIdclaim2 === row.id ? (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "skyblue",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            ) : (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "skyblue",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            )}
                                          </Grid>
                                  

                                          <Grid item xs={12}>
                                            {expandedRowIdclaim2 === row.id && (
                                              <Grid
                                                container
                                                style={{ marginTop: "-15px" }}
                                              >
                                                <Grid item xs={7}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Physician Name:</b>
                                                    {row.attendingPhysicianName}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Auth Number:</b>
                                                    {row.authNumber}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                  <Button
                                                    style={{
                                                      backgroundColor:"skyblue",
                                                      color: "white",
                                                      float: "right",
                                                      width: "120px",
                                                      height: "28px",
                                                      marginTop: "5px",
                                                      // marginRight:'25px'
                                                    }}
                                                    size="small"
                                                    onClick={() => {
                                                      setclaimId(row.id);
                                                      setpatinetIdopenclaim(
                                                        row.patientId
                                                      );
                                                      setpatinetnameopencalim(
                                                        row.patientName
                                                      );
                                                      setPatienTdemoGraphiceId(
                                                        row.patientId
                                                      );
                                                      setclaimPracticeID(
                                                        row.practiceId
                                                      );
                                                      handleclaimopen();
                                                    }}
                                                  >
                                                    <Typography
                                                      fontSize="small"
                                                      style={{ color: "#fff" }}
                                                    >
                                                      {" "}
                                                      Open Claim{" "}
                                                    </Typography>
                                                  </Button>
                                                </Grid>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Paper>
                                    );
                                  })
                                : "No Record Found"}
                            </Paper>
                          </Grid>

                            <Grid item xs={12} sm={6} md={3} lg={3}>
                            <Grid container spacing={1}>
                              <Grid item xs={12}>
                                <Typography
                                  style={{
                                    fontWeight: "bold",
                                    color: "black",
                                    whiteSpace: "nowrap",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    // backgroundColor: '#90EE90',
                                    padding: "2px 4px",
                                    borderRadius: "2px",
                                  }}
                                >
                                  Closed Claims By Provider{" "}
                                  <span
                                    style={{
                                       color: "#1976d2",
                                      fontWeight: "700",
                                    }}
                                  >
                                    ({ClosedClaimCount})
                                  </span>
                                </Typography>
                              </Grid>
                             
                            </Grid>

                            <Paper
                              variant="outlined"
                              square
                              style={{
                                backgroundColor: "#F0F6F8",
                                borderRadius: "15px",
                                marginTop: "3px",
                                borderColor: "#377562",
                                maxWidth: "100%",
                                padding: ".5rem",
                                marginBottom: "0.5rem",
                                marginLeft: "0 .2rem",
                                height: 300,
                                overflow: "auto",
                                /* Other styles */
                                scrollbarWidth: "thin", // For Firefox
                                scrollbarColor: "black transparent", // thumb color and track color
                                "&::-webkit-scrollbar": {
                                  width: 8 /* Width of vertical scrollbar */,
                                  height: 8 /* Height of horizontal scrollbar */,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor:
                                    "#1976d2" /* Color of the thumb */,
                                  borderRadius: 10,
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor:
                                    "transparent" /* Color of the track */,
                                },
                                /* Adjust the width for the horizontal scrollbar */
                                "&::-webkit-scrollbar-thumb:horizontal": {
                                  width: 4 /* Width of horizontal scrollbar */,
                                },
                                // zIndex: "10",
                              }}
                            >
                              {closeRows != null &&
                              closeRows.length > 0
                                ? closeRows.map((row, index) => {
                                    return (
                                      <Paper
                                        variant="outlined"
                                        square
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          // marginTop: '3px',
                                          borderColor: "black",
                                          maxWidth: "100%",
                                          padding: ".3rem",
                                          marginBottom: "0.3rem",
                                          marginLeft: "0 .2rem",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                  
                                          <Grid item xs={1.5}>
                                            <Avatar
                                              sx={{
                                                width: 22,
                                                height: 22,
                                                bgcolor: "black",
                                              }}
                                            >
                                              {row.patientName
                                                ?.charAt(0)
                                                .toUpperCase()}
                                            </Avatar>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "14px",
                                              }}
                                              onClick={() => {
                                                handleToggleExpansionclaim2(
                                                  null
                                                );
                                              }}
                                            >
                                              <b>{row.patientName}</b>
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={1}>
                                            {expandedRowIdclaim2 === row.id ? (
                                              <>
                                                <ExpandLessIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim2(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandLessIcon>
                                              </>
                                            ) : (
                                              <>
                                                <ExpandMoreIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim2(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandMoreIcon>
                                              </>
                                            )}
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            style={{
                                              justifyContent: "space-between",
                                              marginTop: "-8px",
                                              marginBottom: "-2px",
                                            }}
                                          >
                                            {expandedRowIdclaim2 === row.id ? (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            ) : (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.CreatedDate
                                                        ? new Date(
                                                            row.CreatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updateddate
                                                        ? new Date(
                                                            row.updateddate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            )}
                                          </Grid>
                                  

                                          <Grid item xs={12}>
                                            {expandedRowIdclaim2 === row.id && (
                                              <Grid
                                                container
                                                style={{ marginTop: "-15px" }}
                                              >
                                                <Grid item xs={7}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Physician Name:</b>
                                                    {row.attendingPhysicianName}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={5}>
                                                  <Typography
                                                    style={{
                                                      color: "black",
                                                      fontSize: "10px",
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <b>Auth Number:</b>
                                                    {row.authNumber}
                                                  </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                  <Button
                                                    style={{
                                                      backgroundColor:"black",
                                                      color: "white",
                                                      float: "right",
                                                      width: "120px",
                                                      height: "28px",
                                                      marginTop: "5px",
                                                      // marginRight:'25px'
                                                    }}
                                                    size="small"
                                                    onClick={() => {
                                                      setclaimId(row.id);
                                                      setpatinetIdopenclaim(
                                                        row.patientId
                                                      );
                                                      setpatinetnameopencalim(
                                                        row.patientName
                                                      );
                                                      setPatienTdemoGraphiceId(
                                                        row.patientId
                                                      );
                                                      setclaimPracticeID(
                                                        row.practiceId
                                                      );
                                                      handleclaimopen();
                                                    }}
                                                  >
                                                    <Typography
                                                      fontSize="small"
                                                      style={{ color: "#fff" }}
                                                    >
                                                      {" "}
                                                      Open Claim{" "}
                                                    </Typography>
                                                  </Button>
                                                </Grid>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Paper>
                                    );
                                  })
                                : "No Record Found"}
                            </Paper>
                          </Grid>

                            {/* Rejected Claims For backOffice */}
                            {rights?.Send_To_Payer_Claims && (
                            <Grid item xs={12} sm={6} md={3} lg={3}>
                            <Grid container spacing={1}>
                              <Grid item xs={12}>
                                <Typography
                                  style={{
                                    fontWeight: "bold",
                                    color: "black",
                                    whiteSpace: "nowrap",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    // backgroundColor: '#90EE90',
                                    padding: "2px 4px",
                                    borderRadius: "2px",
                                  }}
                                >
                                  Rejected/Correctable Claims{" "}
                                  <span
                                    style={{
                                       color: "#1976d2",
                                      fontWeight: "700",
                                    }}
                                  >
                                    ({RejectedClaims?.length || 0})
                                  </span>
                                </Typography>
                              </Grid>
                             
                            </Grid>

                            <Paper
                              variant="outlined"
                              square
                              style={{
                                backgroundColor: "#F0F6F8",
                                borderRadius: "15px",
                                marginTop: "3px",
                                borderColor: "#377562",
                                maxWidth: "100%",
                                padding: ".5rem",
                                marginBottom: "0.5rem",
                                marginLeft: "0 .2rem",
                                height: 300,
                                overflow: "auto",
                                /* Other styles */
                                scrollbarWidth: "thin", // For Firefox
                                scrollbarColor: "#B91C1C transparent", // thumb color and track color
                                "&::-webkit-scrollbar": {
                                  width: 8 /* Width of vertical scrollbar */,
                                  height: 8 /* Height of horizontal scrollbar */,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor:
                                    "#B91C1C" /* Color of the thumb */,
                                  borderRadius: 10,
                                },
                                "&::-webkit-scrollbar-track": {
                                  backgroundColor:
                                    "transparent" /* Color of the track */,
                                },
                                /* Adjust the width for the horizontal scrollbar */
                                "&::-webkit-scrollbar-thumb:horizontal": {
                                  width: 4 /* Width of horizontal scrollbar */,
                                },
                                // zIndex: "10",
                              }}
                            >
                              {RejectedClaims != null &&
                              RejectedClaims.length > 0
                                ? RejectedClaims.map((row, index) => {
                                    return (
                                      <Paper
                                        variant="outlined"
                                        square
                                        style={{
                                          backgroundColor: "white",
                                          borderRadius: "10px",
                                          // marginTop: '3px',
                                          borderColor: "black",
                                          maxWidth: "100%",
                                          padding: ".3rem",
                                          marginBottom: "0.3rem",
                                          marginLeft: "0 .2rem",
                                        }}
                                      >
                                        <Grid container spacing={1}>
                                  
                                          <Grid item xs={1.5}>
                                            <Avatar
                                              sx={{
                                                width: 22,
                                                height: 22,
                                                bgcolor: "#EA580C",
                                              }}
                                            >
                                              {row.patientName
                                                ?.charAt(0)
                                                .toUpperCase()}
                                            </Avatar>
                                          </Grid>
                                          <Grid item xs={9}>
                                            <Typography
                                              style={{
                                                color: "black",
                                                fontSize: "14px",
                                              }}
                                              onClick={() => {
                                                handleToggleExpansionclaim2(
                                                  null
                                                );
                                              }}
                                            >
                                              <b>{row.patientName}</b>
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={1}>
                                            {expandedRowIdclaim2 === row.id ? (
                                              <>
                                                <ExpandLessIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim2(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandLessIcon>
                                              </>
                                            ) : (
                                              <>
                                                <ExpandMoreIcon
                                                  onClick={() =>
                                                    handleToggleExpansionclaim2(
                                                      row.id
                                                    )
                                                  }
                                                  fontSize="medium"
                                                  style={{
                                                    color: "black",
                                                    paddingRight: "5px",
                                                    paddingBottom: "2px",
                                                  }}
                                                ></ExpandMoreIcon>
                                              </>
                                            )}
                                          </Grid>
                                          <Grid
                                            item
                                            xs={12}
                                            style={{
                                              justifyContent: "space-between",
                                              marginTop: "-8px",
                                              marginBottom: "-2px",
                                            }}
                                          >
                                            {expandedRowIdclaim2 === row.id ? (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.createdDate
                                                        ? new Date(
                                                            row.createdDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updatedDate
                                                        ? new Date(
                                                            row.updatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "#EA580C",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            ) : (
                                              <>
                                                <Grid container>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>ID:</b> {row.id}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      <b>Submitted:</b>{" "}
                                                      {row.createdDate
                                                        ? new Date(
                                                            row.createdDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid item xs={6}>
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        marginTop: "1px",
                                                      }}
                                                    >
                                                      <b>DOS:</b>{" "}
                                                      {row.dos
                                                        ? new Date(
                                                            row.dos
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={6}
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      fontSize: "12px",
                                                      marginTop: "1px",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        color: "black",
                                                        fontSize: "12px",
                                                        whiteSpace: "nowrap",
                                                        marginLeft: 8,
                                                      }}
                                                    >
                                                      <b>Worked:</b>{" "}
                                                      {row.updatedDate
                                                        ? new Date(
                                                            row.updatedDate
                                                          ).toLocaleDateString(
                                                            "en-US"
                                                          )
                                                        : ""}
                                                    </Typography>
                                                  </Grid>

                                                  <Grid item xs={12}>
                                                    <Typography
                                                      style={{
                                                        color: "#EA580C",
                                                        fontWeight: "bold",
                                                        fontSize: "13px",
                                                      }}
                                                    >
                                                      {" "}
                                                      <b>
                                                        {row.practiceName}
                                                      </b>{" "}
                                                    </Typography>
                                                  </Grid>
                                                </Grid>
                                              </>
                                            )}
                                          </Grid>
                                  

                                          <Grid item xs={12}>
                                            {expandedRowIdclaim2 === row.id && (
                                              <Grid
                                                container
                                                style={{ marginTop: "-15px" }}
                                              >
                                                <Grid item xs={12}>
                                                  <Button
                                                    style={{
                                                      backgroundColor:"#EA580C",
                                                      color: "white",
                                                      float: "right",
                                                      width: "120px",
                                                      height: "28px",
                                                      marginTop: "5px",
                                                      // marginRight:'25px'
                                                    }}
                                                    size="small"
                                                    onClick={() => {
                                                      setclaimId(row.id);
                                                      setpatinetIdopenclaim(
                                                        row.patientId
                                                      );
                                                      setpatinetnameopencalim(
                                                        row.patientName
                                                      );
                                                      setPatienTdemoGraphiceId(
                                                        row.patientId
                                                      );
                                                      setclaimPracticeID(
                                                        row.practiceId
                                                      );
                                                      setcallingFromRejection(true)
                                                      handleclaimopen();
                                                    }}
                                                  >
                                                    <Typography
                                                      fontSize="small"
                                                      style={{ color: "#fff" }}
                                                    >
                                                      {" "}
                                                      Open Claim{" "}
                                                    </Typography>
                                                  </Button>
                                                </Grid>
                                              </Grid>
                                            )}
                                          </Grid>
                                        </Grid>
                                      </Paper>
                                    );
                                  })
                                : "No Record Found"}
                            </Paper>
                          </Grid>
                            )}





                        </Grid>
                      </>
                    )}
                  </Grid>
                </Container>
              </>
            )}
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                {/* Render your modal component */}
                {isModalOpen && (
                  <Modal
                    open={isModalOpen}
                    onClose={closeModopen}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
      sx={{
        ...style,
        width: '100%', // Full width for responsiveness
        maxWidth: { xs: '100%', sm: '90vw', md: '80vw', lg: '70vw' }, // Responsive max-width
        margin: '0 auto', // Center the box
        height: { xs: 'auto', sm: '80vh', md: '70vh' }, // Adjust height based on screen size
        overflow: 'auto', // Allow scrolling for overflow content
        boxSizing: 'border-box',
      }}
    >
      <Headroom>
        <Grid
          container
          sx={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            padding: { xs: '0.5rem', sm: '1rem' }, // Responsive padding
          }}
        >
          <Grid item xs={12}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flexWrap: 'wrap', // Allow wrapping on small screens
                padding: { xs: '0.5rem', sm: '1rem' },
              }}
            >
              <DialogTitle
                sx={{
                  flex: 1,
                  textAlign: 'center',
                  padding: { xs: '0.5rem', sm: '1rem' }, // Responsive padding
                }}
              >
                <Typography
                  variant="h6"
                  id="modal-title"
                  sx={{
                    textAlign: 'center',
                    fontWeight: 600,
                    fontSize: { xs: '1rem', sm: '1.25rem', md: '1.5rem' }, // Responsive font size
                  }}
                >
                  {selectedLabel}
                </Typography>
              </DialogTitle>
              <CancelOutlinedIcon
                onClick={closeModopen}
                sx={{
                  fontSize: { xs: '1.5rem', sm: '2rem' }, // Responsive icon size
                  color: 'red',
                  paddingRight: { xs: '0.5rem', sm: '1rem' },
                  cursor: 'pointer',
                }}
              />
            </div>
          </Grid>
        </Grid>
      </Headroom>

      {isLoading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            padding: { xs: '2rem', sm: '3rem', md: '5rem' }, // Responsive padding
          }}
        >
          <CircularProgress size={{ xs: 30, sm: 40, md: 50 }} /> {/* Responsive spinner size */}
        </Box>
      ) : (
        <Box
          sx={{
            height: { xs: 'auto', sm: 400, md: 420 }, // Responsive height
            padding: { xs: '0.5rem', sm: '1rem' }, // Responsive padding
            overflowX: 'auto', // Horizontal scroll for DataGrid on small screens
          }}
        >
          {selectedLabel === `Patient Info (${patientInfo})` &&
            raws !== null &&
            raws.length > 0 && (
              <DataGrid
                rows={raws}
                rowHeight={28}
                columns={calumns}
                getRowId={(row) => row.id}
                classes={gridClasses}
                sx={{
                  ...gridRowStyle,
                  '& .MuiDataGrid-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }, // Responsive font size
                  },
                  '& .MuiDataGrid-columnHeader': {
                    minWidth: { xs: 100, sm: 150 }, // Ensure columns don't collapse too much
                  },
                }}
                pagination
                autoPageSize
              />
            )}
          {selectedLabel === `Completed(${approved1})` &&
            raws2 !== null &&
            raws2.length > 0 && (
              <DataGrid
                rows={raws2}
                rowHeight={28}
                columns={calumns2}
                getRowId={(row) => row.AuthId}
                classes={gridClasses}
                pagination
                autoPageSize
                sx={{
                  ...gridRowStyle,
                  '& .MuiDataGrid-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  },
                  '& .MuiDataGrid-columnHeader': {
                    minWidth: { xs: 100, sm: 150 },
                  },
                }}
              />
            )}


           {selectedLabel === `Archived (${archivedApprovedCount})` &&
  archivedRows !== null &&
  archivedRows.length > 0 && (
    <DataGrid
      rows={archivedRows}
      columns={calumns9}
      getRowId={(row) => row.AuthId}
      pagination
      sx={gridRowStyle}
      pageSizeOptions={[50]}
      rowHeight={30}
      initialState={{
        pagination: { paginationModel: { pageSize: 100, page: 0 } },
      }}
    />
  )}


          {selectedLabel === `Un-Approved (${UNapprovedRecord})` &&
            raws9 !== null &&
            raws9.length > 0 && (
              <DataGrid
                rows={raws9}
                columns={calumns9}
                getRowId={(row) => row.AuthId}
                pagination
                sx={{
                  ...gridRowStyle,
                  '& .MuiDataGrid-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  },
                  '& .MuiDataGrid-columnHeader': {
                    minWidth: { xs: 100, sm: 150 },
                  },
                }}
                pageSizeOptions={[50]}
                rowHeight={30}
                initialState={{
                  pagination: { paginationModel: { pageSize: 100, page: 0 } },
                }}
              />
            )}
             {selectedLabel === `Completed Forms (${CompletedForms})` &&
            raws10 !== null &&
            raws10.length > 0 && (
              <DataGrid
                rows={raws10}
                columns={calumns10}
                getRowId={(row) => row.formId}
                pagination
                sx={{
                  ...gridRowStyle,
                  '& .MuiDataGrid-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  },
                  '& .MuiDataGrid-columnHeader': {
                    minWidth: { xs: 100, sm: 150 },
                  },
                }}
                pageSizeOptions={[50]}
                rowHeight={30}
                initialState={{
                  pagination: { paginationModel: { pageSize: 100, page: 0 } },
                }}
              />
            )}
          {selectedLabel === `Progress Notes (${progressNotes})` &&
            raws1 !== null &&
            raws1.length > 0 && (
              <DataGrid
                rows={raws1}
                rowHeight={28}
                columns={calumns1}
                getRowId={(row) => row.patientId}
                classes={gridClasses}
                pagination
                autoPageSize
                sx={{
                  ...gridRowStyle,
                  '& .MuiDataGrid-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  },
                  '& .MuiDataGrid-columnHeader': {
                    minWidth: { xs: 100, sm: 150 },
                  },
                }}
              />
            )}
          {selectedLabel === `Letter Of Medical Necessity 123(${letterOfMedicalNecessity})` &&
            raws4 !== null &&
            raws4.length > 0 && (
              <DataGrid
                rows={raws4}
                rowHeight={28}
                columns={calumns4}
                getRowId={(row) => row.id}
                classes={gridClasses}
                pagination
                autoPageSize
                sx={{
                  ...gridRowStyle,
                  '& .MuiDataGrid-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  },
                  '& .MuiDataGrid-columnHeader': {
                    minWidth: { xs: 100, sm: 150 },
                  },
                }}
              />
            )}
          {selectedLabel === `Submitted to LuxBilling (${authRequest1})` &&
            raws5 !== null &&
            raws5.length > 0 && (
              <DataGrid
                rows={raws5}
                columns={calumns5}
                getRowId={(row) => row.id}
                pagination
                sx={{
                  ...gridRowStyle,
                  '& .MuiDataGrid-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  },
                  '& .MuiDataGrid-columnHeader': {
                    minWidth: { xs: 100, sm: 150 },
                  },
                }}
                pageSizeOptions={[50]}
                rowHeight={30}
                initialState={{
                  pagination: { paginationModel: { pageSize: 100, page: 0 } },
                }}
              />
            )}
          {selectedLabel === `Questionnaire (${questionnaire})` &&
            raws3 !== null &&
            raws3.length > 0 && (
              <DataGrid
                rows={raws3}
                rowHeight={28}
                columns={calumns3}
                getRowId={(row) => row.id}
                classes={gridClasses}
                pagination
                autoPageSize
                sx={{
                  ...gridRowStyle,
                  '& .MuiDataGrid-root': {
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                  },
                  '& .MuiDataGrid-columnHeader': {
                    minWidth: { xs: 100, sm: 150 },
                  },
                }}
              />
            )}
        </Box>
      )}
    </Box>
                  </Modal>
                )}

                {/* ////////// */}

             {isModalOpen1 && (
              <Modal
                open={isModalOpen1}
                onClose={closeModopen1}
                aria-labelledby="claims-modal-title"
                aria-describedby="claims-modal-description"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    p: 2,
                    borderRadius: 2,
                  }}
                >
                  {/* 🔹 Header */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          position: "relative",
                          mb: 1.5,
                          borderBottom: "1px solid #ddd",
                          pb: 1,
                        }}
                      >
                        {/* 🔹 Title (Centered) */}
                        <h3
                          id="claims-modal-title"
                          style={{
                            margin: 0,
                            textAlign: "center",
                            fontWeight: 600,
                            fontSize: "1.6rem",
                          }}
                        >
                          {selectedLabel1}
                        </h3>

                        {/* 🔹 Close Button (Red ClearIcon) */}
                        <IconButton
                          onClick={closeModopen1}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "red",
                            "&:hover": { backgroundColor: "rgba(255,0,0,0.1)" },
                          }}
                        >
                          <CancelOutlinedIcon />
                        </IconButton>
                      </Box>

                  {/* 🔹 Table Area */}
                  <div style={{ height: 420, padding: "0.1rem" }}>
                    {DashboardClaimRows && DashboardClaimRows.length > 0 ? (
                      <DataGrid
                        rows={DashboardClaimRows}
                        columns={ClaimDashboradCoulmns}
                        getRowId={(row) => row.id}
                        pagination
                        autoPageSize
                        classes={gridClasses}
                        sx={gridRowStyle}
                        rowHeight={28}
                      />
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          color: "gray",
                          fontStyle: "italic",
                        }}
                      >
                        No data found for this category.
                      </Box>
                    )}
                  </div>
                </Box>
              </Modal>
            )}

              </Grid>
            </Grid>
          </div>
        </div>
      )}

      {/* <Container fluid={true}>
          <Grid
            container
          >
            <Grid item xs={1}>
            <Checkbox
            value={isChecked}
            onChange={e => {
              setIsChecked(e.target.checked)
              console.log('Test', e.target.checked)
          }}
            />
            </Grid>
            <Grid item xs={9} style={{ fontWeight: 500, marginTop:'10px', marginLeft:'-40px'}}>
              <Typography fontSize='15px'>All</Typography>
            </Grid>
            <Grid item xs={4} style={{ fontWeight: 500 }}>
              <Typography fontSize='15px'>Date From</Typography>
            </Grid>
            <Grid item xs={4} style={{ fontWeight: 500 }}>
              <Typography fontSize='15px'>Date To</Typography>
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={4}>
              <Controller
                name='fromDate'
                // {...register('fromDate')}
                control={control}
                render={({ field }) => (
                  <TextField
                    // isClearable
                    size='small'
                    type='date'
                    disabled={isChecked == true?(true):(false)}
                    {...field}
                    fullWidth
                    value={fromDate}
                    // error={errors.fromDate}
                    onChange={e => {
                      setValue('fromDate', e.target.value)
                      setfromDate(e.target.value)

                    }}
                  />
                )}
              />

            </Grid>
            <Grid xs ={0.1}></Grid>
            <Grid item xs={4}>
              <Controller
                name='toDate'
                // {...register('toDate')}
                
                control={control}
                render={({ field }) => (
                  <TextField
                    type='date'
                    // isClearable
                    size='small'
                    {...field}
                    fullWidth
                    disabled={isChecked == true?(true):(false)}
                    value={toDate}
                    // onChange={e => settoDate(e.target.value)}
                    onChange={e => {
                      setValue('toDate', e.target.value)
                      settoDate(e.target.value)

                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                onClick={onFilterSearch}
                variant='contained'
                color='primary'
                style={{
                  float: 'right',
                  width: '150px',
                  height: '35px',

                  fontSize: '14px'
                }}
              >
                <SearchOutlinedIcon
                  fontSize='medium'
                  style={{ color: 'white', paddingBottom: '1px' }}
                ></SearchOutlinedIcon>
                Search
              </Button>
            </Grid>
            <Grid item xs={1}></Grid>
          </Grid>
           </Container> */}
    </React.Fragment>
  );
}
export default Dashboard;
